{
  "% к прошлой неделе": "% geçen haftaya göre",
  ". STEOS ID и финансовые квитанции сохраняются.": ". STEOS ID ve finansal makbuzlar saklanır.",
  ". Готовые голоса доступны в разделе «Озвучка» → «Мои».": ". Hazır sesler «Seslendirme» → «Benimkiler» bölümünde kullanılabilir.",
  ". Он не меняет голос озвучки чата.": ". Sohbetin seslendirme sesini değiştirmez.",
  ". После подтверждения обновите профиль.": ". Onayladıktan sonra profili güncelleyin.",
  ". Проверьте папку «Спам».": ". Spam klasörünü kontrol edin.",
  "Circle каждый месяц по подписке": "Her ay abonelikle Circle",
  "Circle по подписке на этот месяц потрачены": "Bu ayın abonelik Circle’ları bitti",
  "STEOS ID · {0}": "STE​​OS ID · {0}",
  "STEOS ID · Не подключён": "STEOS ID · Bağlı değil",
  "Telegram ID скопирован.": "Telegram ID kopyalandı.",
  "{0} {1} C сгорят {2}": "{0} {1} C {2} tarihinde sona erecek",
  "{0} из {1}": "{0}/{1}",
  "{0} фото хватит для сходства": "{0} fotoğraf benzerlik için yeterli",
  "{0}: {1} работ": "{0}: {1} çalışma",
  "{0}: пока недоступно": "{0}: henüz kullanılamıyor",
  "· Вы и варианты": "· Siz ve varyantlar",
  "· Новое": "· Yeni",
  "· занято": "· meşgul",
  "· отменена": "· iptal edildi",
  "». Обучение начнётся после отдельного нажатия «Повторить обработку» в карточке.": "». Eğitim, karttaki «İşlemi yeniden başlat» seçeneğine ayrıca basıldıktan sonra başlayacak.",
  "Автовоспроизведение примеров": "Örnekleri otomatik oynat",
  "Аккаунт": "Hesap",
  "Аккаунт подключён": "Hesap bağlandı",
  "Архив недоступен или срок ссылки истёк. Можно запросить новую выгрузку.": "Arşiv kullanılamıyor veya bağlantının süresi doldu. Yeni bir dışa aktarma isteyebilirsiniz.",
  "Бабушка": "Büyükanne",
  "Баланс и вывод доступны в STEOS ID.": "Bakiye ve para çekme işlemleri STEOS ID'de kullanılabilir.",
  "Баланс и награды": "Bakiye ve ödüller",
  "Без имени": "İsimsiz",
  "Бесплатный план": "Ücretsiz plan",
  "Ближайшие": "En yakın",
  "Близкие": "Sevdikleriniz",
  "Близкий исчезнет из профиля. Его фото больше не будут доступны для новых работ.": "Yakınınız profilden kaldırılacak. Fotoğrafları artık yeni çalışmalar için kullanılamayacak.",
  "Близкий удалён.": "Yakın silindi.",
  "Близких пока нет.": "Henüz yakınınız yok.",
  "Брат": "Erkek kardeş",
  "В Steos с": "Steos'a katılım tarihi",
  "В избранное": "Favorilere ekle",
  "Валюта": "Para birimi",
  "Вариант будет удалён. Исходные фото и STEOS ID сохранятся.": "Varyant silinecek. Orijinal fotoğraflar ve STEOS ID korunacak.",
  "Вариантов: {0}": "Varyant sayısı: {0}",
  "Варианты": "Varyantlar",
  "Ваш собственный голос": "Kendi sesiniz",
  "Введите УДАЛИТЬ": "УДАЛИТЬ yazın",
  "Введите пароль": "Şifreyi girin",
  "Введите почту": "E-posta adresini girin",
  "Вернуться ко входу": "Girişe dön",
  "Версия": "Sürüm",
  "Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.": "Onay metni sürümü değişti. Sayfayı yenileyin ve güncel metni onaylayın.",
  "Версия согласия изменилась. Обновите страницу.": "Onay metni sürümü değişti. Sayfayı yenileyin.",
  "Версия:": "Sürüm:",
  "Взрослый": "Yetişkin",
  "Включаем микрофон…": "Mikrofon açılıyor…",
  "Включено": "Açık",
  "Возраст": "Yaş",
  "Войти": "Giriş yap",
  "Восстановить пароль": "Şifreyi kurtar",
  "Все Circle на балансе без срока": "Circle’larınızın süresi dolmaz",
  "Вы": "Siz",
  "Вы и близкие": "Siz ve yakınlarınız",
  "Вы и варианты": "Siz ve görünümleriniz",
  "Выберите голос": "Bir ses seçin",
  "Выберите инструмент и заполните его форму. Готовая работа сохранится в истории.": "Bir araç seçin ve formunu doldurun. Tamamlanan çalışma geçmişe kaydedilir.",
  "Выбран": "Seçildi",
  "Выбрать голос": "Ses seç",
  "Выбрать голос по умолчанию": "Varsayılan sesi seç",
  "Выбрать из работ": "Çalışmalardan seç",
  "Выгрузить мои данные": "Verilerimi dışa aktar",
  "Выгрузка:": "Dışa aktarma:",
  "Выключено": "Kapalı",
  "Голос": "Ses",
  "Голос готов. Он доступен на вкладке «Мои» в озвучке.": "Ses hazır. Seslendirme bölümündeki «Benimkiler» sekmesinde kullanılabilir.",
  "Голос и клон": "Ses ve klon",
  "Голос изменился. Данные обновлены — проверьте их перед сохранением.": "Ses değişti. Veriler güncellendi; kaydetmeden önce kontrol edin.",
  "Голос изменился. Проверьте обновлённые данные перед повторной обработкой.": "Ses değişti. İşlemi yeniden başlatmadan önce güncellenen verileri kontrol edin.",
  "Голос исчезнет из вашего списка. Это действие нельзя отменить.": "Ses listenizden kaldırılacak. Bu işlem geri alınamaz.",
  "Голос по умолчанию для создания:": "Oluşturma için varsayılan ses:",
  "Голос принят в обработку. Здесь появится его статус.": "Ses işleme alındı. Durumu burada görüntülenecek.",
  "Голос уже удалён или недоступен.": "Ses zaten silinmiş veya kullanılamıyor.",
  "Голос:": "Ses:",
  "Голоса не найдены. Откройте каталог или измените поиск.": "Ses bulunamadı. Kataloğu açın veya aramayı değiştirin.",
  "Горизонтальное": "Yatay",
  "Готов": "Hazır",
  "Готовим образцы": "Örnekler hazırlanıyor",
  "Готово": "Tamamlandı",
  "Готовые работы": "Hazır işler",
  "Далее": "İleri",
  "Данные Telegram обновлены.": "Telegram verileri güncellendi.",
  "Данные баланса временно недоступны": "Bakiye verileri geçici olarak kullanılamıyor",
  "Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.": "Veriler onaylanmış hesaba aktarılıyor. Eski oturumlar kapatıldı; makbuz, yeniden yüklemeden sonra doğrulamaya devam etmenizi sağlar.",
  "Дедушка": "Büyükbaba",
  "До 5 фото: лицо крупно, при хорошем свете": "En fazla 5 fotoğraf: yüz yakın planda ve iyi ışıkta",
  "До пяти фото. Они будут использоваться как ваш образ.": "En fazla beş fotoğraf. Bunlar görünümünüz olarak kullanılacak.",
  "Добавить близкого": "Yakın ekle",
  "Добавить фото": "Fotoğraf ekle",
  "Добавьте ещё": "Daha fazla ekleyin",
  "Добавьте от 2 секунд до 1,5 минуты вашей речи. Говорите естественно, без музыки и других голосов.": "2 saniye ile 1,5 dakika arasında konuşma kaydı ekleyin. Müzik veya başka sesler olmadan doğal konuşun.",
  "Дочь": "Kız evlat",
  "Друг": "Arkadaş",
  "Если аккаунт существует, ссылка для нового пароля отправлена на": "Hesap mevcutsa yeni şifre bağlantısı şu adrese gönderildi:",
  "Ещё варианты": "Daha fazla varyant",
  "Ещё операции": "Daha fazla işlem",
  "Ещё работы": "Daha fazla çalışma",
  "Жена": "Eş",
  "ЗАМЕНА ОБРАЗЦОВ": "ÖRNEKLERİ DEĞİŞTİR",
  "Забыли пароль?": "Şifrenizi mi unuttunuz?",
  "Загружаем аккаунт…": "Hesap yükleniyor…",
  "Загружаем варианты…": "Varyantlar yükleniyor…",
  "Загружаем ваши голоса…": "Sesleriniz yükleniyor…",
  "Загружаем голоса…": "Sesler yükleniyor…",
  "Загружаем настройки…": "Ayarlar yükleniyor…",
  "Загружаем обновления…": "Güncellemeler yükleniyor…",
  "Загружаем операции…": "İşlemler yükleniyor…",
  "Загружаем пример…": "Örnek yükleniyor…",
  "Загружаем работы…": "Çalışmalar yükleniyor…",
  "Загружаем фото…": "Fotoğraflar yükleniyor…",
  "Загрузить аудиофайлы": "Ses dosyalarını yükle",
  "Загрузить выбранные фото": "Seçilen fotoğrafları yükle",
  "Загрузка ещё не подтверждена. Нажмите «Продолжить отправку»: сначала проверим прежнюю загрузку.": "Yükleme henüz onaylanmadı. «Göndermeye devam et» seçeneğine basın: önce önceki yüklemeyi kontrol edeceğiz.",
  "Загрузка не подтверждена. Продолжение сначала проверит прежние загрузки.": "Yükleme onaylanmadı. Devam etmeden önce önceki yüklemeler kontrol edilecek.",
  "Загрузка отклонена. Нажмите «Продолжить отправку», чтобы получить новую ссылку и загрузить образец.": "Yükleme reddedildi. Yeni bir bağlantı almak ve örneği yüklemek için «Göndermeye devam et» seçeneğine basın.",
  "Закрыть": "Kapat",
  "Закрыть мастер": "Sihirbazı kapat",
  "Заменить образцы": "Örnekleri değiştir",
  "Записать с микрофона": "Mikrofondan kaydet",
  "Запись": "Kayıt",
  "Запись здесь недоступна. Откройте приложение по HTTPS или загрузите аудиофайл.": "Burada kayıt yapılamıyor. Uygulamayı HTTPS üzerinden açın veya bir ses dosyası yükleyin.",
  "Запись прервалась. Попробуйте ещё раз или загрузите файл.": "Kayıt kesildi. Tekrar deneyin veya bir dosya yükleyin.",
  "Запись-{0}.{1}": "Kayıt-{0}.{1}",
  "Запишите образец, дождитесь обучения и озвучивайте текст своим голосом.": "Bir örnek kaydedin, eğitimin tamamlanmasını bekleyin ve metinleri kendi sesinizle seslendirin.",
  "Запишите речь или загрузите аудиофайлы": "Konuşma kaydedin veya ses dosyaları yükleyin",
  "Запишите свой голос один раз — используйте его в озвучке.": "Sesinizi bir kez kaydedin, seslendirmede kullanın.",
  "Запрос сохранён. Продолжение проверит прежний запрос и не создаст второй голос.": "İstek kaydedildi. Devam edildiğinde önceki istek kontrol edilecek ve ikinci bir ses oluşturulmayacak.",
  "Запустить обработку": "İşlemi başlat",
  "Здесь появятся ваши работы": "Çalışmalarınız burada görünecek",
  "Из них": "Bunlardan",
  "Из них {0} C можно вывести": "Bunlardan {0} C çekilebilir",
  "Избранное": "Favoriler",
  "Избранные работы": "Favori çalışmalar",
  "Изменение не подтверждено. Проверьте актуальную карточку перед повтором.": "Değişiklik onaylanmadı. Yeniden denemeden önce güncel kartı kontrol edin.",
  "Изменить": "Düzenle",
  "Изменить близкого": "Yakını düzenle",
  "Изменить вариант": "Varyantı düzenle",
  "Изменить голос": "Sesi değiştir",
  "Изменить мои фото": "Fotoğraflarımı değiştir",
  "Имя близкого": "Yakının adı",
  "Имя голоса": "Ses adı",
  "Имя пользователя не задано": "Kullanıcı adı belirlenmedi",
  "Использовать как себя": "Kendim olarak kullan",
  "Используем сохранённые образцы голоса «": "Kaydedilmiş «",
  "Используйте свои фото и фото близких в инструментах студии.": "Stüdyo araçlarında kendi fotoğraflarınızı ve yakınlarınızın fotoğraflarını kullanın.",
  "История очищена: {0} работ, {1} заказов.": "Geçmiş temizlendi: {0} çalışma, {1} sipariş.",
  "КЛОН ГОЛОСА": "SES KLONU",
  "Каждый образец должен содержать хотя бы одну секунду речи.": "Her örnek en az bir saniyelik konuşma içermelidir.",
  "Как в системе": "Sistemdeki gibi",
  "Как пользоваться": "Nasıl kullanılır",
  "Как снимать": "Nasıl fotoğraf çekilir",
  "Каталог голосов": "Ses kataloğu",
  "Квадрат": "Kare",
  "Кем приходится": "Yakınlık derecesi",
  "Ко входу": "Girişe",
  "Количество вариантов пока недоступно": "Varyant sayısı henüz kullanılamıyor",
  "Конфиденциальность": "Gizlilik",
  "Копирование недоступно. ID показан в карточке аккаунта.": "Kopyalama kullanılamıyor. ID, hesap kartında gösteriliyor.",
  "Кружок с героем": "Karakterli görüntülü mesaj",
  "Лимит {0} голосов выбран": "{0} ses sınırına ulaşıldı",
  "Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.": "Ses sınırına ulaşıldı. Yeni bir ses eklemek için kullanmadığınız bir sesi silin.",
  "Лимит:": "Sınır:",
  "Мама": "Anne",
  "Можно добавить до {0} образцов.": "{0} adede kadar örnek ekleyebilirsiniz.",
  "Можно закрыть приложение. Статус обновится после обработки.": "Uygulamayı kapatabilirsiniz. Durum, işlem tamamlandıktan sonra güncellenecek.",
  "Мои варианты": "Varyantlarım",
  "Мои голоса": "Seslerim",
  "Мои данные": "Verilerim",
  "Мои фото": "Fotoğraflarım",
  "Моё": "Benimki",
  "Моё фото": "Fotoğrafım",
  "Муж": "Koca",
  "НОВЫЙ ГОЛОС": "YENİ SES",
  "Награды": "Ödüller",
  "Награды и задания": "Ödüller ve görevler",
  "Назад": "Geri",
  "Название варианта": "Varyant adı",
  "Назначить голос": "Ses ata",
  "Настройки": "Ayarlar",
  "Настройки уже изменились. Показана актуальная версия.": "Ayarlar zaten değişti. Güncel sürüm gösteriliyor.",
  "Начните с 2 секунд речи в тихом месте.": "Sessiz bir yerde 2 saniyelik konuşmayla başlayın.",
  "Не больше 5 фото JPEG или PNG, до 10 МБ каждое.": "En fazla 5 JPEG veya PNG fotoğrafı, her biri en fazla 10 MB.",
  "Не задано": "Belirtilmedi",
  "Не короче 8 знаков": "En az 8 karakter",
  "Не удалось включить микрофон. Разрешите доступ или загрузите файл.": "Mikrofon açılamadı. Erişim izni verin veya bir dosya yükleyin.",
  "Не удалось войти. Откройте приложение из Telegram заново.": "Giriş yapılamadı. Uygulamayı Telegram üzerinden yeniden açın.",
  "Не удалось воспроизвести пример. Откройте карточку заново и попробуйте ещё раз.": "Örnek oynatılamadı. Kartı yeniden açıp tekrar deneyin.",
  "Не удалось загрузить варианты.": "Varyantlar yüklenemedi.",
  "Не удалось загрузить голоса. Измените поиск или вкладку, чтобы повторить.": "Sesler yüklenemedi. Yeniden denemek için aramayı veya sekmeyi değiştirin.",
  "Не удалось загрузить настройки. Попробуйте обновить.": "Ayarlar yüklenemedi. Yenilemeyi deneyin.",
  "Не удалось загрузить работы.": "Çalışmalar yüklenemedi.",
  "Не удалось загрузить следующую страницу.": "Sonraki sayfa yüklenemedi.",
  "Не удалось загрузить следующую страницу. Попробуйте ещё раз.": "Sonraki sayfa yüklenemedi. Tekrar deneyin.",
  "Не удалось обновить данные из Telegram. Попробуйте позже.": "Telegram verileri güncellenemedi. Daha sonra tekrar deneyin.",
  "Не удалось подтвердить изменение избранного. Обновите профиль.": "Favori değişikliği onaylanamadı. Profili yenileyin.",
  "Не удалось подтвердить операцию. Проверьте состояние аккаунта перед повтором.": "İşlem onaylanamadı. Yeniden denemeden önce hesap durumunu kontrol edin.",
  "Не удалось подтвердить сохранение. Обновите настройки перед повтором.": "Kayıt onaylanamadı. Yeniden denemeden önce ayarları yenileyin.",
  "Не удалось подтвердить удаление близкого. Обновите профиль.": "Yakının silinmesi onaylanamadı. Profili yenileyin.",
  "Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.": "Yanıt alınamadı. Tekrar deneyin; istek aynı anahtarla devam edecek.",
  "Не удалось проверить выгрузку. Обновите страницу: продолжим прежнюю операцию.": "Dışa aktarma doğrulanamadı. Sayfayı yenileyin; önceki işlem sürdürülecek.",
  "Не удалось прочитать запись.": "Kayıt okunamadı.",
  "Не удалось создать голос. Откройте карточку, чтобы проверить статус или повторить обработку.": "Ses oluşturulamadı. Durumu kontrol etmek veya işlemi yeniden başlatmak için kartı açın.",
  "Не удалось создать голос. Проверьте данные и образцы.": "Ses oluşturulamadı. Verileri ve örnekleri kontrol edin.",
  "Не удалось сохранить просмотр. Можно закрыть и вернуться позже.": "Görüntüleme kaydedilemedi. Kapatıp daha sonra geri dönebilirsiniz.",
  "Неверная почта или пароль": "Geçersiz e-posta veya şifre",
  "Нет работ": "Çalışma yok",
  "Новая выгрузка": "Yeni dışa aktarma",
  "Новости": "Haberler",
  "Новый вариант": "Yeni varyant",
  "Новый голос": "Yeni ses",
  "Новых публикаций пока нет.": "Henüz yeni paylaşım yok.",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме.": "Toplam 2 saniye ile 1,5 dakika arasında konuşma gerekir.",
  "О приложении": "Uygulama hakkında",
  "Обновить": "Yenile",
  "Обновить варианты": "Varyantları yenile",
  "Обновить из Telegram": "Telegram'dan güncelle",
  "Обновить настройки": "Ayarları güncelle",
  "Обновить профиль": "Profili güncelle",
  "Обновить работы": "Çalışmaları güncelle",
  "Обновления": "Güncellemeler",
  "Обновляем вход…": "Giriş güncelleniyor…",
  "Обрабатывается": "İşleniyor",
  "Образ готов": "Görünüm hazır",
  "Образ ещё не собран": "Görünüm henüz oluşturulmadı",
  "Образец {0}": "Örnek {0}",
  "Образец голоса": "Ses örneği",
  "Образец ещё не проверен. Подождите и продолжите отправку.": "Örnek henüz kontrol edilmedi. Bekleyin ve göndermeye devam edin.",
  "Образец не прошёл проверку. Выберите другую запись.": "Örnek kontrolden geçemedi. Başka bir kayıt seçin.",
  "Образцы готовы к повторной обработке.": "Örnekler yeniden işlenmeye hazır.",
  "Образцы для «": "« için örnekler",
  "Образцы обновлены. Нажмите «Повторить обработку», чтобы обучить голос заново.": "Örnekler güncellendi. Sesi yeniden eğitmek için «İşlemi yeniden başlat» seçeneğine basın.",
  "Обучаем голос": "Ses eğitiliyor",
  "Общая длительность образцов не должна превышать 1,5 минуты.": "Örneklerin toplam süresi 1,5 dakikayı aşmamalıdır.",
  "Объединение STEOS ID": "STE​​OS ID birleştirme",
  "Объединяем аккаунты": "Hesaplar birleştiriliyor",
  "Объём образцов": "Örneklerin toplam süresi",
  "Один аккаунт для бота и сайта STEOS": "STEOS botu ve sitesi için tek hesap",
  "Озвучить текст голосом «": "« sesiyle metni seslendir",
  "Операции": "İşlemler",
  "Операции в токенах STEOS ID": "STEOS ID token işlemleri",
  "Операции временно недоступны.": "İşlemler geçici olarak kullanılamıyor.",
  "Операций пока нет.": "Henüz işlem yok.",
  "Операция не подтверждена. Повтор использует прежний ключ.": "İşlem onaylanmadı. Yeniden deneme aynı anahtarı kullanır.",
  "Описание": "Açıklama",
  "Описание и согласие": "Açıklama ve onay",
  "Остановить запись ·": "Kaydı durdur ·",
  "Остаток Circle недоступен": "Circle bakiyesi kullanılamıyor",
  "Отклик": "Dokunsal geri bildirim",
  "Откройте ссылку из письма и задайте новый пароль на id.steos.io. Потом войдите здесь.": "E-postadaki bağlantıyı açın ve id.steos.io adresinde yeni bir şifre belirleyin. Ardından buradan giriş yapın.",
  "Откройте ссылку подтверждения для": "Şu adres için onay bağlantısını açın:",
  "Открыть id.steos.io": "id.steos.io adresini aç",
  "Открыть историю": "Geçmişi aç",
  "Отмена": "İptal",
  "Отметьте согласие с условиями": "Koşulları kabul ettiğinizi işaretleyin",
  "Отправить ссылку": "Bağlantı gönder",
  "Отправляем…": "Gönderiliyor…",
  "Оформить подписку": "Abone ol",
  "Оформление": "Görünüm",
  "Очистить историю": "Geçmişi temizle",
  "Очистить историю?": "Geçmiş temizlensin mi?",
  "Очистка не подтверждена. Повтор проверит прежнюю операцию.": "Temizleme onaylanmadı. Yeniden deneme önceki işlemi kontrol edecek.",
  "Очищаем…": "Temizleniyor…",
  "Ошибка": "Hata",
  "Папа": "Baba",
  "Пароль": "Şifre",
  "Переименовать вариант": "Varyantı yeniden adlandır",
  "Перенос ещё не подтверждён. Квитанция сохранена; проверка продолжится.": "Aktarım henüz onaylanmadı. Makbuz kaydedildi; doğrulama devam edecek.",
  "Перенос завершён, обновляем вход…": "Aktarım tamamlandı, giriş güncelleniyor…",
  "Переносим данные в существующий STEOS ID. После переноса приложение обновит сессию. Не запускайте повторное объединение.": "Veriler mevcut STEOS ID'ye aktarılıyor. Aktarımın ardından uygulama oturumu güncelleyecek. Birleştirme işlemini yeniden başlatmayın.",
  "Письмо отправлено": "E-posta gönderildi",
  "Питомец": "Evcil hayvan",
  "Повторить загрузку": "Yüklemeyi yeniden dene",
  "Повторить обработку": "İşlemi yeniden başlat",
  "Подготовить ZIP для скачивания": "İndirmek için ZIP hazırla",
  "Поддержка": "Destek",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже или откройте сайт STEOS ID.": "STEOS ID bağlantısı şu anda kullanılamıyor. Daha sonra tekrar deneyin veya STEOS ID sitesini açın.",
  "Подключён": "Bağlı",
  "Подключён:": "Bağlı:",
  "Подруга": "Kız arkadaş",
  "Подтвердите почту": "E-postanızı doğrulayın",
  "Подтвердите согласие перед отправкой образцов.": "Örnekleri göndermeden önce onayınızı verin.",
  "Подтвердить очистку истории": "Geçmişi temizlemeyi onayla",
  "Подтвердить удаление": "Silmeyi onayla",
  "Подтвердить удаление аккаунта": "Hesabın silinmesini onayla",
  "Подтвердить удаление близкого": "Yakının silinmesini onayla",
  "Подтвердить удаление варианта": "Varyantın silinmesini onayla",
  "Поиск голоса": "Ses ara",
  "Поиск по имени": "İsme göre ara",
  "Пока нет своих голосов": "Henüz kendi sesiniz yok",
  "Показать ещё": "Daha fazla göster",
  "Показать ещё голоса": "Daha fazla ses göster",
  "Показать пароль": "Şifreyi göster",
  "Пополнить": "Bakiye yükle",
  "Попробовать": "Dene",
  "Портрет": "Portre",
  "Пост": "Gönderi",
  "Потрачено Circle:": "Harcanan Circle:",
  "Почта": "E-posta",
  "Почта уже занята": "E-posta adresi zaten kullanılıyor",
  "Почта уже занята, войдите с ней": "E-posta adresi zaten kullanılıyor, bu adresle giriş yapın",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Расскажу, как прошёл мой день, что меня порадовало и какие планы у меня на завтра. Продолжайте говорить своими словами не меньше тридцати секунд.": "Merhaba! Bu, kendi sesim için bir kayıt. Sakin ve normal bir konuşma hızında, bir arkadaşımla konuşur gibi konuşuyorum. Günümün nasıl geçtiğini, beni nelerin mutlu ettiğini ve yarın için planlarımı anlatacağım. En az otuz saniye boyunca kendi kelimelerinizle konuşmaya devam edin.",
  "Приглашайте друзей": "Arkadaşlarını davet et",
  "Пример голоса {0}": "Ses örneği {0}",
  "Принимаю": "Kabul ediyorum",
  "Присылать готовые работы в чат": "Tamamlanan çalışmaları sohbete gönder",
  "Проверен": "Doğrulandı",
  "Проверить выгрузку": "Dışa aktarmayı kontrol et",
  "Проверить подтверждение": "Onayı kontrol et",
  "Проверка голоса не пройдена. Запишите образец без музыки и других людей.": "Ses kontrolü başarısız oldu. Müzik ve başka kişiler olmadan bir örnek kaydedin.",
  "Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.": "Örnek kontrolü başarısız oldu. Tek bir kişinin temiz bir kaydını deneyin.",
  "Проверьте адрес": "Adresi kontrol edin",
  "Проверяем запись": "Kayıt kontrol ediliyor",
  "Проверяем образец {0} из {1}…": "{1} örnekten {0}. kontrol ediliyor…",
  "Проверяем состояние переноса…": "Aktarım durumu kontrol ediliyor…",
  "Проверяем…": "Kontrol ediliyor…",
  "Проверяйте остаток в профиле и получайте доступные награды.": "Profilden bakiyenizi kontrol edin ve kullanılabilir ödülleri alın.",
  "Продолжим проверку прежнего запроса, без повторного запуска.": "Önceki isteği yeniden başlatmadan kontrol etmeye devam edeceğiz.",
  "Продолжим сохранённый запрос с теми же данными.": "Kaydedilmiş isteğe aynı verilerle devam edeceğiz.",
  "Продолжить отправку": "Göndermeye devam et",
  "Продолжить проверку": "Kontrole devam et",
  "Продолжить создание голоса": "Ses oluşturmaya devam et",
  "Продолжить сохранение": "Kaydetmeye devam et",
  "Прослушать {0}": "{0} dinle",
  "Профиль": "Profil",
  "Профиль «Вы» пока недоступен.": "«Siz» profili henüz kullanılamıyor.",
  "Профиль уже изменился. Закройте форму и откройте актуальную версию.": "Profil zaten değişti. Formu kapatın ve güncel sürümü açın.",
  "Работ в этом списке пока нет.": "Bu listede henüz çalışma yok.",
  "Работа №": "Çalışma No.",
  "Работы и параметры заказов исчезнут из истории. Голоса, варианты «Вы» и близкие останутся. Финансовые квитанции сохраняются. Вернуть историю нельзя.": "Çalışmalar ve sipariş parametreleri geçmişten silinecek. Sesler, «Siz» varyantları ve yakınlarınız korunacak. Finansal makbuzlar saklanacak. Geçmiş geri getirilemez.",
  "Работы по неделям": "Haftalık çalışmalar",
  "Раздел профиля": "Profil bölümü",
  "Разделы профиля": "Profil bölümleri",
  "Размер каждого образца должен быть от 1 байта до 20 МБ.": "Her örneğin boyutu 1 bayt ile 20 MB arasında olmalıdır.",
  "Ребёнок": "Çocuk",
  "Результат обработки уточняется. Повторный запуск пока недоступен.": "İşlem sonucu henüz kesinleşmedi. Yeniden başlatma şu anda kullanılamıyor.",
  "Русский": "Русский",
  "С": "Şu tarihten itibaren",
  "Сбросить голос по умолчанию": "Varsayılan sesi sıfırla",
  "Светлая": "Açık",
  "Свой аватар": "Kendi avatarınız",
  "Сгорят {0}, если не потратить": "Harcanmazsa {0} tarihinde sona erer",
  "Сделать кружок": "Görüntülü mesaj oluştur",
  "Серия:": "Seri:",
  "Сестра": "Kız kardeş",
  "Скачать ZIP": "ZIP indir",
  "Скопировать Telegram ID": "Telegram ID'yi kopyala",
  "Скорость речи": "Konuşma hızı",
  "Скрыть пароль": "Şifreyi gizle",
  "Слишком много запросов. Подождите немного и попробуйте ещё раз.": "Çok fazla istek gönderildi. Biraz bekleyip tekrar deneyin.",
  "Слишком много попыток. Попробуйте позже.": "Çok fazla deneme yapıldı. Daha sonra tekrar deneyin.",
  "Снимайте лицо без фильтров и тёмных очков, при ровном освещении. Добавьте разные ракурсы. В кадре должен быть один человек.": "Yüzünüzü filtresiz ve koyu renkli gözlüksüz, eşit aydınlatmada çekin. Farklı açılardan fotoğraflar ekleyin. Karede yalnızca bir kişi olmalıdır.",
  "Снять голос": "Ses kaydet",
  "Снять фото": "Fotoğraf çek",
  "Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.": "Eğitim başlamadan önce onay değişti. Sayfayı yenileyin ve işlemi yeniden başlatmadan önce güncel sürümü onaylayın.",
  "Создавайте говорящие кружки с выбранным персонажем или своим образом.": "Seçilen karakter veya kendi görünümünüzle konuşan daire videoları oluşturun.",
  "Создание": "Oluşturma",
  "Создание голосов временно недоступно. Образцы сохранены в этом окне.": "Ses oluşturma geçici olarak kullanılamıyor. Örnekler bu pencerede kaydedildi.",
  "Создание новых голосов пока недоступно. Уже созданные голоса доступны ниже.": "Yeni ses oluşturma şu anda kullanılamıyor. Mevcut sesler aşağıda bulunabilir.",
  "Создано:": "Oluşturulma tarihi:",
  "Создан {0}": "Oluşturulma: {0}",
  "Создать аккаунт": "Hesap oluştur",
  "Создать голос": "Ses oluştur",
  "Создаём голос…": "Ses oluşturuluyor…",
  "Сохранение настроек создания сейчас выключено.": "Oluşturma ayarlarını kaydetme şu anda devre dışı.",
  "Сохранение не подтверждено. Закройте форму и проверьте актуальный профиль.": "Kayıt onaylanmadı. Formu kapatın ve güncel profili kontrol edin.",
  "Сохранение не подтверждено. Повтор создания использует прежний запрос.": "Kayıt onaylanmadı. Yeniden oluşturma işlemi önceki isteği kullanır.",
  "Сохранение недоступно.": "Kaydetme kullanılamıyor.",
  "Сохранено": "Kaydedildi",
  "Сохранить": "Kaydet",
  "Сохранить близкого": "Yakını kaydet",
  "Сохранить вариант": "Varyantı kaydet",
  "Сохранить голос по умолчанию": "Varsayılan sesi kaydet",
  "Сохранить мои фото": "Fotoğraflarımı kaydet",
  "Сохранить образцы": "Örnekleri kaydet",
  "Сохраняем образцы…": "Örnekler kaydediliyor…",
  "Сохраняем…": "Kaydediliyor…",
  "Сохранённые варианты себя доступны в профиле и инструментах создания.": "Kaydedilmiş kendiniz varyantları profilde ve oluşturma araçlarında kullanılabilir.",
  "Сохранённых вариантов пока нет.": "Henüz kaydedilmiş varyant yok.",
  "Сроки партий Circle временно недоступны": "Circle paketlerinin süreleri geçici olarak kullanılamıyor",
  "Старший": "Büyük",
  "Статистика": "İstatistikler",
  "Статистика по неделям временно недоступна.": "Haftalık istatistikler geçici olarak kullanılamıyor.",
  "Статус удаления временно недоступен. Квитанция сохранена в этой вкладке.": "Silme durumu geçici olarak kullanılamıyor. Makbuz bu sekmede kaydedildi.",
  "Сторис": "Hikâyeler",
  "Сын": "Oğul",
  "Тариф": "Tarife",
  "Текст для чтения": "Okunacak metin",
  "Тема": "Tema",
  "Тема сохраняется на этом устройстве.": "Tema bu cihazda kaydedilir.",
  "Тёмная": "Koyu",
  "У меня есть право использовать эти фотографии и согласие изображённых людей.": "Bu fotoğrafları kullanma hakkım var ve fotoğraflardaki kişilerin onayı mevcut.",
  "УДАЛИТЬ": "УДАЛИТЬ",
  "Убираем шум": "Gürültü gideriliyor",
  "Убрать": "Kaldır",
  "Убрать {0}": "{0} öğesini kaldır",
  "Убрать из избранного": "Favorilerden kaldır",
  "Убрать фоновый шум": "Arka plan gürültüsünü gider",
  "Убрать фото": "Fotoğrafı kaldır",
  "Уведомления": "Bildirimler",
  "Уведомления недоступны.": "Bildirimler kullanılamıyor.",
  "Уведомления пока недоступны.": "Bildirimler henüz kullanılamıyor.",
  "Удаление аккаунта Mini App": "Mini App hesabını silme",
  "Удаление:": "Siliniyor:",
  "Удалить": "Sil",
  "Удалить «": "« öğesini sil",
  "Удалить «{0}»?": "«{0}» silinsin mi?",
  "Удалить аккаунт Mini App": "Mini App hesabını sil",
  "Удалить близкого": "Yakını sil",
  "Удалить вариант": "Varyantı sil",
  "Удалить голос": "Sesi sil",
  "Удаляем…": "Siliniyor…",
  "Удаляется": "Siliniyor",
  "Українська": "Українська",
  "Условия использования": "Kullanım koşulları",
  "Файл": "Dosya",
  "Формат": "Biçim",
  "Фото Telegram": "Telegram fotoğrafı",
  "Фото {0}": "Fotoğraf {0}",
  "Фото и имя берутся из вашего профиля в Telegram. Если вы их сменили, обновите данные здесь.": "Fotoğraf ve ad Telegram profilinizden alınır. Değiştirdiyseniz verileri burada güncelleyin.",
  "Фото и фотосессия": "Fotoğraf ve fotoğraf çekimi",
  "Фото перед загрузкой": "Yüklemeden önce fotoğraf",
  "Фото профиля": "Profil fotoğrafı",
  "Фото профиля Telegram": "Telegram profil fotoğrafı",
  "Фото, голоса, близкие и данные Mini App будут удалены во всех сервисах. STEOS ID и финансовые квитанции останутся. Отменить удаление нельзя.": "Fotoğraflar, sesler, yakınlar ve Mini App verileri tüm hizmetlerden silinecek. STEOS ID ve finansal makbuzlar korunacak. Silme işlemi geri alınamaz.",
  "Фото:": "Fotoğraf:",
  "Часть профиля временно недоступна. Попробуйте обновить.": "Profilin bir kısmı geçici olarak kullanılamıyor. Yenilemeyi deneyin.",
  "Читаем аудиофайлы…": "Ses dosyaları okunuyor…",
  "Что нового": "Yenilikler",
  "Что нового пока не опубликовано или временно недоступно.": "Yenilikler henüz yayımlanmadı veya geçici olarak kullanılamıyor.",
  "Что нового пока не опубликовано.": "Yenilikler henüz yayımlanmadı.",
  "Шаблоны": "Şablonlar",
  "Шаблоны и рилс": "Şablonlar ve reels",
  "Эта неделя": "Bu hafta",
  "Этот голос используется:": "Bu ses şu anda kullanılıyor:",
  "Этот запуск пока нельзя повторить. Обновите статус голоса.": "Bu işlem şu anda yeniden başlatılamaz. Ses durumunu yenileyin.",
  "Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.": "Bu biçim desteklenmiyor. MP3, WAV, M4A, OGG veya WebM seçin.",
  "Язык аккаунта": "Hesap dili",
  "готова": "hazır",
  "готова частично": "kısmen hazır",
  "дата недоступна": "tarih kullanılamıyor",
  "для переозвучки": "yeniden seslendirme için",
  "до {0}, потом {1}": "{0} tarihine kadar, sonra {1}",
  "другой тариф": "başka tarife",
  "закончится {0}": "{0} tarihinde sona erecek",
  "и": "ve",
  "из": "içinden",
  "из 1:30 · минимум 0:02": "1:30 üzerinden · minimum 0:02",
  "лимит уточняется": "sınır henüz kesinleşmedi",
  "не задан": "belirtilmedi",
  "не назначен": "atanmadı",
  "новых": "yeni",
  "образец": "örnek",
  "образца": "örneğin",
  "образцов": "örnek",
  "оплачено до {0}": "{0} tarihine kadar ödendi",
  "подарок до {0}": "{0} tarihine kadar hediye",
  "пока недоступно": "henüz kullanılamıyor",
  "политику конфиденциальности STEOS": "STEOS gizlilik politikası",
  "продлится {0}": "{0} tarihinde yenilenir",
  "речи.": "konuşma.",
  "токенов": "token",
  "условия": "koşullar",
  "уточняется": "kesinleşiyor",
  "Қазақша": "Қазақша",
  "← Профиль": "← Profil",
  "▶ Прослушать": "▶ Dinle",
  "Озвучка": "Seslendirme",
  "Клон": "Klon",
  "Студия": "Stüdyo",
  "Баланс": "Bakiye",
  "История": "Geçmiş",
  "Ещё": "Diğer",
  "Клонирование голоса": "Ses klonlama",
  "Партнёрство": "Ortaklık",
  "Добавить в чат": "Sohbete ekle",
  "Разделы": "Bölümler",
  "Главное меню": "Ana menü",
  "Выберите": "Seçin",
  "После объединения сохранены все фото. Оставьте до пяти, чтобы изменить образ.": "Birleştirmeden sonra tüm fotoğraflar korundu. Görünümünü değiştirmek için en fazla beş fotoğraf bırak.",
  "Абзацы": "Paragraflar",
  "Альбом": "Albüm",
  "Аудио": "Ses",
  "Без изменения": "Değişiklik yok",
  "Бесплатно по текущему тестовому dev-тарифу.": "Mevcut test dev tarifesi kapsamında ücretsiz.",
  "Бесплатно по тестовому dev-тарифу": "Test dev tarifesi kapsamında ücretsiz",
  "В избранном пока пусто": "Favoriler henüz boş",
  "В очереди": "Kuyrukta",
  "Вариант {0}": "Seçenek {0}",
  "Введите текст до 1000 символов": "1000 karaktere kadar metin girin",
  "Вернули": "İade edildi",
  "Вернуть запись в историю не получится. Файл в чате останется.": "Kaydı geçmişe geri yükleyemezsiniz. Dosya sohbette kalacak.",
  "Видео": "Video",
  "Виды работ": "İş türleri",
  "Все": "Tümü",
  "Вчера": "Dün",
  "Выбранный вариант": "Seçilen seçenek",
  "Выбранный вариант недоступен. Вернитесь в профиль и обновите список.": "Seçilen seçenek kullanılamıyor. Profile dönüp listeyi yenileyin.",
  "Выполняется": "İşleniyor",
  "Высота голоса": "Ses perdesi",
  "Говорящее видео": "Konuşan video",
  "Голоса": "Sesler",
  "Дата неизвестна": "Tarih bilinmiyor",
  "Длительность": "Süre",
  "Для этого действия пока нет доступного опубликованного инструмента.": "Bu işlem için henüz kullanılabilir, yayımlanmış bir araç yok.",
  "Дополнительное поле": "Ek alan",
  "Заголовок": "Başlık",
  "Загружаем историю…": "Geçmiş yükleniyor…",
  "Загружаем работу…": "İş yükleniyor…",
  "Загружаем результат…": "Sonuç yükleniyor…",
  "Загружаем…": "Yükleniyor…",
  "Загружено": "Yüklendi",
  "Загрузка не подтверждена. Продолжите проверку этого файла.": "Yükleme onaylanmadı. Bu dosyanın kontrolüne devam edin.",
  "Заказ": "Sipariş",
  "Заказ не подтверждён. Продолжение проверит прежний запрос с тем же ключом.": "Sipariş onaylanmadı. Devam etmek, aynı anahtarla önceki isteği kontrol edecek.",
  "Заменить файл": "Dosyayı değiştir",
  "Избранное: {0}": "Favoriler: {0}",
  "Инструмент обновляется. Обновите форму позже.": "Araç güncelleniyor. Formu daha sonra yenileyin.",
  "Искать в {0} работах": "{0} iş içinde ara",
  "Искать в истории": "Geçmişte ara",
  "Использовать фото выбранного варианта": "Seçilen seçeneğin fotoğrafını kullan",
  "Используется выбранный голос.": "Seçilen ses kullanılıyor.",
  "Исход генерации уточняется. Новая работа автоматически не запускается.": "Üretim sonucu hâlâ belirleniyor. Yeni bir iş otomatik olarak başlatılmaz.",
  "К инструментам": "Araçlara git",
  "Кавер": "Cover",
  "Карусель": "Karusel",
  "Ключевые слова": "Anahtar kelimeler",
  "Коллаж": "Kolaj",
  "Кратко": "Kısa",
  "Кружки": "Görüntülü mesajlar",
  "Кружок": "Görüntülü mesaj",
  "Кто в кадре": "Karede kim var",
  "Название": "Ad",
  "Не получилось": "Başarısız oldu",
  "Не удалось выполнить": "İşlem gerçekleştirilemedi",
  "Не удалось выполнить действие с этой работой. Обновите её и попробуйте снова.": "Bu iş üzerinde işlem gerçekleştirilemedi. Yenileyip tekrar deneyin.",
  "Не удалось завершить создание. Попробуйте изменить настройки.": "Oluşturma tamamlanamadı. Ayarları değiştirmeyi deneyin.",
  "Не удалось загрузить историю. Попробуйте ещё раз.": "Geçmiş yüklenemedi. Tekrar deneyin.",
  "Не удалось загрузить студию.": "Stüdyo yüklenemedi.",
  "Не удалось загрузить фото варианта. Обновите профиль.": "Seçeneğin fotoğrafı yüklenemedi. Profili yenileyin.",
  "Не удалось обработать запись": "Kayıt işlenemedi",
  "Не удалось озвучить текст": "Metin seslendirilemedi",
  "Не удалось открыть инструмент. Попробуйте обновить.": "Araç açılamadı. Yenilemeyi deneyin.",
  "Не удалось открыть результат. Попробуйте снова.": "Sonuç açılamadı. Tekrar deneyin.",
  "Не удалось отправить результат. Повторите отправку.": "Sonuç gönderilemedi. Tekrar gönderin.",
  "Не удалось связаться с сервисом. Попробуйте ещё раз.": "Hizmete bağlanılamadı. Tekrar deneyin.",
  "Не удалось скопировать. Выделите текст вручную.": "Kopyalanamadı. Metni manuel olarak seçin.",
  "Не удалось сохранить отправку. Разрешите хранилище вкладки и попробуйте ещё раз.": "Gönderim kaydedilemedi. Sekme depolama alanına izin verip tekrar deneyin.",
  "Некоторые файлы повтора больше недоступны. Загрузите их заново.": "Tekrara ait bazı dosyalar artık kullanılamıyor. Yeniden yükleyin.",
  "Ничего не нашли": "Sonuç bulunamadı",
  "Нужно разных фото": "Farklı fotoğraflar gerekli",
  "Обрабатываем запись": "Kayıt işleniyor",
  "Озвучиваем текст": "Metin seslendiriliyor",
  "Озвучить": "Seslendir",
  "Озвучка готова": "Seslendirme hazır",
  "Озвучка проекта": "Proje seslendirmesi",
  "Оплата": "Ödeme",
  "Оплачено донатом": "Bağışla ödendi",
  "Определить автоматически": "Otomatik algıla",
  "Основа": "Temel",
  "Открыть результат": "Sonucu aç",
  "Отменено": "İptal edildi",
  "Отправить в чат": "Sohbete gönder",
  "Отправка не принята. Проверьте сообщение об ошибке.": "Gönderim kabul edilmedi. Hata mesajını kontrol edin.",
  "Отправка принята. Бот доставит результат в чат.": "Gönderim kabul edildi. Bot sonucu sohbete iletecek.",
  "Отправлено": "Gönderildi",
  "Переозвучить запись": "Kaydı yeniden seslendir",
  "Переозвучка": "Yeniden seslendirme",
  "Персонаж": "Karakter",
  "Площадка": "Platform",
  "Повтори движения": "Hareketleri tekrarla",
  "Повторить": "Tekrarla",
  "Подпись": "Altyazı",
  "Подтверждаю право использовать загружаемые материалы": "Yüklediğim materyalleri kullanma hakkım olduğunu onaylıyorum",
  "Подтверждаю право использовать эти фото и согласие изображённых людей на создание варианта": "Bu fotoğrafları kullanma hakkım olduğunu ve görüntülenen kişilerin bir varyasyon oluşturulmasına izin verdiğini onaylıyorum",
  "Поиск в истории": "Geçmişte ara",
  "Показатели истории": "Geçmiş istatistikleri",
  "Показатели истории временно недоступны": "Geçmiş istatistikleri geçici olarak kullanılamıyor",
  "Показать все работы": "Tüm işleri göster",
  "Показать текст": "Metni göster",
  "Порядок": "Sıralama",
  "Почистить запись": "Kaydı temizle",
  "Прежний голос недоступен. Выберите другой голос.": "Önceki ses kullanılamıyor. Başka bir ses seçin.",
  "Преимущества": "Avantajlar",
  "Проверьте заполненные поля. Заказ не создан.": "Doldurulan alanları kontrol edin. Sipariş oluşturulmadı.",
  "Проверяем итог операции": "İşlem sonucu kontrol ediliyor",
  "Проверяем отправку…": "Gönderim kontrol ediliyor…",
  "Проверяем результат": "Sonuç kontrol ediliyor",
  "Проверяем списание токенов": "Token kesintisi kontrol ediliyor",
  "Продолжить проверку озвучки": "Seslendirme kontrolüne devam et",
  "Работ пока нет": "Henüz iş yok",
  "Работ: {0}": "İş sayısı: {0}",
  "Работа": "İş",
  "Работа больше не найдена. Обновите историю.": "İş artık bulunamıyor. Geçmişi yenileyin.",
  "Работа из истории": "Geçmişten alınan iş",
  "Работа не прошла проверку.": "İş kontrolden geçemedi.",
  "Работа обновилась. Загрузите её ещё раз.": "İş güncellendi. Yeniden yükleyin.",
  "Распознавание": "Tanıma",
  "Распознанный текст": "Tanınan metin",
  "Распознать речь": "Konuşmayı tanı",
  "Расшифровка": "Transkripsiyon",
  "Режим озвучки": "Seslendirme modu",
  "Результат": "Sonuç",
  "Результат больше недоступен": "Sonuç artık kullanılamıyor",
  "Результат операции уточняется. Повторный запуск отключён.": "İşlem sonucu hâlâ belirleniyor. Yeniden başlatma devre dışı.",
  "Результат отправки пока неизвестен. Повторите проверку.": "Gönderim sonucu henüz bilinmiyor. Kontrolü tekrarlayın.",
  "Результат отправки пока неизвестен. Повторите с тем же ключом.": "Gönderim sonucu henüz bilinmiyor. Aynı anahtarla tekrar deneyin.",
  "Результат переозвучки": "Yeniden seslendirme sonucu",
  "Результат работы": "İş sonucu",
  "Реплики": "Replikler",
  "Речевая запись": "Konuşma kaydı",
  "Рилс": "Reels",
  "Сегодня": "Bugün",
  "Сейчас создаётся": "Şu anda oluşturuluyor",
  "Сервис сейчас недоступен.": "Hizmet şu anda kullanılamıyor.",
  "Сессия истекла. Откройте приложение заново.": "Oturumun süresi doldu. Uygulamayı yeniden açın.",
  "Синтез": "Sentez",
  "Скачать": "İndir",
  "Скачать все файлы": "Tüm dosyaları indir",
  "Скачать набор": "Paketi indir",
  "Скопировано": "Kopyalandı",
  "Скопировать": "Kopyala",
  "Слайды": "Slaytlar",
  "Слишком много запросов. Подождите немного.": "Çok fazla istek gönderildi. Biraz bekleyin.",
  "Слушать результат": "Sonucu dinle",
  "Смена голоса": "Ses değiştirme",
  "Сначала новые": "Önce en yeniler",
  "Сначала старые": "Önce en eskiler",
  "Создать": "Oluştur",
  "Создаётся": "Oluşturuluyor",
  "Списано": "Kesildi",
  "Статус пока не подтверждён. Проверяем прежний заказ.": "Durum henüz onaylanmadı. Önceki sipariş kontrol ediliyor.",
  "Статус текущих заказов временно недоступен": "Mevcut siparişlerin durumu geçici olarak kullanılamıyor",
  "Стиль": "Stil",
  "Стоимость": "Maliyet",
  "Сцена": "Sahne",
  "Съёмка": "Çekim",
  "Текст": "Metin",
  "Текст для озвучки": "Seslendirilecek metin",
  "Текст песни": "Şarkı sözleri",
  "Текст поста": "Gönderi metni",
  "Товар": "Ürün",
  "Удалить из истории": "Geçmişten sil",
  "Удалить из истории?": "Geçmişten silinsin mi?",
  "Уточняем результат": "Sonuç netleştiriliyor",
  "Уточняем состояние сохранённого заказа…": "Kaydedilmiş siparişin durumu netleştiriliyor…",
  "Файл в чате останется": "Dosya sohbette kalacak",
  "Файлов: {0}": "Dosya sayısı: {0}",
  "Форма недоступна.": "Form kullanılamıyor.",
  "Формат отправки": "Gönderim biçimi",
  "Фото": "Fotoğraf",
  "Фотосессии": "Fotoğraf çekimleri",
  "Фотосессия": "Fotoğraf çekimi",
  "Фотосессия товара": "Ürün çekimi",
  "Части": "Bölümler",
  "Шаблон": "Şablon",
  "Эта работа недоступна вашему аккаунту.": "Bu iş hesabınız için kullanılamıyor.",
  "Это вся история": "Tüm geçmiş bu kadar",
  "Этот инструмент сейчас недоступен. Попробуйте обновить форму.": "Bu araç şu anda kullanılamıyor. Formu yenilemeyi deneyin.",
  "Язык записи": "Kayıt dili",
  "MP3 · пауза между репликами 0,6 с": "MP3 · replikalar arasında 0,6 sn duraklama",
  "{0} / 1 000 знаков": "{0} / 1.000 karakter",
  "{0} / 20 000 знаков · версия {1}": "{0} / 20.000 karakter · sürüm {1}",
  "{0} реплик": "{0} replik",
  "{0} ролей · {1} новых реплик": "{0} rol · {1} yeni replik",
  "Аудио больше недоступно. Обновите статус проекта.": "Ses artık kullanılamıyor. Proje durumunu güncelleyin.",
  "Буфер недоступен. Вставьте текст в поле вручную.": "Panoya erişilemiyor. Metni alana manuel olarak yapıştırın.",
  "В проекте должно быть от 1 до 50 ролей.": "Projede 1 ile 50 arasında rol bulunmalıdır.",
  "В проекте может быть не больше 500 реплик.": "Projede en fazla 500 replik bulunabilir.",
  "Вставить из буфера": "Panodan yapıştır",
  "Вставить сценарий": "Senaryoyu yapıştır",
  "Выберите голос для каждой непустой роли.": "Boş olmayan her rol için bir ses seçin.",
  "Выше": "Yukarı",
  "Голос {0}": "{0} sesi",
  "Голос роли": "Rolün sesi",
  "Готовим аудио…": "Ses hazırlanıyor…",
  "Добавить {0} реплик": "{0} replik ekle",
  "Добавьте реплику или вставьте сценарий.": "Bir replik ekleyin veya senaryoyu yapıştırın.",
  "Дождитесь загрузки общего файла и попробуйте ещё раз.": "Ortak dosyanın yüklenmesini bekleyin ve tekrar deneyin.",
  "Дублировать": "Çoğalt",
  "Загружаем аудио…": "Ses yükleniyor…",
  "Загружаем проекты…": "Projeler yükleniyor…",
  "Загрузить версию сервера": "Sunucu sürümünü yükle",
  "Закрыть раздел без сохранения изменений?": "Değişiklikleri kaydetmeden bölümü kapatmak istiyor musunuz?",
  "Заменить текущие роли и реплики?": "Mevcut roller ve replikler değiştirilsin mi?",
  "Заменить текущий сценарий": "Mevcut senaryoyu değiştir",
  "Изменить сценарий": "Senaryoyu düzenle",
  "Имя роли": "Rol adı",
  "Кто говорит": "Konuşan kişi",
  "Мои проекты": "Projelerim",
  "Нажмите воспроизведение в плеере, чтобы разрешить звук.": "Sesi etkinleştirmek için oynatıcıdaki oynat düğmesine basın.",
  "Название проекта": "Proje adı",
  "Название слишком длинное.": "Ad çok uzun.",
  "Не удалось восстановить операции. Не запускайте озвучку повторно; проверьте историю.": "İşlemler geri yüklenemedi. Seslendirmeyi yeniden başlatmayın; geçmişi kontrol edin.",
  "Не удалось выполнить действие. Изменения остаются на экране.": "İşlem gerçekleştirilemedi. Değişiklikler ekranda kalıyor.",
  "Не удалось загрузить аудио. Проверьте соединение и попробуйте ещё раз.": "Ses yüklenemedi. Bağlantınızı kontrol edin ve tekrar deneyin.",
  "Не удалось озвучить проект": "Proje seslendirilemedi",
  "Не удалось подготовить аудио. Проверьте реплику и выбранный голос.": "Ses hazırlanamadı. Repliği ve seçilen sesi kontrol edin.",
  "Не удалось проверить владельца проекта. Обновите страницу.": "Proje sahibinin kimliği doğrulanamadı. Sayfayı yenileyin.",
  "Не удалось связаться с сервером. Проверьте соединение и повторите попытку.": "Sunucuya bağlanılamadı. Bağlantınızı kontrol edip tekrar deneyin.",
  "Не хватает Circle. Пополните баланс и повторите действие.": "Circle bakiyesi yetersiz. Bakiyenizi yükleyin ve işlemi tekrarlayın.",
  "Ниже": "Aşağı",
  "Новый дубль реплики": "Repliğin yeni kaydı",
  "Общий файл · MP3": "Ortak dosya · MP3",
  "Один из голосов больше недоступен. Выберите другой голос.": "Seslerden biri artık kullanılamıyor. Başka bir ses seçin.",
  "Озвучено реплик: {0} из {1}": "Seslendirilen replikler: {0} / {1}",
  "Озвучиваем проект": "Proje seslendiriliyor",
  "Озвучить · {0} Circle": "Seslendir · {0} Circle",
  "Озвучить проект": "Projeyi seslendir",
  "Озвучка проектов": "Senaryo seslendirme",
  "Озвучка уже выполняется. Дождитесь результата.": "Seslendirme zaten devam ediyor. Sonucu bekleyin.",
  "Операция уже принята или её исход неизвестен. Проверьте прежний запрос.": "İşlem zaten kabul edildi veya sonucu bilinmiyor. Önceki isteği kontrol edin.",
  "Отбросить локальные изменения и загрузить версию сервера?": "Yerel değişiklikleri atıp sunucu sürümünü yüklemek istiyor musunuz?",
  "Открыть в истории": "Geçmişte aç",
  "Отменить изменения": "Değişiklikleri geri al",
  "Отменить несохранённые изменения?": "Kaydedilmemiş değişiklikler iptal edilsin mi?",
  "Перед озвучкой дождитесь сохранения изменений.": "Seslendirmeden önce değişikliklerin kaydedilmesini bekleyin.",
  "Переозвучить": "Yeniden seslendir",
  "Переозвучить реплику": "Repliği yeniden seslendir",
  "Повторить проверку": "Kontrolü yeniden dene",
  "Подтвердить и запустить": "Onayla ve başlat",
  "Подтверждение озвучки": "Seslendirme onayı",
  "Проверить прежний запрос": "Önceki isteği kontrol et",
  "Проверить статус": "Durumu kontrol et",
  "Проверьте роли, голоса и длину реплик.": "Rolleri, sesleri ve replik uzunluklarını kontrol edin.",
  "Проект больше недоступен.": "Proje artık kullanılamıyor.",
  "Проект длиннее 20 000 знаков.": "Proje 20.000 karakterden uzun.",
  "Проект изменился в другом окне. Сравните свою версию и загрузите свежую.": "Proje başka bir pencerede değiştirildi. Sürümünüzü karşılaştırın ve güncel sürümü yükleyin.",
  "Проект изменился. Сохраните его и проверьте цену ещё раз.": "Proje değişti. Kaydedin ve fiyatı tekrar kontrol edin.",
  "Проект или результат больше недоступен.": "Proje veya sonuç artık kullanılamıyor.",
  "Проект озвучен": "Proje seslendirildi",
  "Проекты {0}": "Projeler {0}",
  "Прослушать": "Dinle",
  "Прослушать реплику": "Repliği dinle",
  "Прослушать текущую версию": "Mevcut sürümü dinle",
  "Прослушивание в очереди": "Dinleme sırada",
  "Прослушивание реплики": "Repliği dinleme",
  "Результат изменился. Загрузите его актуальную версию.": "Sonuç değişti. Güncel sürümünü yükleyin.",
  "Результат озвучки проекта": "Proje seslendirme sonucu",
  "Результат уточняется. Повторная генерация автоматически не запускается.": "Sonuç henüz kesinleşmedi. Yeniden oluşturma otomatik olarak başlatılmaz.",
  "Реплика {0}": "Replik {0}",
  "Реплика длиннее 1 000 знаков.": "Replik 1.000 karakterden uzun.",
  "Реплики · {0}": "Replikler · {0}",
  "Реплику {0} выше": "{0} numaralı repliği yukarı taşı",
  "Реплику {0} ниже": "{0} numaralı repliği aşağı taşı",
  "Роли и голоса": "Roller ve sesler",
  "Роль {0}": "Rol {0}",
  "Роль реплики": "Repliğin rolü",
  "Скачать MP3": "MP3 indir",
  "Слишком много запросов. Подождите и повторите проверку.": "Çok fazla istek gönderildi. Bekleyip tekrar kontrol edin.",
  "Создайте проект, затем вставьте сценарий или добавьте роли и реплики.": "Bir proje oluşturun, ardından senaryoyu yapıştırın veya roller ve replikler ekleyin.",
  "Стоимость подтверждена сервером. Повторная проверка этого же запроса не создаёт нового списания.": "Maliyet sunucu tarafından onaylandı. Aynı isteği yeniden kontrol etmek yeni bir ücretlendirmeye neden olmaz.",
  "Стоимость: {0} Circle": "Maliyet: {0} Circle",
  "Строки «Имя: реплика» станут ролями и репликами. Таймкоды можно оставить.": "“Ad: replik” biçimindeki satırlar rol ve repliklere dönüştürülür. Zaman kodlarını bırakabilirsiniz.",
  "Сценарий": "Senaryo",
  "Сценарий изменился. Эта дорожка относится к предыдущей версии проекта.": "Senaryo değişti. Bu ses kaydı projenin önceki sürümüne ait.",
  "Сценарий по ролям — каждая роль звучит своим голосом.": "Rollere göre senaryo — her rol kendi sesiyle konuşur.",
  "Текст или голос изменились. Для текущей версии нужно новое прослушивание.": "Metin veya ses değişti. Mevcut sürüm için yeniden dinleme oluşturulmalıdır.",
  "Текст реплики": "Replik metni",
  "Удалить проект": "Projeyi sil",
  "Удалить реплику {0}": "{0} numaralı repliği sil",
  "Удалить реплику?": "Replik silinsin mi?",
  "Удалить роль {0}": "{0} numaralı rolü sil",
  "Удалить роль «{0}» вместе с её репликами ({1})?": "“{0}” rolü, replikleriyle birlikte silinsin mi ({1})?",
  "Удалить этот проект?": "Bu proje silinsin mi?",
  "Укажите имя каждой роли.": "Her rol için bir ad girin.",
  "Уточняем результат озвучки": "Seslendirme sonucu netleştiriliyor",
  "Цена изменилась. Проверьте новую цену перед запуском.": "Fiyat değişti. Başlatmadan önce yeni fiyatı kontrol edin.",
  "есть несохранённые изменения": "kaydedilmemiş değişiklikler var",
  "сохранено": "kaydedildi",
  "＋ Новый проект": "＋ Yeni proje",
  "＋ Реплика": "＋ Replik",
  "＋ Роль": "＋ Rol",
  "Circle из пакетов без срока действия.": "Süresiz paketlerden Circle.",
  "Circle каждый месяц": "Her ay Circle",
  "Circle приходят каждые {0} дней, первая партия — сразу.": "Circle her {0} günde bir gelir, ilk paket hemen verilir.",
  "Circle этой партии действуют до {0}": "Bu paketteki Circle şu tarihe kadar geçerlidir: {0}",
  "{0} Circle каждый месяц": "Her ay {0} Circle",
  "{0} Circle каждый месяц · до {1} своих голосов": "Her ay {0} Circle · {1} adede kadar kendi sesiniz",
  "{0} мес.": "{0} ay",
  "Баланс и профиль": "Bakiye ve profil",
  "В текущем месяце осталось {0} из {1} Circle": "Bu ay {1} Circle içinden {0} kaldı",
  "Ваш текущий тариф": "Mevcut tarifeniz",
  "Включить тестовое продление": "Deneme amaçlı yenilemeyi etkinleştir",
  "Выбор тарифа": "Tarife seçimi",
  "Действует до {0}": "{0} tarihine kadar geçerli",
  "Для этой подписки продление пока недоступно.": "Bu abonelik için yenileme henüz kullanılamıyor.",
  "До {0} своих голосов": "{0} adede kadar kendi sesiniz",
  "До {0} сохраняется текущий тариф.": "{0} tarihine kadar mevcut tarife korunur.",
  "Докупить Circle": "Ek Circle satın al",
  "Доступные сроки": "Kullanılabilir süreler",
  "Загружаем подписку…": "Abonelik yükleniyor…",
  "Запланировать переход": "Tarife değişikliğini planla",
  "Запрос не совпадает с сохранённой операцией. Не повторяйте покупку; обратитесь в поддержку.": "İstek, kaydedilen işlemle eşleşmiyor. Satın alma işlemini tekrarlamayın; destek ekibiyle iletişime geçin.",
  "Исход прежнего запроса нужно проверить. Новая покупка пока заблокирована.": "Önceki isteğin sonucu kontrol edilmeli. Yeni satın alma şimdilik engellendi.",
  "Начислить {0} тестовых Circle": "{0} deneme Circle'ı yükle",
  "Не удалось восстановить операцию. Проверьте подписку перед новой покупкой.": "İşlem geri yüklenemedi. Yeni bir satın alma yapmadan önce aboneliğinizi kontrol edin.",
  "Операция подтверждена. Обновите данные; повторять покупку не нужно.": "İşlem onaylandı. Verileri yenileyin; satın alma işlemini tekrarlamanız gerekmez.",
  "Оставить текущий тариф": "Mevcut tarifeyi koru",
  "Отмена продления сохраняет тариф и лимиты до конца оплаченного срока.": "Yenilemeyi iptal etmek, ücretli sürenin sonuna kadar tarifeyi ve limitleri korur.",
  "Отменить продление": "Yenilemeyi iptal et",
  "Оформить dev-подписку": "Dev aboneliği başlat",
  "Пакет Circle начислен.": "Circle paketi yüklendi.",
  "Пакеты Circle доступны с активной подпиской.": "Circle paketleri yalnızca aktif abonelikle kullanılabilir.",
  "Перейти на выбранный тариф": "Seçilen tarifeye geç",
  "Переход начнётся после окончания текущей подписки. Сейчас оплата не требуется.": "Geçiş, mevcut abonelik sona erdikten sonra başlayacak. Şimdi ödeme yapmanız gerekmiyor.",
  "Подписка": "Abonelik",
  "Подписка временно недоступна. Попробуйте обновить данные.": "Abonelik geçici olarak kullanılamıyor. Verileri yenilemeyi deneyin.",
  "Подписка не продлится": "Abonelik yenilenmeyecek",
  "Подписка обновлена.": "Abonelik güncellendi.",
  "Подписка уже активна. Обновите данные и выберите доступное действие.": "Abonelik zaten aktif. Verileri yenileyin ve kullanılabilir bir işlem seçin.",
  "Подписка уже закончилась. Обновите данные.": "Aboneliğin süresi zaten dolmuş. Verileri yenileyin.",
  "Подтвердить": "Onayla",
  "Подтверждение подписки": "Abonelik onayı",
  "Покупка сейчас недоступна. Реальные платежи не включены.": "Satın alma şu anda kullanılamıyor. Gerçek ödemeler etkin değil.",
  "Получить dev-пакет бесплатно": "Ücretsiz dev paketi al",
  "Потом: {0}": "Sonra: {0}",
  "Предыдущая подписка закончилась {0}": "Önceki abonelik {0} tarihinde sona erdi",
  "При продлении оплаченного срока новая партия придёт в следующем периоде.": "Ücretli abonelik süresi yenilendiğinde yeni paket bir sonraki dönemde gelir.",
  "Проверка операции": "İşlem kontrolü",
  "Продление включено": "Yenileme etkin",
  "Продлить подписку": "Aboneliği yenile",
  "Свои голоса": "Kendi sesleriniz",
  "Свои голоса: {0} из {1}": "Kendi sesleriniz: {0}/{1}",
  "Сравнить тарифы": "Tarifeleri karşılaştır",
  "Срок": "Süre",
  "Срок подписки": "Abonelik süresi",
  "Срок: {0} мес.": "Süre: {0} ay",
  "Тариф останется до конца срока. Следующего продления не будет.": "Tarife, sürenin sonuna kadar devam eder. Bir sonraki yenileme yapılmayacak.",
  "Тарифы пока недоступны. Попробуйте обновить данные позже.": "Tarifeler şu anda kullanılamıyor. Daha sonra verileri yenilemeyi deneyin.",
  "Текущий тариф": "Mevcut tarife",
  "Тестовый dev-каталог. Реальных платежей нет; начисляются тестовые Circle.": "Test amaçlı dev kataloğu. Gerçek ödeme yapılmaz; deneme Circle'ları yüklenir.",
  "Управление подпиской": "Aboneliği yönet",
  "Условия тарифа изменились. Обновите данные перед подтверждением.": "Tarife koşulları değişti. Onaylamadan önce verileri yenileyin.",
  "Что входит": "Neler dahil",
  "Это бесплатная dev-операция. Деньги и Telegram Stars не списываются.": "Bu, ücretsiz bir dev işlemidir. Para veya Telegram Stars tahsil edilmez.",
  "Этот переход между тарифами недоступен.": "Tarifeler arasındaki bu geçiş kullanılamıyor.",
  "Этот тариф больше недоступен. Обновите список.": "Bu tarife artık kullanılamıyor. Listeyi yenileyin.",
  "QR-код": "QR kodu",
  "QR-код приглашения": "Davet QR kodu",
  "{0} из {1} · {2} Circle": "{0} / {1} · {2} Circle",
  "Виды заданий": "Görev türleri",
  "Выполнение этого задания пока недоступно.": "Bu görevin tamamlanması şu anda kullanılamıyor.",
  "Готовим материал…": "İçerik hazırlanıyor…",
  "Действие подтверждено. Обновляем задания.": "İşlem onaylandı. Görevler güncelleniyor.",
  "День {0}": "{0}. gün",
  "День {0} из {1}": "{1} günün {0}. günü",
  "Дней подряд: {0}": "Aralıksız gün sayısı: {0}",
  "Друзья": "Arkadaşlar",
  "Ежедневная серия": "Günlük seri",
  "Ежедневные": "Günlük",
  "Есть награды": "Ödüller mevcut",
  "Забрать {0} Circle": "{0} Circle al",
  "Загружаем награды…": "Ödüller yükleniyor…",
  "Задание ещё не выполнено. Обновите прогресс.": "Görev henüz tamamlanmadı. İlerlemenizi güncelleyin.",
  "Задание засчитывает открытие отправки сторис. Telegram не подтверждает публикацию.": "Görev, hikâye paylaşma ekranının açılmasını sayar. Telegram, paylaşımın yayımlandığını doğrulamaz.",
  "Заданий в этой группе пока нет.": "Bu grupta henüz görev yok.",
  "Задания дня": "Günün görevleri",
  "Заходите каждый день. Пропуск дня начинает серию заново.": "Her gün giriş yapın. Bir günü kaçırırsanız seriniz yeniden başlar.",
  "Исход прежнего запроса нужно проверить. Новые начисления пока заблокированы.": "Önceki isteğin sonucu kontrol edilmeli. Yeni ödül yüklemeleri şimdilik engellendi.",
  "Копирование недоступно. Выделите текст вручную.": "Kopyalama kullanılamıyor. Metni manuel olarak seçin.",
  "Материал для сторис": "Hikâye içeriği",
  "Награда подтверждена. Обновите данные; повторять начисление не нужно.": "Ödül onaylandı. Verileri güncelleyin; ödülü yeniden almaya çalışmayın.",
  "Награда получена": "Ödül alındı",
  "Награда получена. Завтра +{0} Circle": "Ödül alındı. Yarın +{0} Circle",
  "Награда уже получена. Обновите данные.": "Ödül zaten alındı. Verileri güncelleyin.",
  "Награды временно недоступны. Попробуйте обновить данные.": "Ödüller geçici olarak kullanılamıyor. Verileri güncellemeyi deneyin.",
  "Награды за друзей": "Arkadaş daveti ödülleri",
  "Награды приходят в Circle: ими можно платить в STEOS, выводить нельзя.": "Ödüller Circle olarak verilir: STEOS'ta ödeme yapmak için kullanılabilir, ancak para çekilemez.",
  "Начисление не подтверждено. Проверьте прежний запрос; новая награда пока заблокирована.": "Ödül yüklemesi onaylanmadı. Önceki isteği kontrol edin; yeni ödül şimdilik engellendi.",
  "Начисления приостановлены.": "Ödül yüklemeleri duraklatıldı.",
  "Начислено {0} Circle": "{0} Circle yüklendi",
  "Начислено: {0} Circle": "Yüklenen: {0} Circle",
  "Не удалось восстановить запрос награды. Проверьте баланс и обратитесь в поддержку.": "Ödül isteği kurtarılamadı. Bakiyenizi kontrol edin ve destek ekibiyle iletişime geçin.",
  "Не удалось загрузить QR-код.": "QR kodu yüklenemedi.",
  "Не удалось открыть отправку сторис. Награда не начислена.": "Hikâye paylaşma ekranı açılamadı. Ödül verilmedi.",
  "Не удалось подготовить сторис. Попробуйте ещё раз.": "Hikâye hazırlanamadı. Tekrar deneyin.",
  "Новый день: {0}": "Yeni gün: {0}",
  "Обновить награды": "Ödülleri güncelle",
  "Обновятся: {0}": "Güncellenecek: {0}",
  "Откройте Mini App в Telegram с поддержкой сторис.": "Mini App'i hikâyeleri destekleyen Telegram sürümünde açın.",
  "Открыть STEOS ID в профиле": "Profilde STEOS ID'yi aç",
  "Открыть сторис": "Hikâyeyi aç",
  "Отправить в сторис": "Hikâyede paylaş",
  "Партнёрские данные временно недоступны.": "İş ortağı verileri geçici olarak kullanılamıyor.",
  "Партнёрство · Статистика, материалы и вывод": "İş ortaklığı · İstatistikler, materyaller ve para çekme",
  "Первые шаги": "İlk adımlar",
  "Перейти к заданию": "Göreve git",
  "Получить ежедневную награду": "Günlük ödülü al",
  "Приглашено: {0} · Покупателей: {1}": "Davet edilen: {0} · Alışveriş yapanlar: {1}",
  "Прогресс задания": "Görev ilerlemesi",
  "Прогресс задания временно недоступен.": "Görev ilerlemesi geçici olarak kullanılamıyor.",
  "Промокод": "Promosyon kodu",
  "Разовые": "Tek seferlik",
  "Скопировать приглашение": "Daveti kopyala",
  "Скопировать промокод": "Promosyon kodunu kopyala",
  "Ссылка приглашения": "Davet bağlantısı",
  "Сторис в Telegram": "Telegram hikâyeleri",
  "Челленджи недели": "Haftalık meydan okumalar",
  "Circle используются внутри STEOS": "Circle, STEOS içinde kullanılır",
  "Telegram подтвердил отправку сообщения.": "Telegram, mesajın gönderildiğini doğruladı.",
  "Без покупок": "Satın alma yok",
  "В этом списке пока нет друзей.": "Bu listede henüz arkadaş yok.",
  "Возможен вывод по условиям программы": "Program koşullarına göre para çekilebilir",
  "Вопросы": "Sorular",
  "Всё время": "Tüm zamanlar",
  "Вы здесь": "Buradasınız",
  "Выберите PDF, JPG или PNG.": "PDF, JPG veya PNG seçin.",
  "Выберите плательщика": "Ödeyeni seçin",
  "Выбрать чат в Telegram": "Telegram'da sohbet seç",
  "Выбрать чат для отправки": "Gönderim için sohbet seç",
  "Вывод": "Para çekme",
  "Вывод недоступен на текущем уровне.": "Mevcut seviyede para çekme kullanılamıyor.",
  "Вывод сейчас недоступен.": "Para çekme şu anda kullanılamıyor.",
  "Вывод средств": "Para çekme işlemi",
  "Выплачен": "Ödendi",
  "Выставьте счёт на": "Fatura alıcısı",
  "Для вывода войдите в STEOS ID.": "Para çekmek için STEOS ID'ye giriş yapın.",
  "Для расчёта нужны опубликованные уровни и тарифы.": "Hesaplama için yayımlanmış seviyeler ve tarifeler gereklidir.",
  "До уровня «{0}»: ещё {1} покупателей": "«{0}» seviyesine ulaşmak için {1} alıcı daha gerekiyor",
  "Доступно к выводу": "Çekilebilir tutar",
  "Доступных шаблонов пока нет.": "Henüz kullanılabilir şablon yok.",
  "Доход": "Gelir",
  "Если купят {0} друзей": "{0} arkadaş satın alırsa",
  "Есть покупки": "Satın alma var",
  "За этот период начислений пока нет.": "Bu dönem için henüz tahakkuk yok.",
  "Загружаем QR-код…": "QR kodu yükleniyor…",
  "Загружаем друзей…": "Arkadaşlar yükleniyor…",
  "Загружаем материалы…": "Materyaller yükleniyor…",
  "Загружаем партнёрские данные…": "İş ortaklığı verileri yükleniyor…",
  "Загрузите проверенный счёт на оплату.": "Doğrulanmış ödeme faturasını yükleyin.",
  "Заказать материал в чат": "Sohbet için materyal sipariş et",
  "Запрос принят. Доставка в чат ещё не подтверждена.": "İstek kabul edildi. Sohbete teslimat henüz doğrulanmadı.",
  "Заявка принята. Статус выплаты появится в истории.": "Başvuru kabul edildi. Ödeme durumu geçmişte görüntülenecek.",
  "Заявок на вывод пока нет.": "Henüz para çekme başvurusu yok.",
  "Изменение реквизитов заблокировано до получения результата этой заявки.": "Bu başvurunun sonucu alınana kadar ödeme bilgilerinin değiştirilmesi engellendi.",
  "Имя получателя": "Alıcının adı",
  "История выводов": "Para çekme geçmişi",
  "Исход запроса нужно проверить. Новый материал пока заблокирован.": "İsteğin sonucu kontrol edilmeli. Yeni materyal şimdilik engellendi.",
  "Как определяется уровень?": "Seviye nasıl belirlenir?",
  "Как это работает": "Nasıl çalışır",
  "Калькулятор станет доступен после публикации расчётной политики.": "Hesaplama politikası yayımlandıktan sonra hesaplayıcı kullanılabilir olacak.",
  "Количество друзей": "Arkadaş sayısı",
  "Материалы": "Materyaller",
  "Материалы временно недоступны. Попробуйте обновить список.": "Materyaller geçici olarak kullanılamıyor. Listeyi yenilemeyi deneyin.",
  "Материалы пока недоступны.": "Materyaller henüz kullanılamıyor.",
  "Месяц": "Ay",
  "Минимальная сумма": "Minimum tutar",
  "На рассмотрении": "İnceleniyor",
  "Налоговый номер": "Vergi numarası",
  "Начисления за период": "Dönem tahakkukları",
  "Начислено Circle": "Tahakkuk eden Circle",
  "Начислено за период: {0} Circle": "Dönem için tahakkuk eden: {0} Circle",
  "Не удалось безопасно сохранить заявку или проверить владельца. Отправка не выполнена.": "Başvuru güvenli şekilde kaydedilemedi veya sahip doğrulanamadı. Gönderim yapılmadı.",
  "Не удалось восстановить отправку. Обратитесь в поддержку перед новым запросом.": "Gönderim kurtarılamadı. Yeni bir istekte bulunmadan önce destek ekibiyle iletişime geçin.",
  "Не удалось загрузить друзей.": "Arkadaşlar yüklenemedi.",
  "Не удалось загрузить историю выводов.": "Para çekme geçmişi yüklenemedi.",
  "Не удалось загрузить тарифы.": "Tarifeler yüklenemedi.",
  "Не удалось открыть отправку в Telegram.": "Telegram'da gönderim açılamadı.",
  "Не удалось проверить владельца. Обновите страницу.": "Sahip doğrulanamadı. Sayfayı yenileyin.",
  "Не удалось прочитать сохранённую заявку. Новый вывод заблокирован.": "Kaydedilmiş başvuru okunamadı. Yeni para çekme işlemi engellendi.",
  "Не удалось сохранить состояние отправки.": "Gönderim durumu kaydedilemedi.",
  "Неделя": "Hafta",
  "Нет данных": "Veri yok",
  "Новая заявка": "Yeni başvuru",
  "Новая заявка на вывод сейчас недоступна.": "Şu anda yeni para çekme başvurusu yapılamıyor.",
  "О программе": "Program hakkında",
  "Обзор": "Genel bakış",
  "Обновите страницу или обратитесь в поддержку.": "Sayfayı yenileyin veya destek ekibiyle iletişime geçin.",
  "Обновить историю выводов": "Para çekme geçmişini yenile",
  "Обновить материалы": "Materyalleri yenile",
  "От {0} покупателей": "{0} alıcıdan itibaren",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены.": "Yanıt alınmadı. Aynı başvuruyu kontrol edin: verileri ve anahtarı kaydedildi.",
  "Отклонён": "Reddedildi",
  "Откройте Mini App в Telegram с поддержкой отправки материалов.": "Materyal gönderimini destekleyen Telegram Mini App'i açın.",
  "Открыть сторис в Telegram": "Telegram'da hikâyeyi aç",
  "Отправка не подтверждена. Повтор проверит прежний запрос без новой отправки.": "Gönderim doğrulanmadı. Tekrar denemek, yeni bir gönderim yapmadan önceki isteği kontrol eder.",
  "Отправка отменена. Можно открыть выбор чата ещё раз.": "Gönderim iptal edildi. Sohbet seçimini yeniden açabilirsiniz.",
  "Оценка дохода": "Tahmini gelir",
  "Оценка за {0} месяцев: {1} Circle": "{0} ay için tahmin: {1} Circle",
  "Оценка за месяц: {0} Circle": "Aylık tahmin: {0} Circle",
  "Переходы": "Tıklamalar",
  "Период обзора": "İnceleme dönemi",
  "Плательщик": "Ödeyen",
  "Подать заявку на вывод": "Para çekme başvurusu yap",
  "Подготовить QR-код": "QR kodu oluştur",
  "Подготовить другой материал": "Başka bir materyal hazırla",
  "Подготовить материал": "Materyal hazırla",
  "Поделитесь своей ссылкой или промокодом.": "Bağlantınızı veya promosyon kodunuzu paylaşın.",
  "Поделиться": "Paylaş",
  "Пока без покупок": "Henüz satın alma yok",
  "Пока недоступно": "Şimdilik kullanılamıyor",
  "Покупатели": "Alıcılar",
  "Покупки друзей учитывает сервер STEOS ID.": "Arkadaşların satın alımları STEOS ID sunucusu tarafından hesaba katılır.",
  "Полные условия программы": "Programın tüm koşulları",
  "Пользователь": "Kullanıcı",
  "Попробуйте STEOS: {0}\nПромокод: {1}": "STEOS'u deneyin: {0}\nPromosyon kodu: {1}",
  "Привязка до: {0}": "Bağlantı tarihi: {0}",
  "Привязка приглашённого друга действует {0} месяцев.": "Davet edilen arkadaşın bağlantısı {0} ay boyunca geçerlidir.",
  "Приглашён: {0}": "Davet edildi: {0}",
  "Проверить загрузку счёта": "Fatura yüklemesini kontrol et",
  "Проверить ту же заявку": "Aynı başvuruyu kontrol et",
  "Проверьте налоговый номер получателя.": "Alıcının vergi numarasını kontrol edin.",
  "Проверьте реквизиты и счёт.": "Ödeme bilgilerini ve faturayı kontrol edin.",
  "Проверьте сумму вывода: целое число в доступном диапазоне.": "Para çekme tutarını kontrol edin: kullanılabilir aralıkta bir tam sayı olmalıdır.",
  "Проверяем владельца…": "Sahip doğrulanıyor…",
  "Проверяем заявку или счёт…": "Başvuru veya fatura kontrol ediliyor…",
  "Процент и доступность вывода определяет опубликованная программа.": "Yüzde oranını ve para çekme olanağını yayımlanmış program belirler.",
  "Проценты, сроки и ограничения показаны по опубликованным данным сервера.": "Yüzdeler, süreler ve kısıtlamalar sunucunun yayımlanmış verilerine göre gösterilir.",
  "Размер счёта должен быть от 1 байта до 10 МБ.": "Fatura boyutu 1 bayt ile 10 MB arasında olmalıdır.",
  "Регистрации": "Kayıtlar",
  "Результат загрузки счёта неизвестен. Проверьте загрузку без повторной отправки файла.": "Fatura yüklemesinin sonucu bilinmiyor. Dosyayı yeniden göndermeden yükleme durumunu kontrol edin.",
  "Скачать PNG": "PNG indir",
  "Сколько действует привязка друга?": "Arkadaş bağlantısı ne kadar süre geçerlidir?",
  "Скопировать текст": "Metni kopyala",
  "Сохранена неподтверждённая заявка": "Onaylanmamış başvuru kaydedildi",
  "Срок рассмотрения, дней": "İnceleme süresi, gün",
  "Ссылка и промокод добавляются сервером. Выберите доступный материал.": "Bağlantı ve promosyon kodu sunucu tarafından eklenir. Kullanılabilir bir materyal seçin.",
  "Ссылка на полный документ условий пока не опубликована.": "Koşulların tam metnini içeren belgenin bağlantısı henüz yayımlanmadı.",
  "Сторис открыта в Telegram. Публикацию нужно подтвердить в редакторе.": "Hikâye Telegram'da açıldı. Yayın, düzenleyicide onaylanmalıdır.",
  "Сумма в Circle": "Circle cinsinden tutar",
  "Сумма меньше минимальной суммы вывода.": "Tutar, minimum para çekme tutarından düşük.",
  "Сумма превышает доступный остаток.": "Tutar, kullanılabilir bakiyeyi aşıyor.",
  "Счёт на оплату · PDF, JPG или PNG, до 10 МБ": "Ödeme faturası · PDF, JPG veya PNG, en fazla 10 MB",
  "Счёт не прошёл загрузку или проверку. Выберите PDF, JPG или PNG до 10 МБ.": "Fatura yüklenemedi veya doğrulanamadı. En fazla 10 MB boyutunda PDF, JPG veya PNG seçin.",
  "Счёт пока не подтверждён. Повторите проверку или выберите другой файл.": "Fatura henüz onaylanmadı. Yeniden kontrol edin veya başka bir dosya seçin.",
  "Счёт проверен": "Fatura doğrulandı",
  "Текст приглашения": "Davet metni",
  "Текст сообщения": "Mesaj metni",
  "Тексты": "Metinler",
  "Тестовая заявка": "Test başvurusu",
  "Тестовая программа dev. Реальные выплаты выключены.": "Dev test programı. Gerçek ödemeler devre dışı.",
  "Тестовая программа: реальные выплаты отключены.": "Test programı: gerçek ödemeler devre dışı.",
  "Тестовый расчёт dev. Это оценка, начисление не выполняется.": "Dev test hesaplaması. Bu bir tahmindir; tahakkuk yapılmaz.",
  "Укажите имя получателя: до 200 символов.": "Alıcının adını girin: en fazla 200 karakter.",
  "Уровень показывает сервер по учтённым покупателям. Смотрите вкладку «Уровни».": "Seviye, hesaba katılan alıcılara göre sunucu tarafından belirlenir. «Seviyeler» sekmesine bakın.",
  "Уровни": "Seviyeler",
  "Условия начислений пока не опубликованы.": "Tahakkuk koşulları henüz yayımlanmadı.",
  "Условия программы": "Program koşulları",
  "Учёт переходов по ссылке пока недоступен.": "Bağlantı tıklamalarının takibi henüz kullanılamıyor.",
  "Фильтр друзей": "Arkadaş filtresi",
  "Что делать, если данные не обновились?": "Veriler güncellenmezse ne yapılmalı?",
  "Шаги": "Adımlar",
  "Баннер": "Afiş",
  "QR-постер": "QR posteri",
  "{0} / 300 знаков": "{0} / 300 karakter",
  "· до 20 МБ": "· 20 MB'ye kadar",
  "Агент готовит ответ…": "Ajan yanıt hazırlıyor…",
  "Аудиозапись": "Ses kaydı",
  "Бесплатно только в dev. До 30 секунд и 10 МБ. Текст можно исправить перед отправкой.": "Yalnızca dev ortamında ücretsizdir. En fazla 30 saniye ve 10 MB. Göndermeden önce metni düzeltebilirsiniz.",
  "Ваш вопрос": "Sorunuz",
  "Вопрос или название инструмента": "Soru veya araç adı",
  "Вопросов: {0}": "Sorular: {0}",
  "Вопросы · {0}": "Sorular · {0}",
  "Восстанавливаем чат…": "Sohbet geri yükleniyor…",
  "Все сервисы работают": "Tüm hizmetler çalışıyor",
  "Выберите MP3, WAV или M4A до 20 МБ.": "20 MB'ye kadar MP3, WAV veya M4A seçin.",
  "Выберите инструкцию к нужному инструменту или странице.": "İlgili araç veya sayfa için talimatları seçin.",
  "Диктовать вопрос": "Soruyu sesli dikte et",
  "Диктовка не подтверждена. Повторите проверку прежнего запроса или загрузки.": "Dikte doğrulanamadı. Önceki isteği veya yüklemeyi yeniden kontrol edin.",
  "До": "Şuna kadar",
  "Ещё спрашивают": "Başkaları da soruyor",
  "Загружаем справку…": "Yardım yükleniyor…",
  "Загружаем статус…": "Durum yükleniyor…",
  "Закрыть чат": "Sohbeti kapat",
  "ИИ-агент поддержки": "Yapay zekâ destek ajanı",
  "ИИ-агент сейчас недоступен.": "Yapay zekâ ajanı şu anda kullanılamıyor.",
  "Инструкции": "Talimatlar",
  "Инструкции · {0}": "Talimatlar · {0}",
  "Инструкции пока не опубликованы.": "Henüz talimat yayımlanmadı.",
  "Исход запроса пока неизвестен. Новый вопрос не отправляется.": "İsteğin sonucu henüz bilinmiyor. Yeni bir soru gönderilmiyor.",
  "Как пользоваться STEOS": "STEOS nasıl kullanılır",
  "Кружки и говорящие видео": "Yuvarlak videolar ve konuşan videolar",
  "Медленнее обычного": "Normalden daha yavaş",
  "Написать агенту": "Ajana yaz",
  "Начать": "Başla",
  "Начать новую диктовку": "Yeni dikte başlat",
  "Не помогло": "Yardımcı olmadı",
  "Не удалось восстановить диктовку. Новый запрос заблокирован.": "Dikte geri yüklenemedi. Yeni istek engellendi.",
  "Не удалось восстановить чат. Обратитесь в поддержку.": "Sohbet geri yüklenemedi. Destek ekibiyle iletişime geçin.",
  "Не удалось загрузить поддержку. Попробуйте ещё раз.": "Destek yüklenemedi. Tekrar deneyin.",
  "Не удалось загрузить статус сервисов.": "Hizmetlerin durumu yüklenemedi.",
  "Не удалось подтвердить ответ. Можно начать новый чат или написать в поддержку.": "Yanıt doğrulanamadı. Yeni bir sohbet başlatabilir veya destek ekibine yazabilirsiniz.",
  "Не удалось получить ответ. Повторите проверку без нового вопроса.": "Yanıt alınamadı. Yeni bir soru göndermeden önceki isteği yeniden kontrol edin.",
  "Не удалось проверить владельца чата. Повторите открытие.": "Sohbetin sahibi doğrulanamadı. Sohbeti yeniden açın.",
  "Не удалось сохранить новый чат.": "Yeni sohbet kaydedilemedi.",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "Değerlendirme kaydedilemedi. Tekrar deneyin.",
  "Недоступен": "Kullanılamıyor",
  "Некоторые сервисы работают медленнее обычного. Открыть статус": "Bazı hizmetler normalden daha yavaş çalışıyor. Durumu aç",
  "Нет подтверждённых данных": "Doğrulanmış veri yok",
  "Ничего не нашли. Попробуйте другие слова или спросите ИИ-агента.": "Hiçbir şey bulunamadı. Farklı kelimeler deneyin veya yapay zekâ ajanına sorun.",
  "Новый чат": "Yeni sohbet",
  "Обзор приложения": "Uygulamaya genel bakış",
  "Обновить справку": "Yardımı yenile",
  "Обновить статус": "Durumu yenile",
  "Опубликованная проверка. Автоматический мониторинг не заявлен.": "Yayımlanmış kontrol. Otomatik izleme yapıldığı belirtilmiyor.",
  "Ответ не подтверждён. Проверьте прежний запрос или напишите в поддержку.": "Yanıt doğrulanmadı. Önceki isteği kontrol edin veya destek ekibine yazın.",
  "Отвечает по опубликованной справке STEOS": "STEOS'un yayımlanmış yardım belgelerine göre yanıt verir",
  "Открыть инструкции": "Talimatları aç",
  "Открыть инструкцию": "Talimatı aç",
  "Открыть инструмент": "Aracı aç",
  "Открыть ответ справки": "Yardım yanıtını aç",
  "Открыть раздел": "Bölümü aç",
  "Отправить вопрос": "Soruyu gönder",
  "Оценка ответа": "Yanıtı değerlendir",
  "Очистить поиск": "Aramayı temizle",
  "Поиск по справке": "Yardımda ara",
  "Полезно": "Yararlı",
  "Помощь": "Yardım",
  "Популярные вопросы": "Popüler sorular",
  "Последняя проверка устарела. Текущее состояние неизвестно.": "Son kontrolün tarihi geçmiş. Mevcut durum bilinmiyor.",
  "Посмотреть короткий обзор": "Kısa genel bakışı görüntüle",
  "Предыдущая": "Önceki",
  "Проверено: {0}": "Kontrol tarihi: {0}",
  "Проверить диктовку": "Dikteyi kontrol et",
  "Пропустить": "Atla",
  "Работает": "Çalışıyor",
  "Распознать вопрос": "Soruyu tanı",
  "Распознаём вопрос…": "Soru tanınıyor…",
  "Результаты поиска": "Arama sonuçları",
  "Следующая": "Sonraki",
  "Советы": "İpuçları",
  "Справка пока не опубликована.": "Yardım henüz yayımlanmadı.",
  "Спросите что угодно": "Ne isterseniz sorun",
  "Спросить ИИ-агента": "Yapay zekâ ajanına sor",
  "Спросить ИИ-агента поддержки": "Yapay zekâ destek ajanına sor",
  "Статус": "Durum",
  "Статус сервисов": "Hizmetlerin durumu",
  "Статус сервисов пока не публикуется.": "Hizmet durumu henüz yayımlanmıyor.",
  "Статья недоступна": "Makale kullanılamıyor",
  "Темы": "Konular",
  "Темы пока не опубликованы.": "Henüz konu yayımlanmadı.",
  "Точного ответа в справке нет.": "Yardımda tam bir yanıt yok.",
  "Чат не отправляет сообщения человеку автоматически.": "Sohbet, bir kişiye otomatik olarak mesaj göndermez.",
  "Читаем запись…": "Kayıt okunuyor…",
  "Эта статья больше не входит в опубликованную справку.": "Bu makale artık yayımlanmış yardım belgelerinde yer almıyor.",
  "Выберите MP3, WAV или M4A до {0} МБ.": "En fazla {0} MB boyutunda bir MP3, WAV veya M4A dosyası seçin.",
  "До {0} · до {1} МБ": "{0} dakikaya kadar · {1} MB'a kadar",
  "Нужна запись от 1 секунды до {0}.": "{0} süresini aşmayan, en az 1 saniyelik bir kayıt gerekli.",
  "Остановить запись · {0}": "Kaydı durdur · {0}",
  "{0} C/сек": "{0} sn/sn",
  "Все инструменты": "Tüm araçlar",
  "Все шаблоны": "Tüm şablonlar",
  "Вся подборка": "Tüm koleksiyon",
  "Выбрать, кто играет": "Kimlerin oynayacağını seçin",
  "Голос и музыка": "Ses ve müzik",
  "Двое": "İki kişi",
  "Дети": "Çocuklar",
  "Дешевле": "Daha ucuz",
  "Для бизнеса": "İşletmeler için",
  "Для этого действия доступно несколько шаблонов. Выберите подходящий в каталоге.": "Bu işlem için birden fazla şablon mevcut. Katalogdan uygun olanı seçin.",
  "Загружаем шаблон…": "Şablon yükleniyor…",
  "Закрыть поиск": "Aramayı kapat",
  "Закрыть превью": "Önizlemeyi kapat",
  "Инструменты": "Araçlar",
  "Искать во всех шаблонах": "Tüm şablonlarda ara",
  "Короче": "Daha kısa",
  "Кто играет": "Kim oynuyor",
  "Найти инструмент или шаблон": "Bir araç veya şablon bulun",
  "Не удалось загрузить выбранный вариант.": "Seçilen seçenek yüklenemedi.",
  "Не удалось загрузить шаблон. Обновите превью.": "Şablon yüklenemedi. Önizlemeyi yenileyin.",
  "Не удалось открыть инструмент.": "Araç açılamadı.",
  "Несколько": "Birden fazla",
  "Новые": "Yeni",
  "Один": "Bir kişi",
  "от {0} C": "{0} C'den başlayan",
  "от {0} C/сек": "{0} C/sn'den başlayan",
  "От {0} Circle": "{0} Circle'dan başlayan",
  "От А до Я": "A'dan Z'ye",
  "Очистить": "Temizle",
  "Питомцы": "Evcil hayvanlar",
  "По желанию": "İsteğe bağlı",
  "Подборка пока недоступна.": "Koleksiyon şu anda kullanılamıyor.",
  "Подборки": "Koleksiyonlar",
  "Поиск": "Ara",
  "Пока нет доступных шаблонов": "Henüz kullanılabilir şablon yok",
  "Популярные": "Popüler",
  "После": "Sonra",
  "Превью шаблона": "Şablon önizlemesi",
  "Пример результата пока не опубликован.": "Sonuç örneği henüz yayımlanmadı.",
  "Пример сейчас недоступен.": "Örnek şu anda kullanılamıyor.",
  "Рекомендуем": "Önerilen",
  "Смотреть все": "Tümünü görüntüle",
  "Сначала": "Sırala",
  "Сравнить до и после": "Öncesi ve sonrasını karşılaştır",
  "Стилей: {0}. Выбор на следующем шаге.": "Stil sayısı: {0}. Seçim sonraki adımda yapılır.",
  "Удерживайте для просмотра": "Görüntülemek için basılı tutun",
  "Цена уточняется в форме создания.": "Fiyat, oluşturma formunda netleşir.",
  "Частые вопросы": "Sık sorulan sorular",
  "Что нужно": "Gerekenler",
  "Что хотите сделать?": "Ne yapmak istiyorsunuz?",
  "Шаблоны и подборки": "Şablonlar ve koleksiyonlar",
  "Это действие пока недоступно.": "Bu işlem şu anda kullanılamıyor.",
  "е": "e",
  "за секунду": "saniyede",
  "ё": "ё",
  "{0} C в минуту": "{0} C dakika başına",
  "{0} C за 100 знаков": "{0} C 100 karakter başına",
  "Владелец сессии изменился. Вернитесь в студию после обновления страницы.": "Oturum sahibi değişti. Sayfayı yeniledikten sonra stüdyoya geri dönün.",
  "Не удалось восстановить сохранённую заявку. Новая генерация заблокирована.": "Kaydedilmiş başvuru geri yüklenemedi. Yeni oluşturma engellendi.",
  "Не удалось обновить сохранённую заявку. Новая генерация заблокирована.": "Kaydedilmiş başvuru güncellenemedi. Yeni oluşturma engellendi.",
  "Не удалось проверить владельца. Новая генерация заблокирована.": "Sahip doğrulanamadı. Yeni oluşturma engellendi.",
  "Не удалось сохранить заявку. Отправка не выполнена.": "Başvuru kaydedilemedi. Gönderim başarısız oldu.",
  "от {0} C в минуту": "Dakika başına {0} C'den başlayan fiyatlarla",
  "от {0} C за 100 знаков": "100 karakter başına {0} C'den başlayan fiyatlarla",
  "Проверить статус заказа": "Sipariş durumunu kontrol et",
  "Статус пока не подтверждён. Проверьте этот же заказ позже.": "Durum henüz doğrulanmadı. Aynı siparişi daha sonra tekrar kontrol edin.",
  "в минуту": "dakika başına",
  "за 100 знаков": "100 karakter başına",
  "Анимация звука": "Ses animasyonu",
  "В видео останется исходная речь. Выберите фрагмент до одной минуты.": "Videoda orijinal konuşma kalacak. Bir dakikaya kadar olan bir bölüm seçin.",
  "В видео останутся исходные слова. Голос можно изменить. Выберите фрагмент до одной минуты.": "Videoda orijinal kelimeler kalacak. Ses değiştirilebilir. Bir dakikaya kadar olan bir bölüm seçin.",
  "Вид персонажа": "Karakterin görünümü",
  "Видео готово": "Video hazır",
  "Видео не создано": "Video oluşturulamadı",
  "Волна": "Dalga",
  "Выберите, кто говорит": "Kimin konuştuğunu seçin",
  "Выбранное фото": "Seçilen fotoğraf",
  "Движение": "Hareket",
  "Добавьте видео": "Video ekleyin",
  "Дополнительная настройка": "Ek ayar",
  "Другой голос для записи": "Kayıt için farklı bir ses",
  "Ещё вариант": "Bir seçenek daha",
  "Ещё настройки": "Daha fazla ayar",
  "Изменить данные": "Bilgileri düzenle",
  "Источник": "Kaynak",
  "Источник лица": "Yüz kaynağı",
  "Источник речи": "Konuşma kaynağı",
  "Кадр по вертикали": "Dikey kadraj",
  "Кадр по горизонтали": "Yatay kadraj",
  "Каких движений избегать": "Kaçınılması gereken hareketler",
  "Конец фрагмента, секунды": "Bölümün bitişi, saniye",
  "Кружком": "Görüntülü mesaj olarak",
  "Кружок готов": "Yuvarlak video mesajı hazır",
  "Кружок не создан": "Yuvarlak video mesajı oluşturulamadı",
  "Люди и персонажи": "İnsanlar ve karakterler",
  "Напишите текст или добавьте запись": "Metin yazın veya kayıt ekleyin",
  "Начало фрагмента, секунды": "Bölümün başlangıcı, saniye",
  "Не удалось загрузить виды персонажа.": "Karakter görünümleri yüklenemedi.",
  "Не удалось загрузить людей и персонажей.": "İnsanlar ve karakterler yüklenemedi.",
  "Не удалось подтвердить завершение заказа. Новая генерация не начата.": "Siparişin tamamlandığı doğrulanamadı. Yeni oluşturma işlemi başlatılmadı.",
  "Не удалось проверить доставку. Откройте историю заказа.": "Teslimat doğrulanamadı. Sipariş geçmişini açın.",
  "Оставить голос записи": "Kaydın sesini koru",
  "Открыть в чате": "Sohbette aç",
  "Отправлено в чат": "Sohbete gönderildi",
  "По умолчанию": "Varsayılan",
  "Подтвердите право использовать материалы": "Materyalleri kullanma hakkınız olduğunu onaylayın",
  "Полосы": "Çizgiler",
  "Портретное": "Dikey",
  "Прежний заказ ещё не завершён. Сначала проверьте его результат.": "Önceki sipariş henüz tamamlanmadı. Öncelikle sonucunu kontrol edin.",
  "Приближение": "Yakınlaştırma",
  "Проверка отклонила материал. Измените исходные данные.": "Kontrol, materyali reddetti. Kaynak verileri değiştirin.",
  "Продолжить проверку отправки": "Gönderim kontrolüne devam et",
  "Результат недоступен. Проверьте историю заказа.": "Sonuç kullanılamıyor. Sipariş geçmişini kontrol edin.",
  "Результат отправки пока не подтверждён. Продолжите проверку с тем же ключом.": "Gönderim sonucu henüz doğrulanmadı. Aynı anahtarla kontrol etmeye devam edin.",
  "Результат пока не подтверждён. Проверьте этот заказ, прежде чем создавать новый.": "Sonuç henüz doğrulanmadı. Yeni bir sipariş oluşturmadan önce bu siparişi kontrol edin.",
  "Своё видео": "Kendi videonuz",
  "Своё фото": "Kendi fotoğrafınız",
  "Создание сейчас недоступно": "Oluşturma şu anda kullanılamıyor",
  "Создать кружок": "Görüntülü mesaj oluştur",
  "Создаём видео": "Video oluşturuluyor",
  "Списание возвращено": "Kesilen tutar iade edildi",
  "Тестовый заказ без списания": "Ücret kesilmeyen test siparişi",
  "Файлом": "Dosya olarak",
  "Фоновый звук": "Arka plan sesi",
  "Фото с лицом": "Yüzün bulunduğu fotoğraf",
  "Цена или версия инструмента изменилась. Обновите форму и проверьте стоимость.": "Fiyat veya araç sürümü değişti. Formu yenileyin ve ücreti kontrol edin.",
  "Человек или персонаж": "Kişi veya karakter",
  "Что скажет?": "Ne söyleyecek?",
  "Напишите не меньше {0} знаков": "En az {0} karakter yazın",
  "Текст отклонён проверкой. Измените текст.": "Metin kontrolden geçemedi. Metni değiştirin.",
  "В видео прозвучат новые слова.": "Videoda yeni kelimeler duyulacak.",
  "Если речь длиннее видео, ролик повторится.": "Konuşma videodan daha uzunsa video tekrar oynatılır.",
  "Исходная речь": "Orijinal konuşma",
  "Новая запись": "Yeni kayıt",
  "Новые слова текстом": "Yeni kelimelerin metin hâli",
  "Речь в видео": "Videodaki konuşma",
  "Размер файла не должен превышать {0} МБ.": "Dosya boyutu {0} MB değerini aşmamalıdır.",
  "До {0} МБ": "En fazla {0} MB",
  "Альбомное": "Yatay",
  "Альбомом": "Yatay olarak",
  "Без стиля": "Stilsiz",
  "В новом стиле": "Yeni bir stilde",
  "Вариант": "Varyant",
  "Во весь экран": "Tam ekran",
  "Восстановить фото": "Fotoğrafı onar",
  "Все стили": "Tüm stiller",
  "Все темы": "Tüm temalar",
  "Выберите инструмент в каталоге, затем подтвердите использование фото.": "Katalogdan bir araç seçin, ardından fotoğrafın kullanımını onaylayın.",
  "Выберите подходящее фото до {0} МБ.": "{0} MB'a kadar uygun bir fotoğraf seçin.",
  "Выберите стиль или свой референс": "Bir stil veya kendi referansınızı seçin",
  "Выбран свой референс": "Kendi referansınız seçildi",
  "Выбрать стиль": "Stil seç",
  "Двигайте картинку, чтобы выбрать кадр": "Kareyi seçmek için görüntüyü hareket ettirin",
  "Диафрагма": "Diyafram",
  "Добавить человека": "Kişi ekle",
  "Добавьте описание, от 10 знаков": "En az 10 karakterlik bir açıklama ekleyin",
  "Загрузите фото": "Fotoğraf yükleyin",
  "Заполните обязательные поля": "Zorunlu alanları doldurun",
  "Изменить фото": "Fotoğrafı değiştir",
  "Использовать выбранное фото результата": "Sonuç fotoğrafını kullan",
  "Кадр": "Kare",
  "Кадрирование": "Kırpma",
  "Как у фото": "Fotoğraftaki gibi",
  "Камера": "Kamera",
  "Найти настройку съёмки": "Çekim ayarı bul",
  "Найти стиль": "Stil bul",
  "Настройки съёмки недоступны.": "Çekim ayarları kullanılamıyor.",
  "Начать новое улучшение": "Yeni bir iyileştirme başlat",
  "Не выбран": "Seçilmedi",
  "Не удалось восстановить улучшение. Новая отправка заблокирована.": "İyileştirme geri yüklenemedi. Yeni gönderim engellendi.",
  "Не удалось загрузить режимы фото.": "Fotoğraf modları yüklenemedi.",
  "Не удалось загрузить фото.": "Fotoğraf yüklenemedi.",
  "Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.": "Sonuç fotoğrafı kullanılamadı. Orijinal siparişi açıp tekrar deneyin.",
  "Не удалось открыть режим. Попробуйте ещё раз.": "Mod açılamadı. Tekrar deneyin.",
  "Не удалось передать выбранное фото. Попробуйте снова.": "Seçilen fotoğraf gönderilemedi. Tekrar deneyin.",
  "Не удалось проверить владельца.": "Sahip doğrulanamadı.",
  "Не удалось прочитать фото.": "Fotoğraf okunamadı.",
  "Не удалось улучшить текст. Исходный текст сохранён.": "Metin iyileştirilemedi. Orijinal metin korundu.",
  "О стиле": "Stil hakkında",
  "Объектив": "Objektif",
  "Оживить фото": "Fotoğrafı canlandır",
  "Описание во весь экран": "Tam ekran açıklama",
  "Описание длиннее допустимого": "Açıklama izin verilen uzunluğu aşıyor",
  "По вертикали": "Dikey",
  "По горизонтали": "Yatay",
  "По описанию": "Açıklamaya göre",
  "Повторить прежнее улучшение": "Önceki iyileştirmeyi tekrarla",
  "Подтвердите права на материалы": "Materyaller üzerindeki haklarınızı onaylayın",
  "Пример": "Örnek",
  "Проверить улучшение": "İyileştirmeyi kontrol et",
  "Проверяем фото…": "Fotoğraf kontrol ediliyor…",
  "Ракурс": "Çekim açısı",
  "Раскрасить чёрно-белое": "Siyah beyaz fotoğrafı renklendir",
  "Режим фото": "Fotoğraf modu",
  "Референс должен быть не меньше 256 × 256 пикселей.": "Referans en az 256 × 256 piksel olmalıdır.",
  "Свернуть": "Daralt",
  "Свет": "Işık",
  "Свой референс": "Kendi referansınız",
  "Свой референс сейчас недоступен": "Kendi referansınız şu anda kullanılamıyor",
  "Сделать рилс": "Reels oluştur",
  "Сколько фото": "Fotoğraf sayısı",
  "Создать фото": "Fotoğraf oluştur",
  "Создаём фото": "Fotoğraf oluşturuluyor",
  "Срок проверки улучшения истёк. Исходный текст сохранён.": "İyileştirme kontrolünün süresi doldu. Orijinal metin korundu.",
  "Тема стиля": "Stil teması",
  "Убрать из кадра": "Kadrajdan çıkar",
  "Улучшение пока не подтверждено. Исходный текст сохранён.": "İyileştirme henüz onaylanmadı. Orijinal metin korundu.",
  "Улучшить": "İyileştir",
  "Формат файла": "Dosya biçimi",
  "Фото готовы": "Fotoğraflar hazır",
  "Фото на аватарку": "Profil fotoğrafı",
  "Фото не создано": "Fotoğraf oluşturulmadı",
  "Цвет": "Renk",
  "Что дальше": "Sırada ne var",
  "Что делает в кадре": "Kadrajda ne yapıyor",
  "Выберите разных людей в кадре": "Kare için farklı kişiler seçin",
  "Измените описание и попробуйте улучшить его снова.": "Açıklamayı değiştirip tekrar iyileştirmeyi deneyin.",
  "Использовать референс": "Referansı kullan",
  "Авто": "Otomatik",
  "Без движения": "Hareket yok",
  "Видео должно длиться не меньше секунды": "Video en az bir saniye olmalıdır",
  "Выберите главное фото": "Ana fotoğrafı seçin",
  "Выберите один исходный файл": "Tek bir kaynak dosya seçin",
  "Выберите файл подходящего формата и размера": "Desteklenen biçim ve boyutta bir dosya seçin",
  "Выберите фрагмент от 1 до 10 секунд": "1 ile 10 saniyelik bölüm seçin",
  "Главное фото": "Ana fotoğraf",
  "Длительность исходника: {0} с": "Kaynak süresi: {0} sn",
  "Добавить речь": "Konuşma ekle",
  "Загрузите видео": "Video yükleyin",
  "Загрузите фото или видео": "Fotoğraf veya video yükleyin",
  "Загрузить": "Yükle",
  "Загрузить видео": "Video yükle",
  "Загрузить фото": "Fotoğraf yükle",
  "Звук исходника не сохраняется: модель создаёт новый звук.": "Orijinal ses korunmaz: model yeni ses oluşturur.",
  "Звук от модели": "Modelin oluşturduğu ses",
  "Звук создаёт модель: фон, шумы и музыка. Речь можно добавить после создания.": "Model arka plan sesleri, efektler ve müzik oluşturur. Konuşma daha sonra eklenebilir.",
  "Использовать видео результата": "Sonuç videosunu kullan",
  "Исходное видео": "Kaynak video",
  "Исходный файл": "Kaynak dosya",
  "Как двигаться": "Nasıl hareket etsin",
  "Конец фрагмента, мс": "Bölüm sonu, ms",
  "Конец, секунды": "Bitiş, saniye",
  "Люди в кадре недоступны для этого режима": "Bu modda kadraja kişi eklenemez",
  "Начало фрагмента, мс": "Bölüm başlangıcı, ms",
  "Начало, секунды": "Başlangıç, saniye",
  "Не удалось загрузить режимы видео.": "Video modları yüklenemedi.",
  "Не удалось использовать видео результата. Откройте исходный заказ и попробуйте снова.": "Sonuç videosu kullanılamadı. Kaynak siparişi açıp tekrar deneyin.",
  "Не удалось передать видео. Откройте исходный заказ и попробуйте снова.": "Video aktarılamadı. Kaynak siparişi açıp tekrar deneyin.",
  "Новое": "Yeni",
  "Объёмное фото создаётся без звука": "Derinlik fotoğrafı sessiz oluşturulur",
  "Первый кадр": "İlk kare",
  "Продолжить загрузку": "Yüklemeye devam et",
  "Разрешение": "Çözünürlük",
  "Режим видео": "Video modu",
  "Снимем из главного фото. Выберите главное фото для кадрирования.": "Ana fotoğrafı kullanacağız. Kırpmak için ana fotoğrafı seçin.",
  "Снять": "Çek",
  "Снять видео": "Video çek",
  "Создать видео": "Video oluştur",
  "Темп": "Tempo",
  "Формат задаёт инструмент: портрет 3:4, ролик на 5 секунд": "Sabit biçim: dikey 3:4, 5 saniyelik video",
  "Фото товара": "Ürün fotoğrafları",
  "Фрагмент от 1 до 10 секунд": "1 ile 10 saniyelik bölüm",
  "Хит": "Popüler",
  "Что изменить": "Ne değiştirilsin",
  "Этот режим видео пока недоступен": "Bu video modu şu anda kullanılamıyor",
  "Как у исходника": "Kaynakla aynı",
  "Со звуком": "Sesli",
  "Без звука": "Sessiz",
  "5 секунд": "5 saniye",
  "10 секунд": "10 saniye",
  "Не удалось прочитать файл.": "Dosya okunamadı.",
  "1. Видео с вами": "1. Sizin videonuz",
  "1. Видео с движениями": "1. Hareket videosu",
  "2. Кем стать": "2. Kime dönüşmek",
  "2. Кто повторит": "2. Kim tekrarlasın",
  "Видео должно длиться не меньше {0} секунд": "Video en az {0} saniye olmalıdır",
  "Водяной знак — недоступен": "Filigran — kullanılamıyor",
  "Вы, близкий или персонаж": "Siz, bir yakınınız veya karakter",
  "Выберите допустимый фрагмент видео": "İzin verilen sürede bir bölüm seçin",
  "Выберите одного героя": "Tek bir kişi veya karakter seçin",
  "Выберите фон": "Arka plan seçin",
  "Выберите, кто повторит движения": "Hareketleri kimin tekrarlayacağını seçin",
  "Голос героя — недоступен": "Karakter sesi — kullanılamıyor",
  "Другой голос — недоступен": "Başka ses — kullanılamıyor",
  "Загрузите видео с движениями": "Hareket videosu yükleyin",
  "Из видео": "Videodan",
  "Изменить людей и свои фото": "Kişileri ve fotoğraflarınızı düzenleyin",
  "Источник героя": "Karakter kaynağı",
  "Исходный звук сохраняется, если он есть в ролике.": "Videoda ses varsa orijinal ses korunur.",
  "Кадр, ракурс и фон берутся с фото героя.": "Kadraj, açı ve arka plan karakter fotoğrafından alınır.",
  "Кто повторит движения": "Hareketleri kim tekrarlasın",
  "На фото должны быть видны голова, плечи и корпус.": "Fotoğrafta baş, omuzlar ve gövde görünmelidir.",
  "Нужен один человек в кадре. На фото и видео должны быть видны голова, плечи и корпус.": "Kadrajda tek kişi olmalıdır. Fotoğraf ve videoda baş, omuzlar ve gövde görünmelidir.",
  "Подтвердите права и согласие человека": "Hakları ve kişinin onayını doğrulayın",
  "Подтверждаю права на материалы и согласие человека на использование его изображения": "Materyaller üzerindeki haklarımı ve kişinin görüntüsünün kullanılmasına onay verdiğini doğruluyorum",
  "Преобразование в кружок недоступно: в результате нет подтверждённой звуковой дорожки.": "Yuvarlak videoya dönüştürülemiyor: sonuçta doğrulanmış ses kanalı yok.",
  "Режим движения": "Hareket modu",
  "С героя": "Karakterden",
  "Смена голоса пока недоступна": "Ses değiştirme şu anda kullanılamıyor",
  "Снять выбор": "Seçimi kaldır",
  "Сохранение исходного звука не подтверждено.": "Orijinal sesin korunduğu doğrulanmadı.",
  "Стать персонажем": "Karaktere dönüş",
  "Сцена и движения берутся из видео; внешность может отличаться.": "Sahne ve hareketler videodan alınır; görünüm farklılık gösterebilir.",
  "Только свои фото или с согласием человека на фото": "Yalnızca kendi fotoğraflarınız veya fotoğraftaki kişinin onayıyla",
  "Фон": "Arka plan",
  "Фото героя": "Karakter fotoğrafı",
  "Фрагмент от {0} до {1} секунд": "{0} ile {1} saniyelik bölüm",
  "{0} символов": "{0} karakter",
  "Авито": "Avito",
  "Английский": "İngilizce",
  "Выберите аудио или видео": "Ses veya video seçin",
  "Выбрать": "Seç",
  "Гарантия": "Garanti",
  "Да": "Evet",
  "Для чего нужен промпт": "İstem amacı",
  "Для этого инструмента сократите текст до 500 символов.": "Bu araç için metni 500 karaktere kısaltın.",
  "Добавьте текст": "Metin ekleyin",
  "Добавьте файл": "Dosya ekleyin",
  "Дополнительные варианты": "Ek seçenekler",
  "Дополнительные варианты пока не подтверждены.": "Ek seçenekler henüz doğrulanmadı.",
  "Дружелюбный": "Samimi",
  "Загрузите запись или запишите голос. Распознавание начнётся после подтверждения.": "Kayıt yükleyin veya sesinizi kaydedin. Yazıya dökme onaydan sonra başlar.",
  "Исходное фото": "Kaynak fotoğraf",
  "Как изменить текст": "Metin nasıl değişsin",
  "Комплект": "Paket içeriği",
  "Короткий": "Kısa",
  "Материал": "Malzeme",
  "Музыка": "Müzik",
  "На весь экран": "Tam ekran",
  "Не удалось открыть инструмент. Проверьте аккаунт и длину текста.": "Araç açılamadı. Hesabı ve metin uzunluğunu kontrol edin.",
  "Не удалось подтвердить дополнительные варианты. Проверьте тот же запрос.": "Ek seçenekler doğrulanamadı. Aynı isteği kontrol edin.",
  "Не удалось скачать текст.": "Metin indirilemedi.",
  "Не удалось скопировать текст.": "Metin kopyalanamadı.",
  "Не удалось сохранить черновик. Создание заблокировано, чтобы не потерять данные.": "Taslak kaydedilemedi. Veri kaybını önlemek için oluşturma engellendi.",
  "Нейтральный": "Nötr",
  "Нет": "Hayır",
  "Объём описания": "Açıklama uzunluğu",
  "Описание товара": "Ürün açıklaması",
  "Повторить запрос с тем же ключом": "Aynı anahtarla yeniden deneyin",
  "Подарочный": "Hediye",
  "Подробнее": "Daha ayrıntılı",
  "Подробный": "Ayrıntılı",
  "Подтверждаю права на материалы": "Materyaller üzerindeki haklarımı doğruluyorum",
  "Пожелания": "Tercihler",
  "Показать время": "Zamanları göster",
  "Показать всё": "Tümünü göster",
  "Премиальный": "Premium",
  "Проверить тот же запрос": "Aynı isteği kontrol et",
  "Продающий": "Satış odaklı",
  "Промпт из видео пока недоступен.": "Videodan istem oluşturma henüz kullanılamıyor.",
  "Промпт из фото": "Fotoğraftan istem",
  "Разделить по собеседникам": "Konuşmacıları ayır",
  "Размеры": "Boyutlar",
  "Распознавание по ссылке YouTube пока недоступно.": "YouTube bağlantısından yazıya dökme henüz kullanılamıyor.",
  "Распознать": "Yazıya dök",
  "Редактировать текст": "Metni düzenle",
  "Сайт": "Web sitesi",
  "Сбросить сохранённый черновик": "Kaydedilen taslağı sıfırla",
  "Скачать TXT": "TXT indir",
  "Скопировать весь текст": "Tüm metni kopyala",
  "Собеседник {0}": "Konuşmacı {0}",
  "Создать промпт": "İstem oluştur",
  "Создать сценарий": "Senaryo oluştur",
  "Создаём текст": "Metin oluşturuluyor",
  "Сократите пожелания": "Tercihleri kısaltın",
  "Сократите текст": "Metni kısaltın",
  "Список": "Liste",
  "Текст готов": "Metin hazır",
  "Текст из аудио и видео": "Ses ve videodan metin",
  "Текст не создан": "Metin oluşturulamadı",
  "Тестовый режим без списания": "Ücret alınmayan test modu",
  "Тон описания": "Açıklama tonu",
  "Улучшить промпт": "İstemi iyileştir",
  "Уход": "Bakım",
  "Что добавить в описание": "Açıklamaya ne eklensin",
  "Экспертный": "Uzman",
  "Язык": "Dil",
  "Яндекс Маркет": "Yandex Market",
  "Добавьте фото в открывшемся инструменте.": "Açılan araçta fotoğraf ekleyin.",
  "Не удалось открыть фото.": "Fotoğraf açılamadı.",
  "Текст для видео": "Video için metin",
  "Цена этого выбора пока не подтверждена": "Bu seçimin fiyatı henüz onaylanmadı",
  "C за фото": "C / fotoğraf",
  "C за секунду": "C / saniye",
  "Обычный": "Standart",
  "Кто повторил": "Tekrarlayan",
  "Человек с фото": "Fotoğraftaki kişi",
  "Сменить фон": "Arka planı değiştir",
  "Убрать лишнее": "Fazlalıkları kaldır",
  "Добавить очки": "Gözlük ekle",
  "Причёска": "Saç modeli",
  "Улыбка": "Gülümseme",
  "Деловой образ": "İş görünümü",
  "Летний фон": "Yaz arka planı",
  "Машет рукой": "El sallıyor",
  "Ветер": "Rüzgâr",
  "Плавнее": "Daha akıcı",
  "Ярче": "Daha parlak",
  "День в ночь": "Gündüzden geceye",
  "Снег": "Kar",
  "Очки": "Gözlük",
  "Что должно быть на фото? Например: девушка с зонтом на мокрой улице, вечер, огни витрин": "Fotoğrafta ne olmalı? Örneğin: ıslak bir sokakta şemsiyeli bir kız, akşam, vitrin ışıkları",
  "Что поменять на фото? Например: замени фон на ночной город, добавь очки": "Fotoğrafta ne değişsin? Örneğin: arka planı gece şehriyle değiştir, gözlük ekle",
  "Что добавить или поменять? Например: деловой костюм, лёгкая улыбка": "Ne eklensin ya da değişsin? Örneğin: takım elbise, hafif bir gülümseme",
  "Что происходит в ролике? Например: камера медленно летит над ночным городом, огни и мокрый асфальт": "Videoda ne oluyor? Örneğin: kamera gece şehrinin üzerinde yavaşça uçuyor, ışıklar ve ıslak asfalt",
  "Как двигаться? Например: улыбается и машет рукой, ветер в волосах": "Nasıl hareket etsin? Örneğin: gülümsüyor ve el sallıyor, saçlarında rüzgâr",
  "Что поменять в видео? Например: замени фон на ночной город, добавь снег": "Videoda ne değişsin? Örneğin: arka planı gece şehriyle değiştir, kar ekle",
  "Что добавить? Например: движения плавнее, ярче": "Ne eklensin? Örneğin: daha akıcı hareketler, daha parlak",
  "Сменить голос в записи": "Kayıttaki sesi değiştir",
  "Загрузите запись": "Bir kayıt yükleyin",
  "Ваша речь зазвучит выбранным голосом": "Konuşmanız seçilen sesle duyulacak",
  "Голосовое, интервью или заметку: уберём шум": "Sesli mesaj, röportaj veya not: gürültüyü gidereceğiz",
  "Библиотека и ваши клоны": "Kitaplık ve klonlarınız",
  "Без переозвучки, выберите другой": "Ses dönüştürme yok, başka birini seçin",
  "· Мой голос": "· Benim sesim",
  "· ещё {0}+ голосов": "· {0}+ ses daha",
  "Убрать шум": "Gürültüyü gider",
  "Перед сменой голоса уберём фон и эхо": "Sesi değiştirmeden önce arka planı ve yankıyı gidereceğiz",
  "Оставим только голос, без фона и эха": "Yalnızca sesi bırakacağız, arka plan ve yankı olmadan",
  "Голосовым или файлом: выберете, когда запись будет готова": "Sesli mesaj veya dosya olarak: kayıt hazır olduğunda seçeceksiniz",
  "Сменить голос": "Sesi değiştir",
  "Сделать голосовым": "Sesli mesaja dönüştür",
  "{0} · от {1} C": "{0} · {1} C’den",
  "Сначала остановите запись": "Önce kaydı durdurun",
  "Загрузите или запишите аудио": "Ses yükleyin veya kaydedin",
  "Читаем запись, секунду": "Kayıt okunuyor, bir saniye",
  "Запись длиннее {0}, загрузите короче": "Kayıt {0} süresinden uzun, daha kısa bir kayıt yükleyin",
  "Выберите голос, которым зазвучит запись": "Kaydın hangi sesle duyulacağını seçin",
  "Этот голос не умеет переозвучку, выберите другой": "Bu ses dönüştürme yapamıyor, başka birini seçin",
  "Пауза": "Duraklat",
  "Длиннее {0}": "{0} süresinden uzun",
  "Звучит запись": "Kayıt çalıyor",
  "Прослушать запись": "Kaydı dinle",
  "Загрузите запись короче": "Daha kısa bir kayıt yükleyin",
  "Запись с микрофона": "Mikrofon kaydı",
  "Без шума": "Gürültüsüz",
  "Как в записи": "Kayıttaki gibi",
  "Слушать": "Dinle",
  "Отправить голосовым": "Sesli mesaj olarak gönder",
  "Отправить файлом": "Dosya olarak gönder",
  "Голосовое в чате": "Sesli mesaj sohbette",
  "Файл в чате": "Dosya sohbette",
  "Голосовое в чате, в отдельной теме": "Sesli mesaj sohbette, ayrı bir konuda",
  "Файл в чате, в отдельной теме": "Dosya sohbette, ayrı bir konuda",
  "Тут откроется тема чата, куда бот прислал голосовое": "Burada botun sesli mesajı gönderdiği sohbet konusu açılacak",
  "Тут откроется тема чата, куда бот прислал запись": "Burada botun kaydı gönderdiği sohbet konusu açılacak",
  "Меняем голос": "Ses değiştiriliyor",
  "Собираем запись": "Kayıt hazırlanıyor",
  "Шум убран": "Gürültü giderildi",
  "Запись готова": "Kayıt hazır",
  "Голос изменён": "Ses değiştirildi",
  "Можно уйти с экрана: бот напишет, когда запись будет готова.": "Ekrandan ayrılabilirsiniz: kayıt hazır olduğunda bot size yazacak.",
  "Голос ваш, шума больше нет.": "Ses sizin, artık gürültü yok.",
  "Голос ваш, запись готова стать голосовым.": "Ses sizin, kayıt sesli mesaja dönüşmeye hazır.",
  "Слова и интонация ваши, голос новый.": "Sözler ve tonlama sizin, ses yeni.",
  "Пришлём в чат голосовым или файлом, как удобнее.": "Sohbete sesli mesaj veya dosya olarak göndereceğiz, hangisi size uygunsa.",
  "Запись ещё собирается": "Kayıt hâlâ hazırlanıyor",
  "Заставить говорить": "Konuştur",
  "Заменить запись": "Kaydı değiştir",
  "Загружаем запись": "Kayıt yükleniyor",
  "Запись загружена": "Kayıt yüklendi",
  "Запись собрана": "Kayıt hazırlandı",
  "Запись не прошла проверку": "Kayıt incelemeden geçemedi",
  "запись не собрана": "kayıt hazırlanmadı",
  "голос не изменён": "ses değiştirilmedi",
  "Не получилось убрать шум": "Gürültü giderilemedi",
  "Не получилось собрать запись": "Kayıt hazırlanamadı",
  "Не получилось сменить голос": "Ses değiştirilemedi",
  "Обновить форму": "Formu yenile",
  "Запись {0}": "Kayıt {0}",
  "Проверяем доступность": "Kullanılabilirlik kontrol ediliyor",
  "Загрузите запись заново": "Kaydı yeniden yükleyin",
  "Не удалось выбрать голос. Попробуйте ещё раз.": "Ses seçilemedi. Tekrar deneyin.",
  "Запись здесь недоступна, загрузите файл": "Burada kayıt yapılamıyor, bir dosya yükleyin",
  "Не удалось прочитать запись, попробуйте ещё раз": "Kayıt okunamadı, tekrar deneyin",
  "Ваш голос": "Sizin sesiniz",
  "в аудио": "seste",
  "со скидкой, {0} водяной знак": "indirimli, {0} filigran",
  "Запись ещё загружается": "Kayıt hâlâ yükleniyor",
  "Проверяем отправку": "Gönderim kontrol ediliyor",
  "Этот способ отправки сейчас недоступен": "Bu gönderim yöntemi şu anda kullanılamıyor",
  "Отправка пока не подтверждена. Нажмите ещё раз — проверим тот же запрос.": "Gönderim henüz onaylanmadı. Tekrar dokunun, aynı isteği kontrol edeceğiz.",
  "Не удалось передать запись. Откройте работу в «Истории» и попробуйте снова.": "Kayıt aktarılamadı. Çalışmayı «Geçmiş» bölümünde açıp tekrar deneyin.",
  "Попробовать ещё раз": "Tekrar dene",
  "Проверить ещё раз": "Tekrar kontrol et",
  "К настройкам": "Ayarlara dön",
  "Заказ не создан": "Sipariş oluşturulmadı",
  "Заказ не подтверждён": "Sipariş onaylanmadı",
  "остаток": "kalan",
  "Права на материалы": "Materyallerin hakları",
  "Только свои файлы или с согласия владельца": "Yalnızca kendi dosyalarınız veya sahibinin izniyle",
  "Загружаем файл": "Dosya yükleniyor",
  "Создаём": "Oluşturuluyor",
  "Файл больше {0} МБ, загрузите меньше": "Dosya {0} MB’tan büyük, daha küçük bir dosya yükleyin",
  "Фото меньше {0} × {1} пикселей, загрузите крупнее": "Fotoğraf {0} × {1} pikselden küçük, daha büyük bir fotoğraf yükleyin",
  "Видео длиннее {0}, загрузите короче": "Video {0} süresinden uzun, daha kısa bir video yükleyin",
  "Запись короче {0}, загрузите длиннее": "Kayıt {0} süresinden kısa, daha uzun bir kayıt yükleyin",
  "Видео короче {0}, загрузите длиннее": "Video {0} süresinden kısa, daha uzun bir video yükleyin",
  "Не удалось открыть фото. Загрузите его заново.": "Fotoğraf açılamadı. Yeniden yükleyin.",
  "Не удалось открыть видео. Загрузите его заново.": "Video açılamadı. Yeniden yükleyin.",
  "Можно до {0} фото": "En fazla {0} fotoğraf",
  "Этот человек не участвует": "Bu kişi katılmıyor",
  "Добавьте фото": "Fotoğraf ekleyin",
  "Файл не читается, загрузите другой": "Dosya okunamıyor, başka bir dosya yükleyin",
  "Запись слишком короткая": "Kayıt çok kısa",
  "Не удалось открыть запись для прослушивания. Загрузите её заново.": "Kayıt dinlemek için açılamadı. Yeniden yükleyin.",
  "Файл не прошёл проверку. Выберите другой файл.": "Dosya kontrolden geçemedi. Başka bir dosya seçin.",
  "Слишком много загрузок подряд. Подождите минуту и выберите файл снова.": "Art arda çok fazla yükleme. Bir dakika bekleyip dosyayı yeniden seçin.",
  "Файл не принят. Выберите его снова.": "Dosya kabul edilmedi. Yeniden seçin.",
  "Выбранный персонаж, голос или шаблон стал недоступен. Выберите другой — заказ не создан.": "Seçilen karakter, ses veya şablon artık kullanılamıyor. Başka birini seçin — sipariş oluşturulmadı.",
  "Создание сейчас недоступно. Заказ не создан, Circle не списаны.": "Oluşturma şu anda kullanılamıyor. Sipariş oluşturulmadı, Circle kesilmedi.",
  "Предыдущая работа ещё создаётся. Когда она будет готова, отправьте заказ снова.": "Önceki çalışma hâlâ oluşturuluyor. Hazır olduğunda siparişi yeniden gönderin.",
  "Политику и запрещённые темы не пропускаем.": "Siyaset ve yasaklı konulara izin vermiyoruz.",
  "{0} C списаны, {1}.": "{0} C kesildi, {1}.",
  "{0} C вернулись на баланс.": "{0} C bakiyenize iade edildi.",
  ", на шаге «{0}»": ", «{0}» adımında",
  "Сбой на нашей стороне": "Bizim tarafımızda bir hata oluştu",
  "{0} или {1}": "{0} veya {1}",
  "до {0}": "en fazla {0}",
  "Записать": "Kayıt yap",
  "Заменить": "Değiştir",
  "Нужна запись: MP3, WAV или M4A": "Bir kayıt gerekli: MP3, WAV veya M4A",
  "Нужно фото: JPG или PNG": "Bir fotoğraf gerekli: JPG veya PNG",
  "Нужно видео: MP4 или MOV": "Bir video gerekli: MP4 veya MOV",
  "Нужен файл PDF, DOCX или TXT": "PDF, DOCX veya TXT dosyası gerekli",
  "Нужно фото или видео": "Bir fotoğraf veya video gerekli",
  "Файл больше {0} МБ": "Dosya {0} MB’tan büyük",
  "Остановить запись": "Kaydı durdur",
  "Запрашиваем микрофон": "Mikrofon izni isteniyor",
  "Отменить запись": "Kaydı iptal et",
  "{0} КБ": "{0} KB",
  "{0} МБ": "{0} MB",
  "Не хватает {0} C · Пополнить": "{0} C eksik · Bakiye yükle",
  "Не хватает Circle": "Yetersiz Circle",
  "Не хватает {0} C": "{0} C eksik",
  "На балансе {0} C, нужно {1} C": "Bakiyede {0} C var, {1} C gerekiyor",
  "Создать за {0} вместо {1} C": "{1} C yerine {0} karşılığında oluştur",
  "Создать за {0} C вместо {1} C": "{1} C yerine {0} C karşılığında oluştur",
  "Со скидкой всё равно не хватает {0}": "İndirimle bile {0} eksik",
  "Со скидкой всё равно не хватает {0} C": "İndirimle bile {0} C eksik",
  "Для этой работы скидки нет": "Bu çalışma için indirim yok",
  "Сделать дешевле на {0}%, с водяным знаком": "%{0} daha ucuz, filigranlı",
  "Сделать дешевле на 10%, с водяным знаком": "%10 daha ucuz, filigranlı",
  "Назад в студию": "Stüdyoya dön",
  "Работа ещё создаётся": "Çalışma hâlâ oluşturuluyor",
  "Ваше фото": "Fotoğrafınız",
  "Ваши фото": "Fotoğraflarınız",
  "Ваш текст": "Metniniz",
  "Ваша тема": "Konunuz",
  "Тема поста": "Gönderi konusu",
  "Готовые кадры": "Hazır kareler",
  "Готовый кружок": "Hazır yuvarlak video",
  "Готовый ролик": "Hazır video",
  "Готовое фото": "Hazır fotoğraf",
  "Готовая аватарка": "Hazır avatar",
  "Готовые слайды": "Hazır slaytlar",
  "Готовый сюжет с вами: монтаж и музыка уже в шаблоне": "Sizinle hazır bir hikâye: kurgu ve müzik zaten şablonda",
  "Пост в стиле шаблона, {0} на выбор": "Şablon tarzında bir gönderi, seçmek için {0}",
  "Аватарка для соцсетей и мессенджеров, {0} на выбор": "Sosyal ağlar ve mesajlaşma uygulamaları için avatar, seçmek için {0}",
  "Фотосессия из {0} кадра в стиле шаблона": "Şablon tarzında {0} karelik fotoğraf çekimi",
  "Фотосессия из {0} кадров в стиле шаблона": "Şablon tarzında {0} karelik fotoğraf çekimi",
  "Ваш снимок оживёт в коротком ролике, {0} на выбор": "Fotoğrafınız kısa bir videoda canlanacak, seçmek için {0}",
  "Персонаж скажет ваш текст в кружке Telegram, {0} на выбор": "Bir karakter metninizi Telegram yuvarlak videosunda söyleyecek, seçmek için {0}",
  "Карусель слайдов для поста, {0} на выбор": "Gönderi için slayt karuseli, seçmek için {0}",
  "{0} стиль": "{0} stil",
  "{0} стиля": "{0} stil",
  "{0} стилей": "{0} stil",
  "{0}, выберете на следующем шаге": "{0}, sonraki adımda seçeceksiniz",
  "Что скажет герой, до 250 знаков": "Karakterin söyleyeceği, en fazla 250 karakter",
  "1 фото": "1 fotoğraf",
  "Любое, где хорошо видно лицо": "Yüzün net göründüğü herhangi bir fotoğraf",
  "Лицо крупно и при хорошем свете": "Yüz yakın planda ve iyi ışıkta",
  "Селфи, лицо крупно": "Selfie, yüz yakın planda",
  "Снимок оживёт в ролике": "Fotoğraf videoda canlanacak",
  "Или фото, из которых сделаем слайды": "Ya da slayta dönüştüreceğimiz fotoğraflar",
  "Стиль кружка": "Yuvarlak video stili",
  "1 человек": "1 kişi",
  "Вы, близкие или персонаж": "Siz, yakınlarınız ya da bir karakter",
  "Ваши дети, до {0}": "Çocuklarınız, en fazla {0}",
  "Ребёнок, одно фото": "Çocuk, tek fotoğraf",
  "Питомец, одно фото": "Evcil hayvan, tek fotoğraf",
  "Вы или близкие, одно фото": "Siz ya da yakınlarınız, tek fotoğraf",
  "По желанию: вы, близкие или персонаж": "İsteğe bağlı: siz, yakınlarınız ya da bir karakter",
  "По желанию: ваши дети, до {0}": "İsteğe bağlı: çocuklarınız, en fazla {0}",
  "По желанию: ребёнок, одно фото": "İsteğe bağlı: çocuk, tek fotoğraf",
  "По желанию: питомец, одно фото": "İsteğe bağlı: evcil hayvan, tek fotoğraf",
  "По желанию: вы или близкие, одно фото": "İsteğe bağlı: siz ya da yakınlarınız, tek fotoğraf",
  "Reels": "Reels",
  "Аватар": "Avatar",
  "{0} кадр": "{0} kare",
  "{0} кадра": "{0} kare",
  "{0} кадров": "{0} kare",
  "Выбрать, кто играет: {0}": "Kimlerin oynayacağını seçin: {0}",
  "Сравнить: {0} и {1}": "Karşılaştır: {0} ve {1}",
  "Поровну": "Yarı yarıya",
  "Пример результата пока не опубликован": "Sonuç örneği henüz yayınlanmadı",
  "Результат сохранён в «Истории». В чат не отправляем — так выбрано в настройках.": "Sonuç «Geçmiş» bölümüne kaydedildi. Sohbete göndermiyoruz — ayarlarda böyle seçildi.",
  "Результат сохранён в «Истории».": "Sonuç «Geçmiş» bölümüne kaydedildi.",
  "Файл результата пока недоступен. Проверьте работу в «Истории».": "Sonuç dosyası henüz kullanılamıyor. Çalışmayı «Geçmiş» bölümünde kontrol edin.",
  ", голос для: {0}": ", {0} için ses",
  ", играет: {0}": ", oynuyor: {0}",
  ": добавьте свои фото": ": fotoğraflarınızı ekleyin",
  ": добавьте фото": ": fotoğraf ekleyin",
  "<b class=\"mono\">{0}</b> из <span class=\"mono\">{1}</span>": "<b class=\"mono\">{0}</b> / <span class=\"mono\">{1}</span>",
  "JPG или PNG, до 10 МБ": "JPG veya PNG, en fazla 10 MB",
  "JPG, PNG · до {0} снимков": "JPG, PNG · en fazla {0} kare",
  "MP3, WAV или M4A, до 50 МБ": "MP3, WAV veya M4A, en fazla 50 MB",
  "MP4 или MOV, до 200 МБ": "MP4 veya MOV, en fazla 200 MB",
  "PDF, DOCX или TXT, до 20 МБ": "PDF, DOCX veya TXT, en fazla 20 MB",
  "{0} и {1}": "{0} ve {1}",
  "{0} фото": "{0} fotoğraf",
  "{0} фото · как в жизни": "{0} fotoğraf · gerçekteki gibi",
  "{0}, персонаж": "{0}, karakter",
  "Анфас, вполоборота, с улыбкой и без": "Önden, yarım profilden, gülümseyerek ve gülümsemeden",
  "Без модели": "Modelsiz",
  "Без сильных теней и фильтров": "Sert gölge ve filtre olmadan",
  "Было": "Önce",
  "В близких": "Yakınlarda",
  "В кадре {0}": "Karede: {0}",
  "В кадре уже {0} из {1}: снимите отметку с кого-нибудь": "Karede zaten {1} içinden {0} kişi var: birinin işaretini kaldırın",
  "В кадре: {0}": "Karede: {0}",
  "В роли «{0}» не больше {1}": "«{0}» rolünde en fazla {1} kişi",
  "В роль «{0}» персонажи не входят": "«{0}» rolüne karakterler giremez",
  "В роль «{0}» подходят {1}": "«{0}» rolüne uygun olanlar: {1}",
  "Варианты делаются из ваших фото в разделе «Свой аватар». Выбранный встаёт в «Кто в кадре» на всех экранах.": "Varyantlar, «Kendi avatarınız» bölümünde fotoğraflarınızdan oluşturulur. Seçilen varyant tüm ekranlarda «Karede kim var» bölümünde yer alır.",
  "Ваш питомец из близких": "Yakınlarınızdan evcil hayvanınız",
  "Ваш ребёнок из близких": "Yakınlarınızdan çocuğunuz",
  "Ваши фото: один раз для всех инструментов": "Fotoğraflarınız: tüm araçlar için bir kez",
  "Вкл": "Açık",
  "Впишите имя": "Bir ad girin",
  "Все <span class=\"mono\">{0}</span>": "Tümü <span class=\"mono\">{0}</span>",
  "Все варианты на виду": "Tüm seçenekler görünüyor",
  "Все персонажи": "Tüm karakterler",
  "Вы и персонажи": "Siz ve karakterler",
  "Вы или персонаж": "Siz veya bir karakter",
  "Вы, близкие и персонажи": "Siz, yakınlarınız ve karakterler",
  "Вы, свои фото": "Siz, kendi fotoğraflarınız",
  "Вы: добавьте свои фото": "Siz: fotoğraflarınızı ekleyin",
  "Выберите вариант": "Bir varyant seçin",
  "Выберите вариант для поля «{0}»": "«{0}» alanı için bir seçenek seçin",
  "Выберите ниже": "Aşağıdan seçin",
  "Выберите одного": "Bir kişi seçin",
  "Выберите, кто играет: {0}": "Kimin oynayacağını seçin: {0}",
  "Выберите, кто это для вас": "Sizin için kim olduğunu seçin",
  "Выбирать во всех инструментах без загрузки": "Tüm araçlarda yeniden yüklemeden seçin",
  "Выбор встанет во все инструменты": "Seçim tüm araçlara uygulanır",
  "Выбрать «{0}»": "«{0}» seç",
  "Выбрать вариант": "Varyant seç",
  "Выбрать: {0}": "Seç: {0}",
  "Выкл": "Kapalı",
  "Выключится, когда выберете вариант": "Bir seçenek seçtiğinizde kapanır",
  "Группы": "Gruplar",
  "Добавить": "Ekle",
  "Добавить в кадр": "Kareye ekle",
  "Добавьте свои фото": "Fotoğraflarınızı ekleyin",
  "Добавьте свои фото или вариант": "Fotoğraflarınızı veya bir varyant ekleyin",
  "Добавьте фото: {0}": "Fotoğraf ekleyin: {0}",
  "Другой голос": "Başka ses",
  "Ещё {0}: {1}": "{0} tane daha: {1}",
  "Заготовки": "Hazır metinler",
  "Загрузите файл": "Bir dosya yükleyin",
  "Загрузить ещё": "Daha fazla yükle",
  "Закрыть камеру": "Kamerayı kapat",
  "Запись недоступна. Загрузите видео.": "Kayıt kullanılamıyor. Bir video yükleyin.",
  "Здесь подходят {0}": "Burada uygun olanlar: {0}",
  "Здесь только персонажи своей подборки": "Burada yalnızca kendi koleksiyonundaki karakterler",
  "Играет: {0}": "Oynuyor: {0}",
  "Из ваших фото": "Fotoğraflarınızdan",
  "Из каталога": "Katalogdan",
  "Изменить ваши фото": "Fotoğraflarınızı düzenleyin",
  "Изменить свои фото": "Kendi fotoğraflarınızı düzenleyin",
  "Изменить: {0}": "Düzenle: {0}",
  "Иллюстрация": "İllüstrasyon",
  "Имя": "Ad",
  "Имя и фото · роли выбираются в ряду": "Ad ve fotoğraflar · roller sırada seçilir",
  "Искать стиль": "Stil ara",
  "Каким вы будете": "Nasıl görüneceksiniz",
  "Камера · лицо в кадр": "Kamera · yüz karede",
  "Камера · селфи в кадр": "Kamera · selfie karede",
  "Камера недоступна · имитация": "Kamera kullanılamıyor · simülasyon",
  "Камера недоступна. Загрузите файл.": "Kamera kullanılamıyor. Bir dosya yükleyin.",
  "Каталог 2 400+ голосов, подборки": "2.400+ ses kataloğu, koleksiyonlar",
  "Ко всем стилям": "Tüm stillere",
  "Кто будет моделью на фото": "Fotoğrafta kim model olacak",
  "Кто играет: <b>{0}</b>": "Kim oynuyor: <b>{0}</b>",
  "Кто играет: {0}": "Kim oynuyor: {0}",
  "Кто это для вас": "Sizin için kim",
  "Лицо в круг, смотрите в камеру": "Yüzünüz dairede olsun, kameraya bakın",
  "Люди": "Kişiler",
  "Можно близких или персонажа": "Yakınlarınız veya bir karakter",
  "Можно ваших близких": "Yakınlarınız",
  "Можно до {0} видео": "En fazla {0} video",
  "Можно до {0} записей": "En fazla {0} kayıt",
  "Можно до {0} записи": "En fazla {0} kayıt",
  "Можно до {0} запись": "En fazla {0} kayıt",
  "Можно до {0} файл": "En fazla {0} dosya",
  "Можно до {0} файла": "En fazla {0} dosya",
  "Можно до {0} файлов": "En fazla {0} dosya",
  "Можно и так, но 3 или больше снимков дадут сходство точнее": "Bu da olur ama 3 veya daha fazla kare benzerliği daha doğru yapar",
  "Можно и так, но 3 или больше фото дадут сходство точнее": "Bu da olur ama 3 veya daha fazla fotoğraf benzerliği daha doğru yapar",
  "Можно себя или близких": "Kendiniz veya yakınlarınız",
  "Можно себя, близких или персонажа": "Kendiniz, yakınlarınız veya bir karakter",
  "На этом экране вы в кадре всегда": "Bu ekranda her zaman karedesiniz",
  "Навсегда, вместе с фото": "Fotoğraflarla birlikte kalıcı olarak",
  "Нажмите, чтобы выбрать": "Seçmek için dokunun",
  "Найти": "Bul",
  "Напишите пару слов, и мы предложим варианты": "Birkaç kelime yazın, size seçenekler önerelim",
  "Например: Барсик": "Örneğin: Boncuk",
  "Например: Лёша": "Örneğin: Ali",
  "Нашли": "Bulunan",
  "Не получилось подготовить файл": "Dosya hazırlanamadı",
  "Не получилось улучшить. Попробуйте дописать пару слов": "İyileştirilemedi. Birkaç kelime eklemeyi deneyin",
  "Не помещается<span class=\"nfx\">: до {0} знаков</span>": "Sığmıyor<span class=\"nfx\">: en fazla {0} karakter</span>",
  "Необязательно: всё уже настроено": "İsteğe bağlı: her şey zaten ayarlı",
  "Ничего не нашлось": "Hiçbir şey bulunamadı",
  "Нужно выбрать": "Seçim gerekli",
  "Объём": "Hacim",
  "Один раз для всех инструментов": "Tüm araçlar için bir kez",
  "Отменить свой вариант": "Kendi seçeneğinizi iptal edin",
  "Отметьте, кто будет в кадре · {0}": "Karede kimin olacağını işaretleyin · {0}",
  "Персонажи": "Karakterler",
  "Подберём сами": "Biz seçeriz",
  "Подбираем варианты": "Seçenekler hazırlanıyor",
  "Пожилой": "Yaşlı",
  "Поиск стилей": "Stil arama",
  "Пока нечего сохранять": "Henüz kaydedilecek bir şey yok",
  "Попробуйте другое слово": "Başka bir kelime deneyin",
  "Порядок здесь один": "Burada tek bir sıralama var",
  "Примеры": "Örnekler",
  "Пропадёт {0} вместе с фото. Вернуть не получится.": "Fotoğraflarla birlikte {0} kaldırılacak. Geri alınamaz.",
  "Пропадёт из близких вместе с фото. Вернуть не получится.": "Fotoğraflarla birlikte yakınlardan kaldırılacak. Geri alınamaz.",
  "Пропадёт из близких и {0} вместе с фото. Вернуть не получится.": "Fotoğraflarla birlikte yakınlardan ve {0} kaldırılacak. Geri alınamaz.",
  "Профиль близкого": "Yakın profili",
  "Разные ракурсы и выражения": "Farklı açılar ve ifadeler",
  "Реалистичный": "Gerçekçi",
  "Реалистичный, иллюстрация или 3D": "Gerçekçi, illüstrasyon veya 3D",
  "Роли": "Roller",
  "Роль «{0}»": "«{0}» rolü",
  "Роль «{0}» для женского персонажа": "«{0}» rolü kadın karakter için",
  "Роль «{0}» для мужского персонажа": "«{0}» rolü erkek karakter için",
  "Роль «{0}» для персонажей своей подборки": "«{0}» rolü kendi koleksiyonundaki karakterler için",
  "Свой вариант": "Kendi seçeneğiniz",
  "Скачать здесь не получится": "Burada indirme yapılamıyor",
  "Создайте новый вариант": "Yeni bir varyant oluşturun",
  "Сортировка": "Sırala",
  "Сохранится в близких": "Yakınlara kaydedilecek",
  "Сохранить в близких": "Yakınlara kaydet",
  "Стало": "Sonra",
  "Только для этой фотосессии": "Yalnızca bu fotoğraf çekimi için",
  "Удаление": "Silme",
  "Удалить «{0}» {1}?": "«{0}» {1} kaldırılsın mı?",
  "Удалить «{0}» из близких?": "«{0}» yakınlardan kaldırılsın mı?",
  "Удалить из близких": "Yakınlardan kaldır",
  "Удалить из фотосессии": "Fotoğraf çekiminden kaldır",
  "Удерживайте, чтобы посмотреть примеры": "Örnekleri görmek için basılı tutun",
  "Управление": "Yönetim",
  "Файл готов. Нажмите ещё раз": "Dosya hazır. Tekrar dokunun",
  "Фото до 10 МБ, видео до 200 МБ": "Fotoğraf en fazla 10 MB, video en fazla 200 MB",
  "Фрагмент": "Kesit",
  "Что делает? Например: поправляет шарф": "Ne yapıyor? Örneğin: atkısını düzeltiyor",
  "Что делают в кадре": "Karede ne yapıyorlar",
  "Эта настройка здесь закреплена": "Bu ayar burada sabit",
  "Этот голос не умеет переозвучку записи": "Bu ses bir kaydı yeniden seslendiremez",
  "вариант «{0}»": "«{0}» varyantı",
  "взрослая": "yetişkin",
  "взрослый": "yetişkin",
  "всё видео умещается": "videonun tamamı sığıyor",
  "выберите": "seçin",
  "до <span class=\"mono\">{0}</span>": "en fazla <span class=\"mono\">{0}</span>",
  "до {0} человек": "en fazla {0} kişi",
  "до {0} человека": "en fazla {0} kişi",
  "ещё {0} из {1}": "{1} içinden {0} daha",
  "женская роль": "kadın rolü",
  "из фотосессии": "fotoğraf çekiminden",
  "из этой фотосессии": "bu fotoğraf çekiminden",
  "камера": "kamera",
  "максимум {0} секунд": "en fazla {0} saniye",
  "максимум {0} секунда": "en fazla {0} saniye",
  "максимум {0} секунды": "en fazla {0} saniye",
  "можно до <span class=\"mono\">{0}</span>": "en fazla <span class=\"mono\">{0}</span>",
  "мужская роль": "erkek rolü",
  "не из подборки этой роли": "bu rolün koleksiyonundan değil",
  "не подходит по возрасту": "yaşı uygun değil",
  "не участвует в этой фотосессии": "bu fotoğraf çekimine katılmıyor",
  "необязательно": "isteğe bağlı",
  "нет фото": "fotoğraf yok",
  "нужно выбрать": "seçim gerekli",
  "нужно: Вы": "gerekli: Siz",
  "персонажи в эту роль не входят": "karakterler bu role giremez",
  "питомец": "evcil hayvan",
  "по желанию": "isteğe bağlı",
  "пожилая": "yaşlı",
  "пожилой": "yaşlı",
  "ребёнок": "çocuk",
  "роль для взрослого": "yetişkin için bir rol",
  "роль для женщины": "kadın için bir rol",
  "роль для мужчины": "erkek için bir rol",
  "роль для питомца": "evcil hayvan için bir rol",
  "роль для ребёнка": "çocuk için bir rol",
  "роль для человека": "insan için bir rol",
  "Попробуйте другое слово или сбросьте тему": "Başka bir kelime deneyin veya temayı sıfırlayın",
  "Искать среди {n}+ голосов": "{n}+ ses içinde ara",
  "Голосов: {n}": "{n} ses",
  "Персонажей: {n}": "{n} karakter",
  "Голосов: {0}": "{0} ses",
  "Прослушать {n}": "{n} sesini dinle",
  "Загружаем ещё {n}": "{n} tane daha yükleniyor",
  "{a} из {b}": "{a}/{b}",
  "Подборка": "Koleksiyon",
  "Закрыть подборку": "Koleksiyonu kapat",
  "По имени": "Ada göre",
  "Загружаем подборки…": "Koleksiyonlar yükleniyor…",
  "Не удалось загрузить голоса": "Sesler yüklenemedi",
  "Не удалось воспроизвести пример. Попробуйте ещё раз.": "Örnek oynatılamadı. Tekrar deneyin.",
  "Мой голос": "Benim",
  "Мои": "Benim",
  "Своих голосов пока нет": "Henüz kendi sesiniz yok",
  "Клонируйте свой голос, и он появится на этой вкладке.": "Sesinizi klonlayın, burada görünecek.",
  "Клонировать голос": "Sesi klonla",
  "Открыть персонажа {0}": "{0} karakterini aç",
  "От": "En az",
  "Тренды недели": "Haftanın trendleri",
  "Голоса, которые быстрее всего набирают заказы": "En hızlı sipariş alan sesler",
  "Мужские": "Erkek",
  "Все мужские голоса библиотеки": "Kütüphanedeki tüm erkek sesler",
  "Женские": "Kadın",
  "Все женские голоса библиотеки": "Kütüphanedeki tüm kadın sesler",
  "Детские": "Çocuk",
  "Детские и мультяшные голоса": "Çocuk ve çizgi film sesleri",
  "меню: Озвучка": "Sesler",
  "Системная": "Sistem",
  "Для аватарки и ленты": "Avatar ve akış için",
  "Как снимок с телефона": "Telefon çekimi gibi",
  "Для ленты": "Akış için",
  "На весь экран телефона": "Tam telefon ekranı",
  "Для обложки и экрана": "Kapak ve ekran için",
  "Станет голосом по умолчанию для озвучки.": "Seslendirmeler için varsayılan ses olur.",
  "Когда генерация закончится": "Oluşturma bitince",
  "Награды и серия": "Ödüller ve seri",
  "Напомним о награде за день": "Günlük ödül hatırlatması",
  "Новые шаблоны и стили": "Yeni şablonlar ve stiller",
  "Не чаще раза в неделю": "Haftada en fazla bir kez",
  "Новости STEOS": "STEOS haberleri",
  "Только крупные обновления": "Yalnızca büyük güncellemeler",
  "Тут откроется документ в браузере": "Belge tarayıcıda açılacak",
  "Язык и валюта": "Dil ve para birimi",
  "Интерфейс и цены картой": "Arayüz ve kart fiyatları",
  "новое|новых|новых": "yeni",
  "работа|работы|работ": "iş",
  "заказ|заказа|заказов": "sipariş",
  "Счётчики недоступны": "Sayaçlar kullanılamıyor",
  "История пуста": "Geçmiş boş",
  "Не задан": "Ayarlanmadı",
  "Недоступны": "Kullanılamıyor",
  "Срок истёк": "Süresi doldu",
  "Не удалась": "Başarısız",
  "Готовится": "Hazırlanıyor",
  "Запрошено": "İstendi",
  "Запрошено {0}": "{0} istendi",
  "Недоступно": "Kullanılamıyor",
  "Пусто": "Boş",
  "Данные Mini App удалены": "Mini App verileri silindi",
  "Удаление данных не удалось": "Veriler silinemedi",
  "Данные удалены частично": "Veriler kısmen silindi",
  "Удаление требует проверки": "Silme işlemi inceleme gerektiriyor",
  "Запрос удаления принят": "Silme isteği alındı",
  "Удаляем данные Mini App": "Mini App verileri siliniyor",
  "Удаление данных в очереди": "Silme sırada",
  "STEOS ID сохранён": "STEOS ID korundu",
  "Финансовые квитанции сохранены": "Mali makbuzlar korundu",
  "Статус удаления не подтверждён": "Silme durumu doğrulanmadı",
  "Удаление аккаунта": "Hesap silme",
  "Удалить данные Mini App?": "Mini App verileri silinsin mi?",
  "Удалить аккаунт?": "Hesap silinsin mi?",
  "Работы, голоса и варианты «Вы» в Mini App удалятся. STEOS ID и финансовые квитанции сохранятся.": "Mini App'teki işleriniz, sesleriniz ve görünümleriniz silinecek. STEOS ID ve mali makbuzlar korunacak.",
  "Работы, голоса, варианты «Вы» и Circle удалятся. Вернуть их не получится.": "İşleriniz, sesleriniz, görünümleriniz ve Circle silinecek. Bu geri alınamaz.",
  "Удалить данные Mini App": "Mini App verilerini sil",
  "Удалить аккаунт": "Hesabı sil",
  "Данные Mini App. STEOS ID сохранится": "Yalnızca Mini App verileri. STEOS ID kalır",
  "Все данные удалятся навсегда": "Tüm veriler kalıcı olarak silinir",
  "В прототипе аккаунт не удаляется": "Prototipte hesap silinmez",
  "Автовоспроизведение": "Otomatik oynatma",
  "Пример при выборе голоса": "Ses seçerken örnek",
  "Присылать в чат": "Sohbete gönder",
  "Готовые работы от бота": "Botun hazır işleri",
  "Уведомления и отклик": "Bildirimler ve titreşim",
  "Данные": "Veriler",
  "Выгрузить данные": "Verileri dışa aktar",
  "Настройки создания сейчас только для чтения": "Oluşturma ayarları şu an salt okunur",
  "Формат по умолчанию": "Varsayılan format",
  "Для новых фото и видео": "Yeni fotoğraf ve videolar için",
  "На экране создания их можно поменять для одной работы.": "Oluşturma ekranında tek bir iş için değiştirebilirsiniz.",
  "Сообщения приходят в чат с ботом": "Mesajlar botla sohbete gelir",
  "Бот напишет только в ответ на действия": "Bot yalnızca işlemlerinize yanıt verir",
  "Уведомления пока недоступны": "Bildirimler henüz kullanılamıyor",
  "Вибрация": "Titreşim",
  "Лёгкий отклик на нажатия": "Dokunuşta hafif titreşim",
  "Выгрузка данных": "Veri dışa aktarma",
  "Выгрузка запрошена": "Dışa aktarma istendi",
  "Пришлём архив в чат в течение суток": "Arşivi 24 saat içinde sohbete göndereceğiz",
  "Настройки и доступные текстовые данные аккаунта": "Ayarlar ve hesabın erişilebilir metin verileri",
  "Ссылка на архив придёт в чат с ботом": "Arşiv bağlantısı botla sohbete gelecek",
  "Готовые работы и заказы": "Hazır işler ve siparişler",
  "Клоны и записи образцов": "Klonlar ve örnek kayıtlar",
  "Ваши фото и варианты себя": "Fotoğraflarınız ve görünümleriniz",
  "Люди и питомцы из фотосессий": "Fotoğraf çekimlerindeki kişiler ve evcil hayvanlar",
  "Запросить выгрузку": "Dışa aktarma iste",
  "Готовим архив": "Arşiv hazırlanıyor",
  "Это займёт несколько минут. Лист можно закрыть, выгрузка продолжится": "Birkaç dakika sürer. Kapatabilirsiniz, dışa aktarma devam eder",
  "Срок хранения архива истёк": "Arşivin süresi doldu",
  "Запросите новую выгрузку данных": "Yeni bir dışa aktarma isteyin",
  "Архив не собрался": "Arşiv oluşturulamadı",
  "Запросите выгрузку ещё раз": "Dışa aktarmayı tekrar isteyin",
  "Не вошли: {0}": "Dahil değil: {0}",
  "Вошли частично: {0}": "Kısmen dahil: {0}",
  "Не входят в выгрузку: {0}": "Dışa aktarmaya dahil değil: {0}",
  "Часть данных недоступна. Точный состав указан в manifest.json внутри архива": "Bazı veriler kullanılamıyor. Tam içerik arşivdeki manifest.json dosyasında",
  "Архив готов, но не полностью": "Arşiv hazır ama eksik",
  "Архив готов": "Arşiv hazır",
  "Скачать можно до {0}": "{0} tarihine kadar indirilebilir",
  "Архив в формате ZIP": "ZIP arşivi",
  "Скачать архив": "Arşivi indir",
  "Счётчики истории не загрузились": "Geçmiş sayaçları yüklenmedi",
  "Загружаем историю": "Geçmiş yükleniyor",
  "Проверьте связь и повторите загрузку": "Bağlantınızı kontrol edip tekrar deneyin",
  "История очищена": "Geçmiş temizlendi",
  "Голоса, варианты «Вы», близкие и Circle на месте": "Sesleriniz, görünümleriniz, sevdikleriniz ve Circle yerinde",
  "Здесь появятся работы, когда вы что-то создадите": "Bir şey oluşturduğunuzda işleriniz burada görünür",
  "Раздел «История»": "Geçmiş bölümü",
  "Работы": "İşler",
  "Фото, видео, кружки и озвучки": "Fotoğraflar, videolar, daireler ve seslendirmeler",
  "Заказы": "Siparişler",
  "Параметры и статусы генераций": "Oluşturma ayarları ve durumları",
  "Голоса, варианты «Вы», близкие и Circle останутся.": "Sesleriniz, görünümleriniz, sevdikleriniz ve Circle kalır.",
  "Удалить работы и заказы": "İşleri ve siparişleri sil",
  "Без возможности восстановления": "Geri alınamaz",
  "Подтверждение удаления": "Silmeyi onayla",
  "Попробовать: {0}": "Dene: {0}",
  "Обновление": "Güncelleme",
  "Загружаем «Что нового»": "Yenilikler yükleniyor",
  "Новых обновлений пока нет": "Henüz yeni güncelleme yok",
  "Уведомления сейчас не сохранить": "Bildirimler şu an kaydedilemiyor",
  "Настройки сейчас только для чтения": "Ayarlar şu an salt okunur",
  "Выгрузка не запросилась. Попробуйте ещё раз": "Dışa aktarma istenemedi. Tekrar deneyin",
  "Удалить всю историю?": "Tüm geçmiş silinsin mi?",
  "{0}. Вернуть не получится.": "{0}. Bu geri alınamaz.",
  "История не очистилась. Попробуйте ещё раз": "Geçmiş temizlenmedi. Tekrar deneyin",
  "Удаление не началось. Попробуйте ещё раз": "Silme başlamadı. Tekrar deneyin",
  "Не удалось загрузить настройки": "Ayarlar yüklenemedi",
  "«Что нового» не загрузилось": "Yenilikler yüklenmedi",
  "Сохранение настроек сейчас недоступно": "Ayarlar şu an kaydedilemiyor",
  "Настройки уже изменились, показываем актуальные": "Ayarlar değişti, güncel olanlar gösteriliyor",
  "Не удалось сохранить. Попробуйте ещё раз": "Kaydedilemedi. Tekrar deneyin",
  "Настройки, ресурсы и история": "Ayarlar, kaynaklar ve geçmiş",
  "Данные Mini App": "Mini App verileri",
  "Учётная запись и финансовые данные STEOS ID": "STEOS ID hesabı ve mali veriler",
  "Переписка с ботом": "Botla yazışma",
  "Фото, аудио, видео и модели": "Fotoğraflar, ses, videolar ve modeller",
  "Данные других продуктов STEOS": "Diğer STEOS ürünlerinin verileri",
  "Рубли": "Ruble",
  "Драмы": "Dram",
  "Евро": "Euro",
  "Доллары": "Dolar",
  "Другие языки": "Diğer diller",
  "Интерфейс и сообщения бота": "Arayüz ve bot mesajları",
  "Цены картой покажем в этой валюте. Звёзды Telegram везде одинаковые.": "Kart fiyatları bu para biriminde gösterilir. Telegram Yıldızları her yerde aynıdır.",
  "сегодня, {0}": "bugün, {0}",
  "вчера, {0}": "dün, {0}",
  "Старт": "Start",
  "Плюс": "Plus",
  "Про": "Pro",
  "Картой или СБП": "Kart veya SBP",
  "СБП только для РФ": "SBP yalnızca Rusya'da",
  "1 месяц": "1 ay",
  "3 месяца": "3 ay",
  "6 месяцев": "6 ay",
  "Год": "Yıl",
  "год": "1 yıl",
  "С днём рождения": "Doğum günün kutlu olsun",
  "С днём рождения. Пусть всё задуманное получается с первого раза": "İyi ki doğdun. Tüm planların ilk seferde gerçekleşsin",
  "Просто так": "Öylesine",
  "Просто так. Пусть у тебя будет больше кружков и смешных голосов": "Sadece öylesine. Daha çok daire ve komik ses için",
  "Спасибо": "Teşekkürler",
  "Спасибо, что ты рядом. Это маленький подарок от меня": "Yanımda olduğun için teşekkürler. Benden küçük bir hediye",
  "С праздником": "Bayramın kutlu olsun",
  "С праздником. Твори, снимай и удивляй": "Bayramın kutlu olsun. Üret, çek ve şaşırt",
  "Для блога": "Blogun için",
  "Для твоего блога: пусть ролики выходят чаще и легче": "Blogun için: daha çok ve daha kolay video",
  "Удачи": "Bol şans",
  "Удачи в новом проекте. Пусть голос и картинка будут такими, как задумано": "Yeni projende bol şans. Ses ve görüntü tam istediğin gibi olsun",
  "картой": "kartla",
  "оплата картой каждый месяц": "her ay kartla ödeme",
  "оплата картой за {0}": "{0} için kartla ödeme",
  "{0} в месяц": "ayda {0}",
  "{0} за {1}": "{1} için {0}",
  "кружок|кружка|кружков": "görüntülü mesaj",
  "рилс|рилса|рилсов": "reels",
  "свой голос|своих голоса|своих голосов": "kendi ses",
  "своего голоса|своих голосов|своих голосов": "kendi ses",
  "день|дня|дней": "gün",
  "звезда|звезды|звёзд": "yıldız",
  "Подписаться на {0}": "{0} abone ol",
  "Продлевается каждый месяц, отмена в любой момент": "Her ay yenilenir, istediğin zaman iptal",
  "Без автопродления, Circle приходят каждый месяц": "Otomatik yenileme yok, Circle her ay gelir",
  "Перейти на {0}": "{0} planına geç",
  "Сразу придут {0} C, а {1} больше не продлится": "{0} C hemen gelir, {1} artık yenilenmez",
  "Сразу придут {0} C": "{0} C hemen gelir",
  "Перейти на {0} с {1}": "{1} tarihinde {0} planına geç",
  "До {0} остаётся {1}, потом {2}": "{0} tarihine kadar {1}, sonra {2}",
  "Продлить на {0}": "{0} uzat",
  "Ещё {0} после {1}, без автопродления": "{1} sonrasında {0} daha, otomatik yenileme yok",
  "Следующее списание {0}, {1}": "Sonraki ödeme {0}, {1}",
  "Способ оплаты": "Ödeme yöntemi",
  "Звёздами": "Yıldızla",
  "Тестовая оплата": "Test ödemesi",
  "Звёзды и деньги не списываются": "Yıldız veya para alınmaz",
  "Оплата картой скоро": "Kartla ödeme yakında",
  "Ваш тариф": "Planınız",
  "выгоднее на {0}%": "%{0} daha avantajlı",
  "{0} C в месяц": "Ayda {0} C",
  "или": "veya",
  "Что сотворим в этом месяце?": "Bu ay ne yaratacaksın?",
  "Готовы творить без пауз?": "Durmadan üretmeye hazır mısın?",
  "Ваш тариф {0}": "Planınız: {0}",
  "{0} C каждый месяц": "Her ay {0} C",
  "До {0} {1}": "{0} {1} kadar",
  "Пакеты Circle, если не хватит": "Yetmezse Circle paketleri",
  "{0} включает": "{0} şunları içerir",
  "Сравнить": "Karşılaştır",
  "Помесячно": "Aylık",
  "Выгода {0}": "{0} kazanç",
  "Одним платежом": "Tek ödeme",
  "{0} с {1}": "{1} tarihinden itibaren {0}",
  "Оставить {0}": "{0} planında kal",
  "Продлить {0}": "{0} uzat",
  "Продлить": "Uzat",
  "Включить продление": "Yenilemeyi aç",
  "Возобновить {0}": "{0} planını sürdür",
  "Возобновить": "Sürdür",
  "Оплата пока не подключена": "Ödeme henüz bağlı değil",
  "Сейчас недоступно": "Şu an kullanılamıyor",
  "Переход на {0} на {1}": "{1} için {0} planına geçiş",
  "Переход на {0}": "{0} planına geçiş",
  "Продление {0} на {1}": "{0} planını {1} uzatma",
  "Подписка {0} на {1}": "{1} için {0}",
  "Как удобнее оплатить": "Nasıl ödemek istersin?",
  "Подарок друга": "Arkadaş hediyesi",
  "{0} на первый пакет {1} после подписки": "Abonelikten sonra {1} boyunca ilk pakette {0}",
  "Не загрузилось": "Yüklenmedi",
  "Прошлую операцию не проверить": "Son işlem kontrol edilemiyor",
  "разрешите хранение данных и откройте раздел снова": "veri depolamaya izin verip bölümü yeniden açın",
  "Оплата требует проверки": "Ödeme inceleme gerektiriyor",
  "Исход подтверждения оплаты ещё неизвестен": "Ödeme onayının sonucu henüz belli değil",
  "Исход отмены счёта неизвестен": "Fatura iptalinin sonucu belli değil",
  "Ждём подтверждения оплаты": "Ödeme onayı bekleniyor",
  "Исход прошлой операции неизвестен": "Son işlemin sonucu belli değil",
  "проверьте его перед новой покупкой": "yeni satın almadan önce kontrol edin",
  "Проверить": "Kontrol et",
  "Открыть оплату": "Ödemeyi aç",
  "Отменить счёт": "Faturayı iptal et",
  "Продление отменено": "Yenileme iptal edildi",
  "Сообщение со старым счётом может прийти. Оно не подтверждает новую подписку": "Eski faturalı bir mesaj gelebilir. Yeni aboneliği onaylamaz",
  "Продление требует проверки": "Yenileme inceleme gerektiriyor",
  "Счёт не подтверждён. Обновите данные или обратитесь в поддержку": "Fatura onaylanmadı. Yenileyin veya desteğe yazın",
  "Не удалось подготовить счёт": "Fatura hazırlanamadı",
  "Сервер повторит проверку. Текущие права не меняются": "Sunucu tekrar kontrol edecek. Mevcut erişiminiz değişmez",
  "Счёт отправлен": "Fatura gönderildi",
  "Бот прислал счёт. Подписка начнётся после подтверждённой оплаты": "Bot fatura gönderdi. Abonelik ödeme onaylanınca başlar",
  "Счёт подготовлен": "Fatura hazırlandı",
  "Передан боту. Доставка и оплата ещё не подтверждены": "Bota iletildi. Teslimat ve ödeme henüz onaylanmadı",
  "Срок счёта истёк": "Faturanın süresi doldu",
  "Продление не оплачено. Выберите тариф ещё раз": "Yenileme ödenmedi. Planı yeniden seçin",
  "Запланированное продление отменено": "Planlanan yenileme iptal edildi",
  "Текущий тариф не меняется. Для новой подписки потребуется отдельная оплата": "Mevcut planınız değişmez. Yeni abonelik için ayrı ödeme gerekir",
  "Продление запланировано": "Yenileme planlandı",
  "Счёт на свою подписку придёт в конце подарочного месяца": "Kendi aboneliğinizin faturası hediye ayının sonunda gelir",
  "Подарок ещё действует": "Hediye hâlâ geçerli",
  "Месячная подписка будет доступна после его окончания. Сейчас можно продлить на 3 или 12 месяцев": "Aylık abonelik bitince kullanılabilir. Şimdilik 3 veya 12 ay uzatabilirsiniz",
  "выберите другой тариф или срок": "başka bir plan veya süre seçin",
  "−{0}% на первый пакет · ещё {1}": "İlk pakette −%{0} · {1} kaldı",
  "Circle из пакетов не сгорают": "Paket Circle'ları yanmaz",
  "Подарить другу": "Arkadaşına hediye et",
  "С открыткой, без продления": "Kartla, yenilemesiz",
  "Промокод {0}": "Promosyon kodu {0}",
  "{0} C, сгорят {1}": "{0} C, {1} tarihinde yanar",
  "Промокод применён": "Promosyon kodu uygulandı",
  "{0} C и {1} на первый пакет": "{0} C ve ilk pakette {1}",
  "после подписки": "abonelikten sonra",
  "Вы пришли по ссылке партнёра": "Bir ortak bağlantısıyla geldiniz",
  "привязка уже действует": "bağlantı zaten etkin",
  "Есть промокод?": "Promosyon kodun mu var?",
  "Загружаем тарифы": "Planlar yükleniyor",
  "Счёт придёт {0}": "Fatura {0} tarihinde gelir",
  "Счёт придёт в конце текущего срока": "Fatura mevcut dönemin sonunda gelir",
  "Новый тариф начнётся после оплаты. Сейчас ничего не списывается.": "Yeni plan ödemeden sonra başlar. Şimdi hiçbir şey alınmaz.",
  "Оплата подтверждена": "Ödeme onaylandı",
  "Оплаченный период уже закончился. Circle за прошедший период не начисляются.": "Ödenen dönem sona erdi. Geçmiş dönemler için Circle yüklenmez.",
  "Баланс пополнен": "Bakiye yüklendi",
  "Теперь на балансе {0} C. Circle из пакетов не сгорают": "Bakiyeniz artık {0} C. Paket Circle'ları yanmaz",
  "следующие {0} C придут {1}": "sonraki {0} C {1} tarihinde gelir",
  "До этой даты действует {0}": "O tarihe kadar {0} geçerli",
  "{0} продлён до {1}": "{0} {1} tarihine kadar uzatıldı",
  "Circle приходят каждый месяц, {0}": "Circle her ay gelir, {0}",
  "Тариф {0} подключён": "{0} planı etkin",
  "Подписка {0} оформлена": "{0} aboneliği başladı",
  "Оплачено до {0}. Circle приходят каждый месяц, {1}": "{0} tarihine kadar ödendi. Circle her ay gelir, {1}",
  "Тестовая подписка действует до {0}. Звёзды и деньги не списываются": "Test aboneliği {0} tarihine kadar geçerli. Yıldız veya para alınmaz",
  "Circle действуют до {0}, тогда же следующее списание {1}": "Circle {0} tarihine kadar geçerli, sonraki ödeme o gün: {1}",
  "Circle действуют до {0}, продление выключено": "Circle {0} tarihine kadar geçerli, yenileme kapalı",
  "В месяц": "Aylık",
  "Кружки или фото": "Daire veya fotoğraf",
  "Видео говорит": "Video konuşuyor",
  "Рилсы": "Reels",
  "Сравнение тарифов": "Plan karşılaştırması",
  "В любом тарифе {0} {1} вместо {2}, все инструменты студии и пакеты Circle": "Her planda: {2} yerine {0} {1}, tüm stüdyo araçları ve Circle paketleri",
  "Следующее списание": "Sonraki ödeme",
  "Сумма": "Tutar",
  "Тестовая, без списаний": "Test, ödeme yok",
  "Картой": "Kartla",
  "Оплачено до": "Ödendiği tarih",
  "Действует до": "Geçerlilik",
  "Потом": "Sonra",
  "Продление": "Yenileme",
  "Счёт на {0} запланирован": "{0} faturası planlandı",
  "подписку": "abonelik",
  "Придёт {0}. Новый тариф начнётся после оплаты": "{0} tarihinde gelir. Yeni plan ödemeden sonra başlar",
  "Отменить": "İptal et",
  "Отменить подписку": "Aboneliği iptal et",
  "Тариф останется до {0}": "Plan {0} tarihine kadar kalır",
  "Потом тариф {0}": "Sonra {0}",
  "Подарок на месяц": "Bir aylık hediye",
  "Оплачено вперёд": "Peşin ödendi",
  "Подписка {0}": "{0} aboneliği",
  "Условия тарифа уточняются": "Plan ayrıntıları netleştiriliyor",
  "Сменить тариф": "Planı değiştir",
  "Отмена подписки": "Abonelik iptali",
  "Этот переход сейчас недоступен": "Bu geçiş şu an kullanılamıyor",
  "Переход уже назначен": "Geçiş zaten planlandı",
  "Выберите другой тариф": "Başka bir plan seçin",
  "С {0} начнётся этот тариф": "Bu plan {0} tarihinde başlar",
  "Это ваш тариф": "Bu sizin planınız",
  "К подписке": "Aboneliğe dön",
  "Сейчас {0}, {1}": "Şu an {0}, {1}",
  "Латиница, цифры и «_»": "Latin harfler, rakamlar ve _",
  "Ник начинается с буквы": "Harfle başlamalı",
  "Не короче 5 знаков": "En az 5 karakter",
  "Не длиннее 32 знаков": "En fazla 32 karakter",
  "Ник не кончается на _": "_ ile bitemez",
  "Это ваш ник": "Bu sizin kullanıcı adınız",
  "Сначала проверьте прежнюю операцию": "Önce önceki işlemi kontrol edin",
  "Подарок сейчас недоступен": "Hediye şu an kullanılamıyor",
  "Укажите ник друга в Telegram": "Arkadaşının Telegram kullanıcı adını girin",
  "Проверьте ник": "Kullanıcı adını kontrol edin",
  "Друг увидит: {0}": "Arkadaşın görecek: {0}",
  "Подарок придёт без имени": "Hediye isimsiz gelir",
  "{0} дарит вам": "{0} size hediye ediyor:",
  "вам подарили": "size hediye edildi:",
  "Вам подарили": "Size hediye edildi:",
  "{0} подписку STEOS {1} на месяц.": "{0} bir aylık STEOS {1} aboneliği.",
  "Забрать подарок": "Hediyeyi al",
  "От друга": "Bir arkadaştan",
  "{0} C и {1} {2}": "{0} C ve {1} {2}",
  "Подарить {0}": "{0} hediye et",
  "Тестовый подарок: звёзды и деньги не списываются": "Test hediyesi: yıldız veya para alınmaz",
  "На месяц, без продления": "Bir ay, yenilemesiz",
  "Тариф подарка": "Hediye planı",
  "Кому": "Kime",
  "ник друга в Telegram": "Telegram kullanıcı adı",
  "Ник друга в Telegram": "Arkadaşın Telegram kullanıcı adı",
  "Пожелание": "Mesaj",
  "Пара тёплых слов, по желанию": "Birkaç sıcak söz, isteğe bağlı",
  "Подписать от меня": "Benden olarak imzala",
  "Так увидит друг": "Arkadaşın böyle görecek",
  "Подарок оформлен для {0}": "{0} için hediye hazırlandı",
  "Подарок отправлен {0}": "Hediye {0} adresine gönderildi",
  "Бот прислал открытку со ссылкой «Забрать подарок» в подписи.": "Bot, açıklamasında “Hediyeyi al” bağlantısı olan bir kart gönderdi.",
  "Месяц {0} начнётся, когда друг заберёт подарок": "{0} ayı arkadaşın hediyeyi aldığında başlar",
  "Друг ещё не запускал STEOS? Перешлите открытку сами": "Arkadaşın STEOS'u henüz açmadı mı? Kartı kendin ilet",
  "Переслать": "İlet",
  "Загружаем подарок": "Hediye yükleniyor",
  "Вам подарок": "Size bir hediye",
  "Подписка STEOS на месяц": "Bir aylık STEOS aboneliği",
  "Этот подарок предназначен {0}. Перешлите получателю открытку со ссылкой.": "Bu hediye {0} için. Bağlantılı kartı ona iletin.",
  "Подарок уже получен": "Hediye zaten alındı",
  "Подарок добавлен": "Hediye eklendi",
  "Подписка {0} подключена": "{0} aboneliği etkin",
  "Circle подарка сгорят {0}": "Hediye Circle'ları {0} tarihinde yanar",
  "Месяц без продления, Circle действуют до {0}": "Bir ay, yenilemesiz, Circle {0} tarihine kadar geçerli",
  "У вас уже есть {0}: подарок добавит {1} C, они сгорят через месяц": "Zaten {0} planınız var: hediye bir ay içinde yanacak {1} C ekler",
  "Придут {0} C и {1} {2}. Подписка не продлится сама": "{0} C ve {1} {2} gelir. Abonelik kendiliğinden yenilenmez",
  "За последние 7 дней": "Son 7 gün",
  "Потрачено": "Harcanan",
  "Начислено": "Yüklenen",
  "Пакеты пока недоступны": "Paketler henüz kullanılamıyor",
  "Пакет": "Paket",
  "Оплата пакетов пока не подключена": "Paket ödemesi henüz bağlı değil",
  "Введите промокод": "Promosyon kodunu girin",
  "Применить": "Uygula",
  "Промокод партнёра работает до первой покупки, промокод STEOS можно применить один раз": "Ortak kodları ilk satın almaya kadar geçerli, STEOS kodu bir kez kullanılabilir",
  "От партнёра или от STEOS": "Bir ortaktan veya STEOS'tan",
  "Например, ANNA24": "Örneğin ANNA24",
  "Не удалось загрузить операции": "İşlemler yüklenemedi",
  "Начисление": "Yükleme",
  "Списание": "Harcama",
  "Загружаем операции": "İşlemler yükleniyor",
  "Журнал STEOS ID": "STEOS ID kaydı",
  "Операций пока нет": "Henüz işlem yok",
  "Применение не подтверждено. Проверьте прежний запрос": "Onaylanmadı. Önceki isteği kontrol edin",
  "Отменить подписку?": "Abonelik iptal edilsin mi?",
  "Тариф {0} останется до {1}, потом не продлится.": "{0} {1} tarihine kadar kalır, sonra yenilenmez.",
  "Оставить": "Kalsın",
  "Не удалось подготовить открытку": "Kart hazırlanamadı",
  "Откройте Mini App в Telegram, чтобы переслать открытку": "Kartı iletmek için Mini App'i Telegram'da açın",
  "Отправка отменена": "Gönderim iptal edildi",
  "Ссылка на подарок скопирована": "Hediye bağlantısı kopyalandı",
  "Не получилось. Попробуйте ещё раз": "Olmadı. Tekrar deneyin",
  "Счёт отменён": "Fatura iptal edildi",
  "Оплата не завершена": "Ödeme tamamlanmadı",
  "Подтверждение оплаты": "Ödeme onayı",
  "Проверяем подтверждение оплаты": "Ödeme onayı kontrol ediliyor",
  "Проверяем отмену счёта": "Fatura iptali kontrol ediliyor",
  "Telegram начал подтверждение счёта. Его исход ещё неизвестен. Не оплачивайте повторно: проверяйте этот счёт или обратитесь в поддержку.": "Telegram faturayı onaylamaya başladı. Sonuç henüz belli değil. Tekrar ödemeyin: bu faturayı kontrol edin veya desteğe yazın.",
  "Подарок будет оформлен после подтверждения сервера. Месяц подписки начнётся, когда друг заберёт подарок. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Hediye sunucu onayından sonra hazırlanır. Ay, arkadaşın hediyeyi aldığında başlar. Ödeme penceresinden dönmek ödemenin tamamlandığı anlamına gelmez.",
  "Circle поступят на баланс после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle sunucu onayından sonra yüklenir. Ödeme penceresinden dönmek ödemenin tamamlandığı anlamına gelmez.",
  "Circle и подписка появятся после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle ve abonelik sunucu onayından sonra görünür. Ödeme penceresinden dönmek ödemenin tamamlandığı anlamına gelmez.",
  "Не удалось открыть оплату. Проверьте прежний запрос": "Ödeme açılamadı. Önceki isteği kontrol edin",
  "Откройте Mini App в Telegram, чтобы оплатить звёздами": "Yıldızla ödemek için Mini App'i Telegram'da açın",
  "Оплата ещё не подтверждена сервером": "Sunucu ödemeyi henüz onaylamadı",
  "Открытка готова. Откройте Mini App в Telegram, чтобы переслать её": "Kart hazır. İletmek için Mini App'i Telegram'da açın",
  "Отменить счёт?": "Fatura iptal edilsin mi?",
  "Отменится только этот неоплаченный счёт. Текущая подписка останется. Если оплата уже подтверждается, сервер не разрешит отмену.": "Yalnızca bu ödenmemiş fatura iptal edilir. Mevcut aboneliğiniz kalır. Ödeme zaten onaylanıyorsa sunucu iptale izin vermez.",
  "Вернуться к оплате": "Ödemeye dön",
  "{0} на первый пакет после подписки": "Abonelikten sonra ilk pakette {0}",
  "{0} на первый пакет, ещё {1}": "İlk pakette {0}, {1} kaldı",
  "{0} на первый пакет": "İlk pakette {0}",
  "Промокод {0} применён": "{0} kodu uygulandı",
  "Circle сгорят {0}": "Circle {0} tarihinde yanar",
  "Circle начислены": "Circle yüklendi",
  "Привязка к партнёру подтверждена": "Ortak bağlantısı onaylandı",
  "Скидка {0}. Бонусные Circle сгорят {1}": "İndirim: {0}. Bonus Circle {1} tarihinde yanar",
  "Привязка к партнёру действует": "Ortak bağlantısı etkin",
  "{0} C и {1}": "{0} C ve {1}",
  "Открытка передана боту для доставки.": "Kart teslimat için bota iletildi.",
  "Бот готовит доставку открытки. Можно переслать её самостоятельно.": "Bot kartı teslim etmeye hazırlanıyor. Kendiniz de iletebilirsiniz.",
  "Доставка открытки не подтверждена. Можно переслать её самостоятельно.": "Teslimat onaylanmadı. Kartı kendiniz iletebilirsiniz.",
  "Сначала тратятся Circle со сроком: бонусные и по подписке, потом все остальные, а те, что можно вывести, в последнюю очередь.": "Önce süreli Circle harcanır (bonus ve abonelik), sonra diğerleri; çekilebilenler en son.",
  "Получатель не найден среди пользователей STEOS. Проверьте ник или попросите друга запустить бота.": "Alıcı STEOS kullanıcıları arasında bulunamadı. Kullanıcı adını kontrol edin veya arkadaşınızdan botu başlatmasını isteyin.",
  "Условия оплаты изменились. Обновите данные.": "Ödeme koşulları değişti. Lütfen yenileyin.",
  "Эту открытку может переслать только отправитель подарка.": "Bu kartı yalnızca hediyeyi gönderen iletebilir.",
  "Откройте чат с ботом и попробуйте ещё раз.": "Botla sohbeti açıp tekrar deneyin.",
  "Доставка получателю не подтверждена. Перешлите открытку самостоятельно.": "Alıcıya teslimat onaylanmadı. Kartı kendiniz iletin.",
  "Предложение не найдено. Обновите данные.": "Teklif bulunamadı. Lütfen yenileyin.",
  "Такого промокода нет": "Böyle bir kod yok",
  "Срок действия промокода закончился": "Bu kodun süresi doldu",
  "Этот промокод пока не действует": "Bu kod henüz geçerli değil",
  "Вы уже активировали этот промокод": "Bu kodu zaten kullandınız",
  "Промокод больше не действует": "Bu kod artık geçerli değil",
  "Это ваш промокод": "Bu sizin kendi kodunuz",
  "Партнёрские промокоды работают только до первой покупки": "Ortak kodları yalnızca ilk satın almadan önce geçerlidir",
  "Промокод партнёра временно недоступен": "Bu ortak kodu geçici olarak kullanılamıyor",
  "Вы уже привязаны к партнёру": "Zaten bir ortağa bağlısınız",
  "Получатель изменился. Отмените прежний неоплаченный счёт и проверьте ник перед новой покупкой.": "Alıcı değişti. Önceki ödenmemiş faturayı iptal edip yeni satın almadan önce kullanıcı adını kontrol edin.",
  "Пожелание должно быть не длиннее 200 знаков, без управляющих символов.": "Mesaj en fazla 200 karakter olmalı, kontrol karakteri içermemeli.",
  "Проверьте ник: получатель должен запускать STEOS, нельзя дарить себе": "Kullanıcı adını kontrol edin: alıcı STEOS'u başlatmış olmalı, kendinize hediye veremezsiniz",
  "Получатель сейчас занят. Повторите позже": "Alıcı şu an meşgul. Daha sonra tekrar deneyin",
  "Подарок не найден": "Hediye bulunamadı",
  "Этот подарок предназначен другому пользователю": "Bu hediye başka bir kullanıcı için",
  "Не удалось подтвердить условия продления. Обновите тарифы.": "Yenileme koşulları onaylanamadı. Planları yenileyin.",
  "Подписка изменилась. Обновите данные перед новым продлением.": "Aboneliğiniz değişti. Yeniden uzatmadan önce yenileyin.",
  "Продление уже запланировано. Его можно отменить в управлении подпиской.": "Yenileme zaten planlandı. Abonelik yönetiminden iptal edebilirsiniz.",
  "Запланированное продление отменено. Обновите данные.": "Planlanan yenileme iptal edildi. Lütfen yenileyin.",
  "Счёт будет доступен в конце текущего срока.": "Fatura mevcut dönemin sonunda kullanılabilir olacak.",
  "Месячная подписка будет доступна после окончания подарка. Сейчас можно продлить на 3 или 12 месяцев.": "Aylık abonelik hediye bitince kullanılabilir. Şimdilik 3 veya 12 ay uzatabilirsiniz.",
  "Предыдущее изменение подписки ещё проверяется. Повторите его проверку.": "Önceki abonelik değişikliği hâlâ kontrol ediliyor. Tekrar kontrol edin.",
  "Изменение подписки ещё не подтверждено Telegram.": "Telegram abonelik değişikliğini henüz onaylamadı.",
  "Подписка изменилась. Обновите данные и повторите проверку.": "Aboneliğiniz değişti. Yenileyip tekrar kontrol edin.",
  "Скидка уже закреплена за предыдущим счётом. Проверьте его оплату.": "İndirim önceki faturaya bağlandı. Ödemesini kontrol edin.",
  "Счёт уже подтверждается или недоступен для отмены. Проверьте результат оплаты.": "Fatura zaten onaylanıyor veya iptal edilemiyor. Ödeme sonucunu kontrol edin.",
  "Оплата требует проверки. Сервер сохранил платёж; права пока не подтверждены. Не оплачивайте повторно — проверьте результат позже или обратитесь в поддержку.": "Ödeme inceleme gerektiriyor. Sunucu ödemeyi kaydetti ama erişim henüz onaylanmadı. Tekrar ödemeyin — daha sonra kontrol edin veya desteğe yazın.",
  "Счёт отменён. Подписка и Circle по нему не начислены. Можно выбрать новую оплату.": "Fatura iptal edildi. Abonelik veya Circle yüklenmedi. Yeni bir ödeme başlatabilirsiniz.",
  "Оплата не завершена. Деньги и Circle не подтверждены; можно начать новую оплату.": "Ödeme tamamlanmadı. Para ve Circle onaylanmadı; yeni bir ödeme başlatabilirsiniz.",
  "Открытка готовится. Нажмите «Проверить», чтобы получить результат прежнего запроса.": "Kart hazırlanıyor. Sonucu görmek için “Kontrol et”e dokunun.",
  "Подарить подписку": "Abonelik hediye et",
  "Оплата подписки": "Abonelik ödemesi",
  "Итог оплаты": "Ödeme sonucu",
  "Подарок": "Hediye",
  "Пакет Circle": "Circle paketi",
  "лента: Хит": "Hit",
  "настройки: Очистить историю": "Geçmişi temizle",
  "Разделы, которых нет в меню": "Menüde olmayan bölümler",
  "Базовый": "Temel",
  "Продвинутый": "İleri",
  "Амбассадор": "Elçi",
  "задание ждёт|задания ждут|заданий ждут": "görev bekliyor",
  ", до +{0} C": ", en fazla +{0} C",
  "Серия {0}, задания на сегодня": "{0} seri, bugünün görevleri",
  "Задания на каждый день": "Günlük görevler",
  "Всё созданное в одном месте": "Tüm yaptıkların tek yerde",
  "Пока пусто: всё созданное будет здесь": "Şimdilik boş: yaptıkların burada görünecek",
  "{0}, последняя {1}": "{0}, sonuncusu {1}",
  "тариф {0}": "{0} planı",
  "без подписки": "abonelik yok",
  "{0}, {1}% с покупок": "{0}, alışverişlerden %{1}",
  "{0} уровень, {1}% с покупок": "{0} seviye, alışverişlerden %{1}",
  "До {0}% с покупок друзей": "Arkadaş alışverişlerinden %{0} kadar",
  "ИИ-агент ответит сразу": "Yapay zekâ asistanı hemen yanıtlar",
  "Черновики ролей и реплик": "Rol ve replik taslakları",
  "Тема, язык и валюта": "Tema, dil ve para birimi",
  "{0} ждут": "{0} bekliyor",
  "Тут Telegram откроет выбор чата: бот добавится в группу и будет работать там": "Telegram burada sohbet seçimini açar: bot gruba eklenir ve orada çalışır",
  "голос {0}": "ses {0}",
  "Искать в {0} {1}": "{0} {1} içinde ara",
  "работе|работах|работах": "iş",
  "Не прошло модерацию": "Moderasyondan geçmedi",
  "Бесплатно": "Ücretsiz",
  "Цена недоступна": "Fiyat yok",
  "Не удалось загрузить историю": "Geçmiş yüklenemedi",
  "Проверьте написание или поищите по номеру заказа": "Yazımı kontrol edin veya sipariş numarasıyla arayın",
  "Проверьте написание или поищите по названию, голосу или персонажу": "Yazımı kontrol edin veya ad, ses ya da karaktere göre arayın",
  "Сбросить поиск": "Aramayı temizle",
  "В этой вкладке пока пусто": "Burada henüz bir şey yok",
  "Отмечайте работы сердцем в карточке, чтобы быстро находить их здесь": "Burada hızlıca bulmak için işleri kalple işaretleyin",
  "Новые работы этого вида появятся здесь сами": "Bu türdeki yeni işler burada kendiliğinden görünecek",
  "Показать все": "Tümünü göster",
  "Поиск по истории": "Geçmişte ara",
  "Что показать": "Gösterilecekler",
  "Кружки, фото, видео, озвучки и тексты, которые вы создадите": "Oluşturduğunuz yuvarlak videolar, fotoğraflar, videolar, seslendirmeler ve metinler",
  "Открыть студию": "Stüdyo'yu aç",
  "{0}: шаг {1} из {2}. Открыть": "{0}: adım {1}/{2}. Aç",
  "Шаг {0} из {1}": "Adım {0}/{1}",
  "{0}: {1}. Открыть": "{0}: {1}. Aç",
  "Раскладка": "Düzen",
  "Широкий": "Geniş",
  "Инструмент": "Araç",
  "голос|голоса|голосов": "ses",
  "Как в оригинале": "Orijinaldeki gibi",
  "фото|фото|фото": "fotoğraf",
  "слайд|слайда|слайдов": "slayt",
  "снимок|снимка|снимков": "fotoğraf",
  "кадр|кадра|кадров": "kare",
  "Длительность записи": "Kayıt süresi",
  "Цена": "Fiyat",
  "Списание не подтверждено": "Kesinti onaylanmadı",
  "Кадры": "Kareler",
  "знак|знака|знаков": "karakter",
  "пункт|пункта|пунктов": "madde",
  "фраза|фразы|фраз": "ifade",
  "человек|человека|человек": "kişi",
  "Смотреть видео": "Videoyu izle",
  "символ|символа|символов": "karakter",
  "Дорожка": "Parça",
  "фрагмент 1:00": "1:00 parça",
  "вся песня": "şarkının tamamı",
  "образец|образца|образцов": "örnek",
  "Свой голос": "Kendi sesin",
  "{0} C списаны": "{0} C düşüldü",
  "Работа ещё создаётся. Результат появится здесь и придёт в чат": "Hâlâ oluşturuluyor. Sonuç burada ve sohbette görünecek",
  "Проверяем результат. Обычно это занимает пару минут": "Sonuç kontrol ediliyor. Bu genellikle birkaç dakika sürer",
  "Не прошло модерацию. Политику и запрещённые темы не пропускаем, {0}": "Moderasyondan geçmedi. Siyaset ve yasaklı konulara izin vermiyoruz. {0}",
  "Не прошло модерацию. {0}": "Moderasyondan geçmedi. {0}",
  "Не получилось. {0}": "Oluşturulamadı. {0}",
  "Не получилось. {0} C вернулись на баланс": "Oluşturulamadı. {0} C bakiyenize iade edildi",
  "Удалится только запись о заказе": "Yalnızca sipariş kaydı silinir",
  "Удаление из истории": "Geçmişten silme",
  "Смотреть: {0}": "İzle: {0}",
  "В этой работе нет файлов для просмотра": "Bu işte görüntülenecek dosya yok",
  "Вернуть запись в историю не получится.": "Kayıt geçmişe geri getirilemez.",
  "Файл в чате останется. Вернуть работу в историю не получится.": "Dosya sohbette kalır. İş geçmişe geri getirilemez.",
  "Отправка пока не подтвердилась. Нажмите ещё раз": "Gönderim henüz onaylanmadı. Tekrar dokunun",
  "Принято": "Alındı",
  "Бот пришлёт результат в чат": "Bot sonucu sohbete gönderecek",
  "Возврат обрабатывается": "İade işleniyor",
  "Не списано": "Kesilmedi",
  "Circle не списаны": "Circle kesilmedi",
  "Circle вернулись на баланс": "Circle bakiyenize iade edildi",
  "Списание пока не подтверждено": "Kesinti henüz onaylanmadı",
  "Возврат не подтверждён": "İade onaylanmadı",
  "Ожидаем подтверждения оплаты": "Ödeme bekleniyor",
  "история: Повторить": "Tekrarla",
  "история: Кружки": "Görüntülü mesajlar",
  "Фотосессия из селфи": "Selfie’den fotoğraf çekimi",
  "Рилс с вами": "Sizinle reels",
  "Фото говорит": "Fotoğraf konuşuyor",
  "Слайды с преимуществами": "Avantaj slaytları",
  "Карусель для поста": "Gönderi karuseli",
  "Коллаж из фото": "Fotoğraf kolajı",
  "Карточка для маркетплейса": "Pazaryeri kartı",
  "шаг|шага|шагов": "adım",
  "вопрос|вопроса|вопросов": "soru",
  "Открыть": "Aç",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку: {0}.": "Bu sorunun yanıtı doğrulanmadı. Önemliyse desteğe yazın: {0}.",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку.": "Bu sorunun yanıtı doğrulanmadı. Önemliyse desteğe yazın.",
  "Ответ ещё не пришёл. Проверим этот же вопрос, второй раз он не задастся.": "Henüz yanıt gelmedi. Aynı soruyu kontrol edeceğiz, ikinci kez gönderilmeyecek.",
  "Открыть профиль": "Profili aç",
  "Войти через STEOS ID": "STEOS ID ile giriş yap",
  "Тут Telegram откроет выбор чата": "Telegram burada sohbet seçimini açacak",
  "Разделы поддержки": "Destek bölümleri",
  "Ответит сразу": "Hemen yanıtlar",
  "Отвечает сразу": "Hemen yanıtlar",
  "Поддержка в Telegram, {0}": "Telegram’da destek, {0}",
  "Поддержка в Telegram": "Telegram’da destek",
  "Видео медленнее обычного": "Video normalden yavaş",
  "Видео работает медленнее обычного": "Video normalden yavaş çalışıyor",
  "Спросить ИИ‑агента поддержки": "Yapay zekâ destek ajanına sor",
  "Отвечает сразу и знает всё о STEOS": "Hemen yanıtlar, STEOS hakkında her şeyi bilir",
  "Поиск по вопросам и инструкциям": "Sorularda ve talimatlarda ara",
  "Шесть коротких сторис о главном": "Temel konularda altı kısa hikâye",
  "Попробуйте другие слова или спросите ИИ-агента": "Başka kelimeler deneyin veya yapay zekâ ajanına sorun",
  "Проверено в {0}": "Kontrol: {0}",
  "Заказы не теряются: результат придёт в чат, а если что-то сорвётся, Circle вернутся на баланс.": "Siparişler kaybolmaz: sonuç sohbete gelir, bir sorun olursa Circle bakiyenize geri döner.",
  "Сервисы": "Hizmetler",
  "Загружаем статус сервисов": "Hizmet durumu yükleniyor",
  "Загружаем справку": "Yardım yükleniyor",
  "Статус не загрузился": "Durum yüklenemedi",
  "Статус сервисов пока не отслеживается": "Hizmet durumu henüz izlenmiyor",
  "Если что-то не работает, напишите в поддержку": "Bir şey çalışmıyorsa desteğe yazın",
  "Часть сервисов работает с перебоями": "Bazı hizmetlerde aksaklık var",
  "Статусы ваших работ и подтверждённые возвраты смотрите в «Истории».": "İşlerinizin durumunu ve onaylanan iadeleri “Geçmiş” bölümünde görebilirsiniz.",
  "Справка не загрузилась": "Yardım yüklenemedi",
  "Справка пока не опубликована": "Yardım henüz yayımlanmadı",
  "Вопрос можно задать поддержке в Telegram": "Sorunuzu Telegram’da desteğe sorabilirsiniz",
  "Инструкции появятся после публикации справки": "Talimatlar yardım yayımlandıktan sonra görünecek",
  "Назад к ИИ-агенту": "Yapay zekâ ajanına dön",
  "Инструкция · {0}": "Rehber · {0}",
  "Вопрос · {0}": "Soru · {0}",
  "Справка": "Yardım",
  "Вопрос из Справки": "Yardım’dan soru",
  "Подробнее из Справки": "Yardım’da daha fazlası",
  "Назад по таблице": "Tabloda geri kaydır",
  "Вперёд по таблице": "Tabloda ileri kaydır",
  "Здравствуйте, {0}.": "Merhaba {0}.",
  "Здравствуйте.": "Merhaba.",
  "Я ИИ-агент поддержки STEOS: подскажу про тарифы и Circle, инструменты и шаблоны, промокоды, STEOS ID и партнёрство. Спросите своими словами или выберите вопрос.": "Ben STEOS yapay zekâ destek ajanıyım: tarifeler ve Circle, araçlar ve şablonlar, promosyon kodları, STEOS ID ve ortaklık programı konusunda yardımcı olurum. Kendi sözlerinizle sorun veya bir soru seçin.",
  "ИИ-агент печатает": "Yapay zekâ ajanı yazıyor",
  "ИИ-агент ещё отвечает": "Yapay zekâ ajanı hâlâ yanıtlıyor",
  "Напишите вопрос": "Bir soru yazın",
  "Диалог с ИИ-агентом": "Yapay zekâ ajanıyla sohbet",
  "Распознаём…": "Tanınıyor…",
  "Слушаю": "Dinliyorum",
  "Спросите о STEOS": "STEOS hakkında sorun",
  "Вопрос ИИ-агенту": "Yapay zekâ ajanına soru",
  "Остановить диктовку": "Dikteyi durdur",
  "Сказать голосом": "Sesle söyle",
  "Отправить": "Gönder",
  "Не удалось начать новый чат": "Yeni sohbet başlatılamadı",
  "Спасибо, учтём": "Teşekkürler, dikkate alacağız",
  "Спасибо, передадим команде": "Teşekkürler, ekibe ileteceğiz",
  "Оценка не сохранилась": "Değerlendirme kaydedilmedi",
  "Чат ещё загружается": "Sohbet hâlâ yükleniyor",
  "В чате уже {0} вопросов. Начните новый": "Bu sohbette zaten {0} soru var. Yeni bir sohbet başlatın",
  "Вопрос не сохранился. Попробуйте ещё раз": "Soru kaydedilmedi. Tekrar deneyin",
  "Некоторые сервисы работают медленнее обычного": "Bazı hizmetler normalden yavaş çalışıyor",
  "{0} не работают": "{0} çalışmıyor",
  "{0} не работает": "{0} çalışmıyor",
  "{0} медленнее обычного": "{0} normalden yavaş",
  "{0} работают медленнее обычного": "{0} normalden yavaş çalışıyor",
  "{0} работает медленнее обычного": "{0} normalden yavaş çalışıyor",
  "Микрофон здесь недоступен": "Mikrofon burada kullanılamıyor",
  "Нет доступа к микрофону": "Mikrofona erişim yok",
  "Нужна запись от 1 до 30 секунд": "Kayıt 1 ile 30 saniye arasında olmalı",
  "Не удалось разобрать запись": "Kayıt anlaşılamadı",
  "Диктовка не распозналась. Нажмите микрофон, чтобы проверить ещё раз": "Dikte tanınmadı. Tekrar kontrol etmek için mikrofona dokunun",
  "Вопрос не подошёл. Сформулируйте иначе": "Soru uygun değil. Farklı şekilde sorun",
  "Ответ не подтвердился. Напишите в поддержку": "Yanıt doğrulanmadı. Desteğe yazın",
  "Ответ не пришёл. Проверьте ещё раз": "Yanıt gelmedi. Tekrar kontrol edin",
  "Говорящий кружок, видео и фото говорят, повтори движения, свой аватар": "Konuşan yuvarlak video, Video konuşuyor, Fotoğraf konuşuyor, Hareketleri tekrarla, kendi avatarınız",
  "Оживить фото, видео по описанию, рилсы и сцены": "Fotoğrafı canlandır, açıklamadan video, reels ve sahneler",
  "Фото, фотосессии, товары, карусели": "Fotoğraflar, fotoğraf çekimleri, ürünler, karuseller",
  "Голоса, клон, озвучка проектов, кавер": "Sesler, klon, senaryo seslendirme, cover",
  "Звёзды Telegram и карты": "Telegram Stars ve kartlar",
  "Не работает": "Çalışmıyor",
  "Как сделать по шагам": "Adım adım",
  "Полезный ответ": "Faydalı yanıt",
  "Ответ не помог": "Yardımcı olmadı",
  "Проверьте связь и попробуйте ещё раз": "Bağlantınızı kontrol edip tekrar deneyin",
  "Не удалось проверить владельца чата": "Sohbet sahibi doğrulanamadı",
  "Не удалось восстановить чат. Начните новый": "Sohbet geri yüklenemedi. Yeni bir sohbet başlatın",
  "Клоны для озвучки": "Seslendirme klonları",
  "Создайте первый голос": "İlk sesinizi oluşturun",
  "Люди и питомцы для фото": "Fotoğraflar için kişiler ve evcil hayvanlar",
  "Добавьте близких для фото": "Fotoğraflar için sevdiklerinizi ekleyin",
  "Сохранённые работы": "Kaydedilen işler",
  "Отмечайте работы сердцем": "İşleri kalple işaretleyin",
  "Ежедневная серия и бонусы": "Günlük seri ve bonuslar",
  "Частые вопросы и связь с нами": "SSS ve iletişim",
  "Обучается": "Eğitiliyor",
  "Аккаунт недоступен": "Hesap kullanılamıyor",
  "Эта неделя · {0}": "Bu hafta · {0}",
  "Неделя с {0} · {1}": "{0} haftası · {1}",
  "ID скопирован": "ID kopyalandı",
  "Скопировать ID": "ID’yi kopyala",
  "Баланс временно недоступен": "Bakiye geçici olarak kullanılamıyor",
  "Разбивка остатка временно недоступна": "Bakiye dökümü geçici olarak kullanılamıyor",
  "Из них {0} C сгорит {1}|Из них {0} C сгорят {1}|Из них {0} C сгорят {1}": "Bunlardan {0} C, {1} tarihinde sona erer",
  "Ближайшие {0} C сгорят {1}": "Sıradaki {0} C, {1} tarihinde sona erer",
  "Circle каждый месяц от {0}": "Her ay Circle, {0} başlayan fiyatlarla",
  "Circle каждый месяц с подпиской": "Abonelikle her ay Circle",
  "Тариф временно недоступен": "Tarife geçici olarak kullanılamıyor",
  "Аккаунт, подписка и баланс": "Hesap, abonelik ve bakiye",
  "Статистика и моё": "İstatistikler ve Benimki",
  "{0} к прошлой неделе": "geçen haftaya göre {0}",
  "Работы по неделям: на этой неделе {0}": "Haftalık işler: bu hafta {0}",
  "Работы по неделям: на этой неделе {0}, на прошлой {1}": "Haftalık işler: bu hafta {0}, geçen hafta {1}",
  "Статистика пока недоступна": "İstatistikler henüz kullanılamıyor",
  "Дата регистрации недоступна": "Kayıt tarihi kullanılamıyor",
  "С {0}": "{0} itibarıyla",
  "Создано": "Oluşturulan",
  "Серия": "Seri",
  "день подряд|дня подряд|дней подряд": "gün üst üste",
  "Общий аккаунт STEOS": "Ortak STEOS hesabı",
  "Для вывода Circle": "Circle çekmek için",
  "До {0}% с их покупок": "Alışverişlerinden %{0}’a kadar",
  "Обновлено {0}": "Güncellendi: {0}",
  "Действия": "İşlemler",
  "Сохранить имя": "Adı kaydet",
  "Новое имя": "Yeni ad",
  "Больше голосов с подпиской": "Abonelikle daha fazla ses",
  "Создание голосов пока недоступно": "Ses oluşturma henüz kullanılamıyor",
  "Свободных мест нет": "Boş yer yok",
  "с подпиской до {0}": "abonelikle {0} adede kadar",
  "Пауза «{0}»": "“{0}” duraklat",
  "Прослушать «{0}»": "“{0}” dinle",
  "Переименовать": "Yeniden adlandır",
  "Запишите от 2 секунд речи или загрузите файлы, и голос будет звучать как вы": "2 saniyelik konuşma kaydedin veya dosya yükleyin, ses sizin gibi duyulsun",
  "Свободных мест нет. Удалите голос, чтобы записать новый": "Boş yer yok. Yeni ses kaydetmek için bir sesi silin",
  "Выбрать за «Вы»": "“Siz” olarak kullan",
  "голос по умолчанию": "varsayılan ses",
  "Сделать кружок с вариантом «{0}»": "“{0}” görünümüyle yuvarlak video yap",
  "Выбраны": "Seçildi",
  "{0} фото|{0} фото|{0} фото": "{0} fotoğraf",
  "{0} фото · для всех инструментов|{0} фото · для всех инструментов|{0} фото · для всех инструментов": "{0} fotoğraf · tüm araçlar için",
  "{0} вариант · кружки, фото и видео|{0} варианта · кружки, фото и видео|{0} вариантов · кружки, фото и видео": "{0} görünüm · yuvarlak video, fotoğraf, video",
  "{0} вариант|{0} варианта|{0} вариантов": "{0} görünüm",
  "Голос {0} удалён, у варианта {1} теперь голос по умолчанию.": "{0} sesi silindi, {1} görünümü artık varsayılan sesi kullanıyor.",
  "Голоса удалены, у вариантов {0} теперь голос по умолчанию.": "Sesler silindi, {0} görünümleri artık varsayılan sesi kullanıyor.",
  "Другой голос можно выбрать у каждого кружка": "Her yuvarlak video için başka ses seçebilirsiniz",
  "Вариантов пока нет": "Henüz görünüm yok",
  "Загрузите свои фото, и вариант себя будет говорить вашим голосом в кружках, фото и видео": "Fotoğraflarınızı yükleyin, görünümünüz yuvarlak video, fotoğraf ve videolarda sizin sesinizle konuşsun",
  "Вы: свои фото и варианты": "Siz: fotoğraflarınız ve görünümleriniz",
  "добавьте фото": "fotoğraf ekleyin",
  "Изменить «{0}»": "“{0}” düzenle",
  "{0} близкий · для фото и видео|{0} близких · для фото и видео|{0} близких · для фото и видео": "{0} sevdiğiniz · fotoğraf ve video için",
  "Люди и питомцы для фото и видео": "Fotoğraf ve video için kişiler ve evcil hayvanlar",
  "Близких пока нет": "Henüz sevdiğiniz kimse eklenmedi",
  "Добавьте людей и питомцев с фото, и они появятся в кадре рядом с вами": "Fotoğraflarıyla kişi ve evcil hayvan ekleyin, karede yanınızda görünsünler",
  "Открыть в «Истории»": "Geçmiş’te aç",
  "Вернуть в избранное": "Favorilere geri ekle",
  "{0} работа с сердцем|{0} работы с сердцем|{0} работ с сердцем": "Kalpli {0} iş",
  "Отмеченные сердцем работы": "Kalple işaretlenen işler",
  "Открыть «Историю»": "Geçmiş’i aç",
  "Не удалось загрузить избранное": "Favoriler yüklenemedi",
  "Закройте лист и откройте его ещё раз": "Pencereyi kapatıp yeniden açın",
  "Отмечайте работы сердцем в «Истории», и они соберутся здесь": "Geçmiş’te işleri kalple işaretleyin, burada toplansınlar",
  "Не удалось обновить. Попробуйте позже": "Güncellenemedi. Daha sonra deneyin",
  "Удалить голос «{0}»?": "“{0}” sesi silinsin mi?",
  "Голос пропадёт из списка. Вернуть его не получится.": "Ses listeden kaldırılacak. Geri getirilemez.",
  "Удалить вариант «{0}»?": "“{0}” görünümü silinsin mi?",
  "За «Вы» снова встанут ваши фото.": "“Siz” için yeniden fotoğraflarınız kullanılacak.",
  "Готовые кружки и фото с ним останутся в «Истории». Вернуть вариант не получится.": "Hazır yuvarlak videolar ve fotoğraflar Geçmiş’te kalır. Görünüm geri getirilemez.",
  "Не удалось удалить голос": "Ses silinemedi",
  "Не удалось удалить вариант. Попробуйте ещё раз": "Görünüm silinemedi. Tekrar deneyin",
  "«{0}»": "“{0}”",
  "подписка: до {0}": "{0} tarihine kadar",
  "варианты «Вы»: Новый вариант": "Yeni görünüm",
  "в очереди": "sırada",
  "идёт": "devam ediyor",
  "завершено": "tamamlandı",
  "не удалось": "başarısız",
  "слово подтверждения: УДАЛИТЬ": "SİL",
  "Выгрузка: {0}": "Dışa aktarma: {0}",
  "Удаление: {0}. STEOS ID и финансовые квитанции сохраняются.": "Silme: {0}. STEOS ID ve mali makbuzlar korunur.",
  "Введите {0}": "{0} yazın",
  "Перенос ещё не подтверждён. Проверка продолжится, откройте лист позже": "Aktarım henüz onaylanmadı. Kontrol sürecek, pencereyi daha sonra açın",
  "Этот STEOS ID уже связан с другим Telegram": "Bu STEOS ID zaten başka bir Telegram hesabına bağlı",
  "На обоих аккаунтах есть подписка. Для объединения напишите в поддержку": "İki hesapta da abonelik var. Birleştirmek için desteğe yazın",
  "Слишком много попыток. Попробуйте позже": "Çok fazla deneme. Daha sonra deneyin",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже": "STEOS ID bağlantısı şu anda kullanılamıyor. Daha sonra deneyin",
  "Не удалось создать аккаунт. Попробуйте позже": "Hesap oluşturulamadı. Daha sonra deneyin",
  "Не удалось отправить письмо": "E-posta gönderilemedi",
  "Фото не подошло. Выберите другое": "Fotoğraf uygun değil. Başka birini seçin",
  "Загрузите фото заново": "Fotoğrafı yeniden yükleyin",
  "Данные изменились. Откройте заново": "Veriler değişti. Yeniden açın",
  "подряд": "üst üste",
  "Начните {0}": "{0} başlatın",
  "серию": "Seri",
  "Завтра +{0} C": "Yarın +{0} C",
  "Заходите каждый день: награда растёт, на седьмой день {0} C. Пропуск дня начинает серию заново.": "Her gün girin: ödül büyür, yedinci gün {0} C. Bir günü kaçırırsanız seri baştan başlar.",
  "Забрать {0} C": "{0} C al",
  "Прогресс": "İlerleme",
  "Заданий здесь пока нет": "Burada henüz görev yok",
  "Время обновления недоступно": "Yenilenme zamanı bilinmiyor",
  "Новые через {0}": "{0} sonra yenilenir",
  "Выполнено {0} из {1}": "{0}/{1} tamamlandı",
  "друг|друга|друзей": "arkadaş",
  "{0} с вами": "{0} sizinle",
  "Прогресс друзей недоступен": "Arkadaş ilerlemesi alınamadı",
  "Пригласить": "Davet et",
  "Засчитываются друзья, которые пришли по вашей ссылке или промокоду и создали первую работу": "Bağlantınız veya promosyon kodunuzla gelip ilk işini oluşturan arkadaşlar sayılır",
  "Ещё {0} {1} до награды {2}": "{2} için {0} {1} daha",
  "Все ступени пройдены": "Tüm basamaklar tamamlandı",
  "Получено {0} из {1}": "{0}/{1} alındı",
  "Задания": "Görevler",
  "покупатель|покупателя|покупателей": "alıcı",
  "Партнёрская программа": "Ortaklık programı",
  "Партнёрам": "Ortaklara",
  "До {0}% {1}": "{1} %{0}'a kadar",
  "с покупок друзей": "Arkadaş alışverişlerinden",
  "Заработано {0} с покупок {1} {2}": "{1} {2} alışverişlerinden {0} kazanıldı",
  "друга|друзей|друзей": "arkadaşın",
  "Сами выбирайте: больше возможностей в STEOS или доход с рекомендаций.": "Siz seçin: STEOS'ta daha fazla olanak ya da tavsiyelerden gelir.",
  "Ещё {0} до уровня {1}": "{1} için {0} daha",
  "Максимальный уровень: вывод через STEOS ID": "En üst seviye: STEOS ID ile para çekme",
  "Статистика, материалы и вывод": "İstatistik, materyaller ve para çekme",
  "Исход прежнего запроса награды нужно проверить. Новые начисления пока заблокированы": "Önceki ödül isteğinin sonucu kontrol edilmeli. Yeni ödüller şimdilik engellendi",
  "Загружаем награды": "Ödüller yükleniyor",
  "Награды не загрузились": "Ödüller yüklenemedi",
  "Создайте 3 работы": "3 iş oluşturun",
  "Сделайте кружок": "Yuvarlak video yapın",
  "Персонаж или вы сами": "Bir karakter ya da siz",
  "Озвучьте текст": "Bir metni seslendirin",
  "Голосом героя или клона": "Karakter ya da klon sesiyle",
  "Улучшите описание": "Açıklamayı iyileştirin",
  "Бот допишет детали": "Bot ayrıntıları ekler",
  "Отправьте работу": "Bir işi paylaşın",
  "Из «Истории» в любой чат": "Geçmiş'ten herhangi bir sohbete",
  "Неделя кружков": "Yuvarlak video haftası",
  "Создайте 10 кружков за неделю": "Bir haftada 10 yuvarlak video oluşturun",
  "Исследователь": "Kâşif",
  "Попробуйте 5 разных инструментов студии": "5 farklı Stüdyo aracını deneyin",
  "Первый кружок": "İlk yuvarlak video",
  "Видеокружок для Telegram": "Telegram için yuvarlak video",
  "Клон голоса": "Ses klonu",
  "Всего 2 секунды речи": "Sadece 2 saniyelik konuşma",
  "Первое фото": "İlk fotoğraf",
  "Портрет в любом стиле": "Her tarzda portre",
  "Первый рилс с вами": "Sizinle ilk Reels",
  "Шаблон одной кнопкой": "Tek dokunuşla şablon",
  "Первый кавер": "İlk cover",
  "Песня другим голосом": "Başka bir sesle şarkı",
  "Кружки и видео с вами": "Sizinle yuvarlak ve normal videolar",
  "С вашей ссылкой": "Bağlantınızla",
  "Бот в чате": "Sohbette bot",
  "Добавьте бота в группу": "Botu bir gruba ekleyin",
  "Вход в STEOS ID": "STEOS ID ile giriş",
  "Один аккаунт с сайтом": "Siteyle tek hesap",
  "Первый друг": "İlk arkadaş",
  "3 друга": "3 arkadaş",
  "10 друзей": "10 arkadaş",
  "25 друзей": "25 arkadaş",
  "Первый покупатель": "İlk alıcı",
  "Первая оплата друга": "Arkadaşın ilk ödemesi",
  "{0} мин": "{0} dk",
  "{0} ч": "{0} sa",
  "Последний день": "Son gün",
  "Ещё {0} {1}": "{0} {1} kaldı",
  "Это задание выполняется вне мини-приложения": "Bu görev Mini App dışında yapılır",
  "Задание пока недоступно": "Görev henüz kullanılamıyor",
  "Прогресс временно недоступен": "İlerleme geçici olarak alınamıyor",
  "Не удалось восстановить прежний запрос награды. Проверьте баланс и напишите в поддержку": "Önceki ödül isteği geri yüklenemedi. Bakiyenizi kontrol edip destek ekibine yazın",
  "Награды временно недоступны. Попробуйте обновить данные": "Ödüller geçici olarak kullanılamıyor. Verileri yenilemeyi deneyin",
  "Награда подтверждена. Обновите данные: повторять начисление не нужно": "Ödül onaylandı. Verileri yenileyin: tekrar almanıza gerek yok",
  "Задание ещё не выполнено. Обновите прогресс": "Görev henüz tamamlanmadı. İlerlemeyi yenileyin",
  "Награда уже получена. Обновите данные": "Ödül zaten alındı. Verileri yenileyin",
  "Начисление не подтверждено. Проверьте прежний запрос: новая награда пока заблокирована": "Ödül onaylanmadı. Önceki isteği kontrol edin: yeni ödüller şimdilik engellendi",
  "Сначала обновите данные наград": "Önce ödül verilerini yenileyin",
  "Сначала проверьте прежний запрос награды": "Önce önceki ödül isteğini kontrol edin",
  "Рассказчик": "Anlatıcı",
  "Встреча на тракте": "Yolda karşılaşma",
  "Геральт": "Geralt",
  "Цири": "Ciri",
  "Дождь шёл третий день, и дорога к крепости почти исчезла под грязью.": "Yağmur üç gündür yağıyordu ve kaleye giden yol çamurun altında neredeyse kaybolmuştu.",
  "Ты опять ушла вперёд без меня. Я же просил ждать у моста.": "Yine bensiz önden gittin. Köprüde beklemeni söylemiştim.",
  "Я ждала. Целый час. Потом решила, что ты заблудился.": "Bekledim. Koca bir saat. Sonra kaybolduğunu düşündüm.",
  "Ведьмаки не блуждают. Мы иногда выбираем длинную дорогу.": "Witcher'lar kaybolmaz. Bazen uzun yolu seçeriz.",
  "Тогда в следующий раз выбирай её быстрее. Я замёрзла.": "O zaman bir dahaki sefere daha çabuk seç. Dondum.",
  "Он молча снял плащ и накинул ей на плечи. Впереди уже виднелись огни крепости.": "Sessizce pelerinini çıkarıp onun omuzlarına attı. İleride kalenin ışıkları görünüyordu.",
  "Пойдём. Весемир наверняка уже поставил суп на огонь.": "Hadi. Vesemir çorbayı çoktan ocağa koymuştur.",
  "Опять ты?": "Yine mi sen?",
  "Мне нужна помощь": "Yardıma ihtiyacım var",
  "Вставьте сценарий или начните с нуля": "Senaryo yapıştırın ya da sıfırdan başlayın",
  "Напишите хотя бы одну реплику": "En az bir replik yazın",
  "Сократите реплику: до {0} знаков": "Repliği kısaltın: en fazla {0} karakter",
  "Сократите проект: до {0} знаков": "Projeyi kısaltın: en fazla {0} karakter",
  "Озвучка проектов временно недоступна": "Senaryo seslendirme geçici olarak kullanılamıyor",
  "Выберите голос для каждой роли": "Her rol için bir ses seçin",
  "Озвучить · {0} C": "Seslendir · {0} C",
  "Без названия": "Adsız",
  "Роль": "Rol",
  "вчера": "dün",
  "Проекты": "Projeler",
  "роль|роли|ролей": "rol",
  "реплика|реплики|реплик": "replik",
  "Нет реплик": "Replik yok",
  "{0} знаков": "{0} karakter",
  "Строки «Имя: реплика» сами станут ролями и голосами": "“Ad: replik” satırları rollere ve seslere dönüşür",
  "Начать с нуля": "Sıfırdan başla",
  "Роли и реплики добавите сами": "Rolleri ve replikleri kendiniz ekleyin",
  "Открыть пример": "Örneği aç",
  "Проекты сохраняются сами: вернуться к ним можно в любой момент": "Projeler otomatik kaydedilir: istediğiniz zaman geri dönebilirsiniz",
  "Роль с именем персонажа сама получит его голос: Геральт, Цири, Йеннифэр": "Karakter adını taşıyan rol onun sesini alır: Geralt, Ciri, Yennefer",
  "Переименовать проект": "Projeyi yeniden adlandır",
  "Загрузить свежую": "Güncelini yükle",
  "{0}: голос {1}. Сменить голос": "{0}: ses {1}. Sesi değiştir",
  "Действия с ролью": "Rol işlemleri",
  "Озвучиваем": "Seslendiriliyor",
  "Действия с репликой": "Replik işlemleri",
  "Реплика: {0}": "Replik: {0}",
  "Реплик пока нет": "Henüz replik yok",
  "Нажмите «Реплика» внизу или вставьте готовый сценарий": "Aşağıdaki “Replik” düğmesine dokunun ya da hazır senaryo yapıştırın",
  "Реплика": "Replik",
  "за проект": "proje başına",
  "Цена — по числу знаков": "Fiyat karakter sayısına göre",
  "Добавить реплику": "Replik ekle",
  "проект|проекта|проектов": "proje",
  "{0} {1} · сохраняются сами": "{0} {1} · otomatik kaydedilir",
  "Пока ни одного": "Henüz yok",
  "Новый проект": "Yeni proje",
  "Вставить сценарий или начать с нуля": "Senaryo yapıştır ya da sıfırdan başla",
  "Удаление проекта": "Projeyi silme",
  "Новая роль": "Yeni rol",
  "Это первая реплика": "Bu ilk replik",
  "Это последняя реплика": "Bu son replik",
  "Удалить роль": "Rolü sil",
  "Вместе с её репликами": "Replikleriyle birlikte",
  "В проекте нужна хотя бы одна роль": "Projede en az bir rol olmalı",
  "Удалить роль «{0}»?": "“{0}” rolü silinsin mi?",
  "Вместе с ней уйдут {0} {1}.": "Onunla birlikte {0} {1} silinecek.",
  "Удалить проект?": "Proje silinsin mi?",
  "{0}. Роли и реплики удалятся, вернуть проект не получится.": "{0}. Roller ve replikler silinecek, proje geri getirilemez.",
  "Выбор голоса откроется в приложении": "Ses seçimi uygulamada açılır",
  "Не удалось удалить проект: {0}": "Proje silinemedi: {0}",
  "Не получилось открыть аудио": "Ses açılamadı",
  "Не получилось включить звук": "Ses çalınamadı",
  "Сначала напишите текст реплики": "Önce replik metnini yazın",
  "Аудио реплики пока недоступно": "Replik sesi henüz hazır değil",
  "Готовим роли": "Roller hazırlanıyor",
  "Роли готовы": "Roller hazır",
  "Озвучиваем реплики": "Replikler seslendiriliyor",
  "Реплики озвучены": "Replikler seslendirildi",
  "Собираем дорожку": "Ses kaydı birleştiriliyor",
  "Дорожка собрана": "Ses kaydı hazır",
  "дубль {0}": "{0}. kayıt",
  "Время реплики пока недоступно": "Replik zamanı henüz bilinmiyor",
  "Общий файл · {0}": "Tam dosya · {0}",
  "Аудио пока недоступно": "Ses henüz hazır değil",
  "Слушать дорожку": "Ses kaydını dinle",
  "реплика {0} из {1}": "replik {0}/{1}",
  "Проект не озвучен": "Proje seslendirilemedi",
  "Можно уйти с экрана: озвучка продолжится, дорожка появится здесь и в «Истории».": "Ekrandan çıkabilirsiniz: seslendirme sürecek, ses kaydı burada ve Geçmiş'te görünecek.",
  "Можно уйти с экрана: бот напишет, когда дорожка будет готова.": "Ekrandan çıkabilirsiniz: ses kaydı hazır olunca bot yazacak.",
  "Отправьте общий файл в чат или скачайте его. Любую реплику можно переозвучить отдельно.": "Tam dosyayı sohbete gönderin ya da indirin. Her replik ayrı ayrı yeniden seslendirilebilir.",
  "Бот уже прислал общий файл в чат, в отдельную тему. Любую реплику можно переозвучить отдельно.": "Bot tam dosyayı sohbette ayrı bir konuya gönderdi. Her replik ayrı ayrı yeniden seslendirilebilir.",
  "Сценарий не прошёл проверку": "Senaryo denetimden geçmedi",
  "проект не озвучен": "proje seslendirilmedi",
  "Не получилось собрать дорожку": "Ses kaydı birleştirilemedi",
  "К сценарию": "Senaryoya dön",
  "Звук дорожки не загрузился: скачайте файл": "Ses kaydı yüklenemedi: dosyayı indirin",
  "Каждая реплика с новой строки: имя, двоеточие, текст. Строка без имени достаётся предыдущей роли": "Her replik yeni satırda: ad, iki nokta, metin. Adsız satır önceki role gider",
  "голос персонажа": "karakter sesi",
  "Заменить сценарий": "Senaryoyu değiştir",
  "Сейчас {0} {1}, они уйдут": "Şu an {0} {1} var, silinecek",
  "реплику|реплики|реплик": "replik",
  "Заменить на {0} {1}": "{0} {1} ile değiştir",
  "Добавить {0} {1}": "{0} {1} ekle",
  "Заменить реплики": "Replikleri değiştir",
  "Добавить реплики": "Replik ekle",
  "Не нашли реплик: имя, двоеточие, текст": "Replik bulunamadı: ad, iki nokta, metin",
  "Вставьте сценарий в поле": "Senaryoyu alana yapıştırın",
  "Роли и голоса появятся сами": "Roller ve sesler kendiliğinden belirir",
  "Геральт: Опять ты. Что на этот раз? Цири: Мне нужна твоя помощь.": "Geralt: Yine mi sen. Bu sefer ne var?\nCiri: Yardımına ihtiyacım var.",
  "Сейчас нельзя": "Şu anda olmaz",
  "Вставьте текст в поле": "Metni alana yapıştırın",
  "Загружаем проекты": "Projeler yükleniyor",
  "Проекты не загрузились": "Projeler yüklenemedi",
  "Не хватает Circle: пополните баланс": "Yetersiz Circle: bakiyenizi yükleyin",
  "Цена: {0} C. Нажмите ещё раз, чтобы озвучить": "Fiyat: {0} C. Seslendirmek için tekrar dokunun",
  "Не удалось посчитать цену. Попробуйте ещё раз": "Fiyat hesaplanamadı. Tekrar deneyin",
  "Сценарий не прошёл проверку. Измените текст и попробуйте ещё раз.": "Senaryo denetimden geçmedi. Metni değiştirip tekrar deneyin.",
  "Не получилось собрать дорожку. Если Circle списались, они вернутся на баланс.": "Ses kaydı birleştirilemedi. Circle kesildiyse bakiyenize iade edilecek.",
  "Запуск не подтверждён": "Başlatma onaylanmadı",
  "Не получилось собрать дорожку.": "Ses kaydı birleştirilemedi.",
  "Повторная проверка не спишет Circle дважды.": "Tekrar kontrol etmek Circle'ı iki kez kesmez.",
  "Отправили в чат": "Sohbete gönderildi",
  "Отправка принята: бот пришлёт дорожку в чат": "Gönderim alındı: bot ses kaydını sohbete gönderecek",
  "Прослушивание реплики пока недоступно": "Replik dinleme henüz kullanılamıyor",
  "Прослушать реплику: {0} C. Нажмите ещё раз": "Repliği dinle: {0} C. Tekrar dokunun",
  "Переозвучка реплики пока недоступна": "Repliği yeniden seslendirme henüz kullanılamıyor",
  "Переозвучить реплику: {0} C. Нажмите ещё раз": "Repliği yeniden seslendir: {0} C. Tekrar dokunun",
  "Сохранение проектов сейчас недоступно. Обновите данные.": "Projeler şu anda kaydedilemiyor. Verileri yenileyin.",
  "Изменение проектов сейчас недоступно. Обновите данные.": "Projeler şu anda düzenlenemiyor. Verileri yenileyin.",
  "Проект ещё сохраняется. Попробуйте через секунду.": "Proje hâlâ kaydediliyor. Bir saniye sonra deneyin.",
  "Результат больше недоступен.": "Sonuç artık kullanılamıyor.",
  "Не удалось проверить владельца проекта.": "Proje sahibi doğrulanamadı.",
  "Операция не найдена. Проверьте историю.": "İşlem bulunamadı. Geçmişi kontrol edin.",
  "Проект ещё не сохранён.": "Proje henüz kaydedilmedi.",
  "Озвучка проектов сейчас недоступна. Обновите данные.": "Senaryo seslendirme şu anda kullanılamıyor. Verileri yenileyin.",
  "Прослушивание реплики сейчас недоступно. Обновите данные.": "Replik dinleme şu anda kullanılamıyor. Verileri yenileyin.",
  "Переозвучка реплики сейчас недоступна. Обновите данные.": "Repliği yeniden seslendirme şu anda kullanılamıyor. Verileri yenileyin.",
  "Дорожка ещё не готова.": "Ses kaydı henüz hazır değil.",
  "Аккаунт сменился. Обновите страницу.": "Hesap değişti. Sayfayı yenileyin.",
  "Отправка пока не подтверждена. Нажмите ещё раз, чтобы проверить прежний запрос.": "Gönderim henüz onaylanmadı. Önceki isteği kontrol etmek için tekrar dokunun.",
  "Результат проекта пока недоступен. Проверьте статус ещё раз.": "Proje sonucu henüz hazır değil. Durumu tekrar kontrol edin.",
  "Не удалось открыть аудио проекта.": "Proje sesi açılamadı.",
  "месяц|месяца|месяцев": "ay",
  "покупателя|покупателей|покупателей": "alıcı",
  "рабочий день|рабочих дня|рабочих дней": "iş günü",
  "друг купит|друга купят|друзей купят": "arkadaş",
  "покупателем|покупателями|покупателями": "alıcı",
  "Баннеры": "Bannerlar",
  "Постер": "Poster",
  "Голос героя": "Karakterin sesi",
  "Персонаж говорит": "Karakter konuşuyor",
  "Было и стало": "Önce ve sonra",
  "Подарок другу": "Arkadaşa hediye",
  "Кружок, который говорит": "Konuşan yuvarlak video",
  "Персонаж читает ваш текст": "Karakter metninizi okur",
  "Рилс с вами одной кнопкой": "Tek dokunuşla sizinle Reels",
  "Сюжет, монтаж и музыка в шаблоне": "Kurgu, montaj ve müzik şablonda",
  "Герой говорит": "Kahraman konuşuyor",
  "Герой говорит вашим текстом": "Kahraman metninizi söylüyor",
  "Голос и губы в такт": "Ses ve dudaklar uyumlu",
  "Старое фото как новое": "Eski fotoğraflar yeni gibi",
  "Цвет и резкость за минуту": "Bir dakikada renk ve netlik",
  "Кавер любым голосом": "Her sesle cover",
  "Рок, джаз или lo-fi": "Rock, caz veya lo-fi",
  "Фотосессия в любом образе": "Her tarzda fotoğraf çekimi",
  "По паре своих фото": "Birkaç fotoğrafınızdan",
  "Друзьям": "Arkadaşlara",
  "Личное сообщение": "Özel mesaj",
  "Подписчикам": "Takipçilere",
  "Пост в канал": "Kanal gönderisi",
  "Семье": "Aileye",
  "Сообщение родным": "Aileye mesaj",
  "Геймерам": "Oyunculara",
  "Чат по интересам": "İlgi alanı sohbeti",
  "Для работы": "İş için",
  "Коллегам и в рабочий чат": "İş arkadaşlarına ve iş sohbetine",
  "Авторам": "İçerik üreticilerine",
  "Блогерам и создателям роликов": "Blogerler ve video üreticileri",
  "Подарок по моему промокоду": "Promosyon kodumla hediye",
  "Кружки, фото и голос с ИИ прямо в Telegram": "Telegram'da yapay zekâyla yuvarlak video, fotoğraf ve ses",
  "Кружки с персонажами": "Karakterli yuvarlak videolar",
  "Пишете текст, персонаж его говорит": "Siz yazın, karakter söylesin",
  "Озвучка любым голосом": "Her sesle seslendirme",
  "Из библиотеки или своим клоном": "Kütüphaneden ya da kendi klonunuzla",
  "Фотосессия без студии": "Stüdyosuz fotoğraf çekimi",
  "Пара своих фото, любой образ": "Birkaç fotoğraf, her tarz",
  "{0} с регистрации по вашей ссылке или с первой покупки по промокоду. Всё это время процент идёт со всех оплат друга. Промокод работает только до первой покупки друга, а если друг пришёл по ссылке, промокод привязку уже не меняет.": "Bağlantınızla kayıttan ya da promosyon kodunuzla ilk satın almadan itibaren {0}. Bu süre boyunca arkadaşınızın tüm ödemelerinden yüzde alırsınız. Kod yalnızca arkadaşın ilk satın almasına kadar geçerlidir; arkadaş bağlantınızla geldiyse kod bağlantıyı artık değiştirmez.",
  "Что получает друг?": "Arkadaş ne alır?",
  "+{0} C сразу: они не выводятся и сгорают через {1}.": "+{0} C hemen: çekilemez ve {1} sonra yanar.",
  "Скидка {0}% на первый пакет Circle действует {1} после оформления подписки, потому что пакеты Circle продаются только с подпиской. Подарок один на аккаунт: по ссылке или по промокоду.": "İlk Circle paketinde %{0} indirim abonelikten sonra {1} geçerlidir, çünkü Circle paketleri yalnızca abonelikle satılır. Hesap başına bir hediye: bağlantıyla veya kodla.",
  "Что считается оплатой?": "Ödeme sayılan nedir?",
  "Подписка и пакеты Circle, оплаченные звёздами или картой. Процент считается от суммы, которую друг заплатил, со скидкой. Бонусные монеты, награды за задания и возвраты не учитываются.": "Yıldız veya kartla ödenen abonelikler ve Circle paketleri. Yüzde, arkadaşın indirimli ödediği tutardan hesaplanır. Bonus jetonlar, görev ödülleri ve iadeler sayılmaz.",
  "Какие бывают промокоды?": "Hangi promosyon kodları var?",
  "Ваш промокод партнёра даёт другу подарок и привязывает его к вам, работает только до его первой покупки. Промокоды STEOS публикует команда в канале и сообществе STEOS: они дают Circle со своим сроком и работают у всех, один раз на аккаунт.": "Ortak kodunuz arkadaşa hediye verir ve onu size bağlar; yalnızca ilk satın almasına kadar geçerlidir. STEOS kodlarını ekip STEOS kanalında ve topluluğunda yayınlar: kendi süresi olan Circle verir ve herkes için hesap başına bir kez çalışır.",
  "Когда приходят Circle?": "Circle ne zaman gelir?",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} их можно вывести.": "Arkadaşınız öder ödemez doğrudan bakiyenize. {0} seviyesinde onları çekebilirsiniz.",
  "Сразу после оплаты друга, прямо на баланс. На уровнях {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Arkadaşınız öder ödemez doğrudan bakiyenize. {0} seviyelerinde STEOS içinde kullanılır, {1} seviyesinde çekilebilir.",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Arkadaşınız öder ödemez doğrudan bakiyenize. {0} seviyesinde STEOS içinde kullanılır, {1} seviyesinde çekilebilir.",
  "Считаются ли друзья с истёкшей привязкой?": "Bağlantısı sona eren arkadaşlar sayılır mı?",
  "Да. Процент с их оплат больше не идёт, но в счёте уровня они остаются: уровень считается по всем покупателям за всё время.": "Evet. Ödemelerinden artık yüzde almazsınız ama seviyede sayılmaya devam ederler: seviye tüm zamanların alıcılarına göre hesaplanır.",
  "Кто может выводить?": "Kimler para çekebilir?",
  "Партнёры уровня {0} (от {1}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {2}.": "{0} seviyesindeki ortaklar ({1} ve üzeri), şahıs işletmesi, serbest çalışan veya yabancı eşdeğeri statüsüyle, STEOS ID ile girişten sonra. Çekim yalnızca hesaba para olarak: burada veya {2} üzerinde.",
  "Амбассадоры (от {0}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {1}.": "Elçiler ({0} ve üzeri), şahıs işletmesi, serbest çalışan veya yabancı eşdeğeri statüsüyle, STEOS ID ile girişten sonra. Çekim yalnızca hesaba para olarak: burada veya {1} üzerinde.",
  "Можно ли вывести монеты, заработанные до входа?": "Girişten önce kazanılan jetonlar çekilebilir mi?",
  "Да. Монеты Circle, заработанные на уровне {0} до входа через STEOS ID, ждут на балансе и станут доступны для вывода после входа.": "Evet. {0} seviyesinde STEOS ID ile girişten önce kazanılan Circle bakiyede bekler ve girişten sonra çekilebilir olur.",
  "Какие монеты тратятся первыми?": "Önce hangi jetonlar harcanır?",
  "Можно пригласить самого себя?": "Kendimi davet edebilir miyim?",
  "Нет. Покупки с вашего аккаунта и с повторных аккаунтов не учитываются.": "Hayır. Kendi hesabınızdan ve ikinci hesaplardan yapılan satın almalar sayılmaz.",
  "Международный": "Uluslararası",
  "Self-employed, sole trader или компания вне РФ": "Rusya dışında serbest çalışan, şahıs işletmesi veya şirket",
  "Самозанятый в РФ": "Rusya'da serbest çalışan",
  "Налог на профессиональный доход": "Mesleki gelir vergisi (NPD)",
  "ИП в РФ": "Rusya'da şahıs işletmesi",
  "Индивидуальный предприниматель": "Şahıs işletmesi sahibi",
  "Имя или компания": "Ad veya şirket",
  "Как в документах": "Belgelerdeki gibi",
  "TIN или номер в вашей стране": "TIN veya ülkenizdeki vergi numarası",
  "ФИО": "Ad soyad",
  "Как в паспорте": "Pasaporttaki gibi",
  "ИНН": "INN",
  "12 цифр": "12 hane",
  "Название ИП": "Şahıs işletmesi adı",
  "Как в выписке": "Sicil kaydındaki gibi",
  "ИНН или ОГРНИП": "INN veya OGRNIP",
  "От 10 до 15 цифр": "10–15 hane",
  "НДС": "KDV",
  "Плательщик НДС": "KDV mükellefi",
  "Адрес": "Adres",
  "КПП": "KPP",
  "ОГРН": "OGRN",
  "Основной офис STEOS": "STEOS merkez ofisi",
  "Платёжный агент STEOS в России": "STEOS'un Rusya'daki ödeme aracısı",
  "Тут откроется выбор чата Telegram с этим текстом, ссылкой и промокодом": "Burada bu metin, bağlantı ve kodla Telegram sohbet seçimi açılacak",
  "Тут откроется выбор чата Telegram: баннер уйдёт с подписью и кнопкой «Открыть STEOS»": "Burada Telegram sohbet seçimi açılacak: afiş açıklama ve «STEOS'u aç» düğmesiyle gider",
  "Ещё <b>{0} {1}</b> до уровня {2}": "{2} için <b>{0} {1}</b> daha",
  "Максимальный уровень": "En yüksek seviye",
  "До следующего уровня": "Sonraki seviyeye",
  "Получайте до&nbsp;{0}% <span>с&nbsp;покупок друзей</span>": "En fazla&nbsp;%{0} <span>arkadaş alışverişlerinden</span>",
  "Период": "Dönem",
  "Кого показать": "Göster",
  "Перешли": "Tıklama",
  "Зарегистрировались": "Kayıt",
  "Купили": "Satın aldı",
  "Пока нет данных": "Henüz veri yok",
  "{0} к прошлому периоду": "önceki döneme göre {0}",
  "за {0} {1}": "{0} {1} boyunca",
  "Пока не считаем": "Henüz sayılmıyor",
  "нет начислений": "kazanç yok",
  "Пик <b>{0} C</b>": "Zirve <b>{0} C</b>",
  "Начисления по месяцам": "Aylık kazanç",
  "Начисления по дням": "Günlük kazanç",
  "Здесь появятся начисления": "Kazancınız burada görünecek",
  "Подписка Про": "Pro abonelik",
  "Купила Circle": "Circle aldı",
  "Купил Circle": "Circle aldı",
  "Покупатель": "Alıcı",
  "по промокоду": "kodla",
  "привязка истекла": "bağlantı sona erdi",
  "Это весь список · {0}": "Liste bu kadar · {0}",
  "Друг привязан к вам {0}: с регистрации по ссылке или с первой покупки по промокоду. Промокод работает только до первой покупки друга.": "Arkadaş size {0} boyunca bağlı kalır: bağlantıyla kayıttan ya da kodla ilk satın almadan itibaren. Kod yalnızca arkadaşın ilk satın almasına kadar geçerlidir.",
  "Покупатели с истёкшей привязкой остаются в счёте уровня.": "Bağlantısı sona eren alıcılar seviyede sayılmaya devam eder.",
  "Пока никого": "Henüz kimse yok",
  "Поделитесь ссылкой или промокодом, первые друзья появятся здесь": "Bağlantınızı veya kodunuzu paylaşın, ilk arkadaşlarınız burada görünecek",
  "Картинка": "Görsel",
  "Ссылка и промокод уже на картинке. Нажмите на шаблон, чтобы поправить подпись и опубликовать.": "Bağlantı ve kod zaten görselde. Açıklamayı düzenleyip paylaşmak için bir şablona dokunun.",
  "{0}, открыть и опубликовать": "{0}, aç ve paylaş",
  "Для Reels, Shorts, TikTok и VK Клипов. Промокод и ссылка уже в кадре, бот пришлёт ролик в чат.": "Reels, Shorts, TikTok ve VK Clips için. Kod ve bağlantı zaten karede, bot videoyu sohbete gönderir.",
  "{0}, открыть": "{0}, aç",
  "Ссылка и промокод уже в тексте. Скопируйте его или отправьте в чат.": "Bağlantı ve kod zaten metinde. Kopyalayın veya sohbete gönderin.",
  "Картинка уйдёт в чат с подписью и кнопкой «Открыть STEOS». Подойдёт для групп, каналов и личных сообщений.": "Görsel, açıklama ve «STEOS'u aç» düğmesiyle sohbete gider. Gruplar, kanallar ve özel mesajlar için uygun.",
  "Баннер «{0}» с вашим промокодом": "Kodunuzla «{0}» afişi",
  "QR-постер: код ведёт на вашу ссылку, промокод {0}": "QR afişi: kod bağlantınıza gider, promosyon kodu {0}",
  "Кружки, фото и голос с ИИ": "Yapay zekâyla yuvarlak video, fotoğraf ve ses",
  "+{0}&nbsp;C на старт по промокоду": "Kodla başlangıçta +{0}&nbsp;C",
  "Начните по ссылке или промокоду": "Bağlantı veya kodla başlayın",
  "Наведите камеру телефона": "Telefon kamerasını tutun",
  "A4 для печати: стойки, витрины, визитки. Код ведёт на вашу ссылку, а промокод под ним можно ввести и без камеры.": "Baskı için A4: standlar, vitrinler, kartvizitler. QR bağlantınıza gider, altındaki kod kamerasız da girilebilir.",
  "Цвет постера": "Afiş rengi",
  "Прислать PDF в чат": "PDF'i sohbete gönder",
  "Вывести": "Çek",
  "Заявка на {0} C не подтверждена": "{0} C talebi onaylanmadı",
  "Вывод сейчас недоступен": "Para çekme şu an kullanılamıyor",
  "Вывод недоступен": "Kullanılamıyor",
  "Деньгами на ваш счёт за {0}": "{0} içinde hesabınıza",
  "Вывод от {0} C": "En az {0} C çekilebilir",
  "Вывод заработает после входа через STEOS ID": "Para çekme STEOS ID ile girişten sonra açılır",
  "Войдите через STEOS ID": "STEOS ID ile giriş yapın",
  "Вывод доступен на уровне {0}, от {1}": "Para çekme {0} seviyesinde, {1} ve üzeri",
  "Нужен уровень {0}": "{0} seviyesi gerekli",
  "Вывод откроется на уровне {0}, от {1}. Пока Circle работают внутри STEOS": "Para çekme {0} seviyesinde açılır, {1} ve üzeri. Şimdilik Circle STEOS içinde kullanılır",
  "Не подключён": "Bağlı değil",
  "Вход свяжет аккаунт бота с общим аккаунтом STEOS: баланс станет общим, а вывод заработает здесь и на сайте STEOS ID.": "Giriş, bot hesabınızı ortak STEOS hesabınıza bağlar: bakiye ortak olur, para çekme burada ve STEOS ID sitesinde çalışır.",
  "Выплачено": "Ödendi",
  "В обработке": "İşleniyor",
  "Отклонено": "Reddedildi",
  "Не удалось загрузить историю выводов": "Para çekme geçmişi yüklenemedi",
  "Выводов пока не было": "Henüz para çekilmedi",
  "за всё время": "tüm zamanlar",
  "Можно вывести": "Çekilebilir",
  "Тестовая программа: настоящих выплат нет": "Test programı: gerçek ödeme yok",
  "Баланс и выводы есть и на {0}.": "Bakiye ve para çekme {0} üzerinde de var.",
  "Вопрос о выводе?": "Para çekmeyle ilgili soru mu?",
  "Напишите в поддержку": "Desteğe yazın",
  "Поделитесь ссылкой или промокодом": "Bağlantınızı veya kodunuzu paylaşın",
  "Друг привязывается к вам на {0}": "Arkadaş size {0} boyunca bağlanır",
  "Друг получает подарок": "Arkadaş hediye alır",
  "+{0} C сразу и −{1}% на первый пакет Circle после подписки": "Hemen +{0} C ve abonelikten sonra ilk Circle paketinde −%{1}",
  "Друг платит в STEOS": "Arkadaş STEOS'ta öder",
  "Подписка и пакеты Circle звёздами или картой": "Yıldız veya kartla abonelik ve Circle paketleri",
  "Вам приходит процент": "Size yüzde gelir",
  "{0}% с каждой оплаты, сразу на баланс": "Her ödemeden %{0}, doğrudan bakiyeye",
  "Шаг {0}": "Adım {0}",
  "От {0}": "En az {0}",
  "С первого дня": "İlk günden",
  "Если {0} {1} {2}": "{0} {1} {2} alırsa",
  "{0} C за {1}": "{1} boyunca {0} C",
  "Хватит на {0} в месяц": "Ayda {0} için yeter",
  "Кружок стоит {0} C": "Bir yuvarlak video {0} C",
  "Считаем по подписке {0}: {1} в месяц, это {2}&nbsp;C. Процент идёт с каждой оплаты друга {3} привязки.": "{0} aboneliğine göre: ayda {1}, yani {2}&nbsp;C. Yüzde, {3} boyunca arkadaşın her ödemesinden gelir.",
  "Уровень считается вместе с вашими {0}.": "Mevcut alıcılarınız da seviyeye sayılır: {0}.",
  "Калькулятор дохода": "Gelir hesaplayıcı",
  "Тариф друзей": "Arkadaşların tarifesi",
  "Сколько друзей купят подписку": "Kaç arkadaş abonelik alır",
  "Вы получите": "Kazancınız",
  "C в месяц": "C / ay",
  "Проценты, сроки и ограничения": "Yüzdeler, süreler ve sınırlar",
  "Circle можно вывести": "Circle çekilebilir",
  "Circle работают внутри STEOS": "Circle STEOS içinde kullanılır",
  "Привязка на {0}": "{0} bağlılık",
  "Процент идёт со всех оплат друга: с регистрации по ссылке или с первой покупки по промокоду": "Arkadaşın tüm ödemelerinden yüzde: bağlantıyla kayıttan ya da kodla ilk satın almadan itibaren",
  "Ссылка главнее промокода": "Bağlantı koddan önceliklidir",
  "Если друг пришёл по ссылке, промокод привязку уже не меняет": "Arkadaş bağlantıyla geldiyse kod bağlılığı değiştirmez",
  "Промокод только до первой покупки": "Kod yalnızca ilk alışverişe kadar",
  "После первой оплаты друга ваш промокод партнёра у него не работает": "Arkadaşın ilk ödemesinden sonra ortak kodunuz onun için çalışmaz",
  "{0} C сразу, сгорят через {1}. {2} на первый пакет Circle {3} после подписки": "Hemen {0} C, {1} sonra yanar. Abonelikten sonra {3} boyunca ilk Circle paketinde {2}",
  "Только уровень {0}": "Yalnızca {0} seviyesi",
  "От {0} {1}, после входа через STEOS ID. Для ИП, самозанятых и их аналогов в других странах": "En az {0} {1}, STEOS ID ile girişten sonra. Şahıs işletmeleri, serbest çalışanlar ve diğer ülkelerdeki eşdeğerleri için",
  "Счёт на компанию STEOS": "STEOS şirketine fatura",
  "Плательщик появится, когда вывод откроется": "Ödeyen, para çekme açılınca görünür",
  "В РФ: {0}, в рублях. Международный статус: {1}, в евро": "Rusya’da: {0}, ruble ile. Uluslararası statü: {1}, euro ile",
  "Выплата за {0}": "{0} içinde ödeme",
  "После проверки счёта, от {0} C": "Fatura kontrolünden sonra, en az {0} C",
  "Коротко о главном": "Kısaca en önemlisi",
  "Здесь краткое изложение. Полный текст условий на {0}": "Bu bir özettir. Tam koşullar {0} üzerinde",
  "Понятно": "Anladım",
  "У вас {0}.": "Şu an {0} var.",
  "Покупателей пока нет.": "Henüz alıcı yok.",
  "Уровень считается по всем покупателям за всё время, с истёкшей привязкой тоже.": "Seviye, bağlantısı sona erenler dahil tüm zamanların alıcılarına göre hesaplanır.",
  "Введите сумму": "Tutar girin",
  "Можно вывести не больше {0} C": "En fazla {0} C çekilebilir",
  "Заполните реквизиты": "Bilgileri doldurun",
  "Загрузите счёт на оплату": "Fatura yükleyin",
  "Счёт ещё проверяется": "Fatura hâlâ kontrol ediliyor",
  "Выплата в {0} · 1 C = {1} {0}": "{0} ile ödeme · 1 C = {1} {0}",
  "Вывести {0} C": "{0} C çek",
  "Счёт выставьте в {0}. Проверим его, и деньги придут за {1}.": "Faturayı {0} cinsinden kesin. Kontrol ettikten sonra para {1} içinde gelir.",
  "Счёт выставьте в евро. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Faturayı euro cinsinden kesin. Kontrol ettikten sonra para {0} içinde gelir. Bilgiler STEOS ID’de saklanır.",
  "Счёт выставьте в рублях. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Faturayı ruble cinsinden kesin. Kontrol ettikten sonra para {0} içinde gelir. Bilgiler STEOS ID’de saklanır.",
  "Скопировать {0}": "{0} kopyala",
  "юридический адрес": "yasal adres",
  "Скопировать название компании": "Şirket adını kopyala",
  "Скопировать все реквизиты": "Tüm bilgileri kopyala",
  "Реквизиты для счёта": "Fatura bilgileri",
  "Проверяем счёт…": "Fatura kontrol ediliyor…",
  "PDF, JPG или PNG, до 10 МБ": "PDF, JPG veya PNG, en fazla 10 MB",
  "Можно вывести {0} C": "{0} C çekilebilir",
  "Сумма, C": "Tutar, C",
  "Сумма вывода, C": "Çekim tutarı, C",
  "Всё": "Tümü",
  "Придёт на счёт": "Hesabınıza gelecek",
  "Реквизиты": "Bilgiler",
  "Счёт на оплату": "Fatura",
  "Заявка на вывод принята": "Para çekme talebi alındı",
  "{0} придут за {1} после проверки счёта": "{0}, fatura kontrolünden sonra {1} içinde gelir",
  "Ролик принят в обработку": "Video hazırlanıyor",
  "Ролик в чате с ботом": "Video bot sohbetinde",
  "Бот пришлёт его после подготовки. Доставка пока не подтверждена.": "Bot hazır olunca gönderecek. Teslimat henüz onaylanmadı.",
  "Сохраните его и выложите в Reels, Shorts, TikTok или VK Клипы": "Kaydedin ve Reels, Shorts, TikTok veya VK Clips’te paylaşın",
  "Промокод и ссылка уже в кадре. Бот пришлёт ролик в чат, оттуда его можно сохранить и выложить.": "Kod ve bağlantı zaten karede. Bot videoyu sohbete gönderir, oradan kaydedip paylaşabilirsiniz.",
  "Прислать в чат": "Sohbete gönder",
  "Текст выделен: скопируйте его вручную": "Metin seçildi: elle kopyalayın",
  "Баннер готов: отправить его в чат можно из Telegram": "Afiş hazır: Telegram’dan sohbete gönderebilirsiniz",
  "PDF принят в очередь": "PDF sıraya alındı",
  "PDF в чате": "PDF sohbette",
  "Не удалось загрузить период. Попробуйте ещё раз": "Dönem yüklenemedi. Tekrar deneyin",
  "Без начислений": "Kazanç yok",
  "Значение выделено: скопируйте его вручную": "Değer seçildi: elle kopyalayın",
  "Реквизиты выделены: скопируйте их вручную": "Bilgiler seçildi: elle kopyalayın",
  "Нужен файл PDF, JPG или PNG": "PDF, JPG veya PNG dosyası gerekli",
  "Файл {0}, можно до 10 МБ": "Dosya {0}, en fazla 10 MB",
  "Партнёрство не загрузилось": "Ortaklık yüklenmedi",
  "Загружаем партнёрскую программу": "Ortaklık programı yükleniyor",
  "за неделю": "bir haftada",
  "за месяц": "bir ayda",
  "Для вывода войдите через STEOS ID": "Para çekmek için STEOS ID ile giriş yapın",
  "Вывод недоступен на текущем уровне": "Mevcut seviyede para çekilemez",
  "Сумма больше доступной": "Tutar kullanılabilir miktarı aşıyor",
  "Сумма меньше минимальной": "Tutar asgari tutarın altında",
  "Проверьте реквизиты и счёт": "Bilgileri ve faturayı kontrol edin",
  "Счёт ещё не проверен. Загрузите его заново": "Fatura henüz doğrulanmadı. Yeniden yükleyin",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены": "Yanıt alınamadı. Aynı talebi kontrol edin: verileri ve anahtarı kayıtlı",
  "Не удалось загрузить список друзей": "Arkadaş listesi yüklenemedi",
  "Не удалось восстановить прежнюю заявку. Напишите в поддержку перед новой": "Önceki talep geri yüklenemedi. Yenisinden önce desteğe yazın",
  "Партнёрская программа временно недоступна": "Ortaklık programı geçici olarak kullanılamıyor",
  "Не удалось загрузить следующую страницу": "Sonraki sayfa yüklenemedi",
  "Не удалось подготовить баннер. Попробуйте ещё раз": "Afiş hazırlanamadı. Tekrar deneyin",
  "Бот не может подготовить материал: откройте чат с ботом и попробуйте ещё раз": "Bot materyali hazırlayamıyor: bot sohbetini açıp tekrar deneyin",
  "Материал сейчас недоступен": "Materyal şu an kullanılamıyor",
  "Отправка не подтверждена. Нажмите ещё раз: повтор проверит прежний запрос": "Gönderim onaylanmadı. Tekrar dokunun: önceki istek kontrol edilir",
  "Прежняя отправка не восстановлена. Напишите в поддержку": "Önceki gönderim geri yüklenemedi. Desteğe yazın",
  "Прежняя отправка подтверждена. Нажмите ещё раз": "Önceki gönderim onaylandı. Tekrar dokunun",
  "Отправка не подтверждена": "Gönderim onaylanmadı",
  "Счёт не прошёл проверку. Выберите PDF, JPG или PNG до 10 МБ": "Fatura kontrolden geçmedi. En fazla 10 MB PDF, JPG veya PNG seçin",
  "Не удалось безопасно сохранить заявку. Отправка не выполнена": "Talep güvenle kaydedilemedi. Gönderilmedi",
  "Тут откроется инструмент «{0}»": "“{0}” aracı burada açılacak",
  "Геральт, Цири и ещё 2 400 голосов скажут всё, что напишете": "Geralt, Ciri ve 2.400 ses daha yazdığınız her şeyi söyler",
  "Снимите себя, и персонаж повторит ваши движения": "Kendinizi çekin, karakter hareketlerinizi tekrarlasın",
  "Выберите образ, и через минуту готовы 3 кадра из одного селфи": "Bir tarz seçin, bir dakikada tek selfie’den 3 kare hazır",
  "Сделать": "Oluştur",
  "2 400 голосов, 19 языков": "2.400 ses, 19 dil",
  "Текст в речь голосом персонажа или своим клоном": "Metni karakter sesiyle ya da kendi klonunuzla seslendirin",
  "Ваш голос за две минуты": "İki dakikada kendi sesiniz",
  "Запишите образец, и клон появится во всех инструментах с озвучкой": "Bir örnek kaydedin, klon tüm seslendirme araçlarında görünsün",
  "Движения": "Hareketler",
  "бесплатно": "ücretsiz",
  "/сек": "/sn",
  "готов": "hazır",
  "Клон · готов": "Klon · hazır",
  "студия: Мой голос": "Benim sesim",
  "Сейчас в тренде": "Şu an trend",
  "Популярное за неделю": "Haftanın popülerleri",
  "Геральт скажет ваш текст": "Geralt metninizi söyler",
  "Вы в знаменитых сценах": "Ünlü sahnelerde siz",
  "3 кадра в любом образе": "Her tarzda 3 kare",
  "Готовый сюжет с вами": "Sizinle hazır bir hikâye",
  "Вы повторите любой танец": "Her dansı tekrarlarsınız",
  "Ваш снимок в движении": "Fotoğrafınız hareketli",
  "Фото скажет ваш текст": "Fotoğraf metninizi söyler",
  "Легенды замка": "Kale efsaneleri",
  "Город инков": "İnka şehri",
  "Неоновый дождь": "Neon yağmur",
  "Утренний бег": "Sabah koşusu",
  "Танец теней": "Gölge dansı",
  "Дорога домой": "Eve dönüş yolu",
  "Ночной рейв": "Gece rave’i",
  "Снежный пик": "Karlı zirve",
  "Тайны Хейвена": "Haven’ın sırları",
  "Магия рун": "Rün büyüsü",
  "Странные дела": "Tuhaf işler",
  "Ночной рынок": "Gece pazarı",
  "Ретро-кадр": "Retro kare",
  "Утро в горах": "Dağlarda sabah",
  "Золотой час": "Altın saat",
  "Студийный свет": "Stüdyo ışığı",
  "Полароид": "Polaroid",
  "Киберпанк": "Siberpunk",
  "Старый маяк": "Eski deniz feneri",
  "Шторм в заливе": "Körfezde fırtına",
  "Кинотрейлер": "Film fragmanı",
  "Город в движении": "Hareketli şehir",
  "Интервью": "Röportaj",
  "Пустыня на закате": "Gün batımında çöl",
  "Подводный мир": "Su altı dünyası",
  "Кружок «Привет»": "“Merhaba” yuvarlak videosu",
  "Спокойной ночи": "İyi geceler",
  "Поздравляю": "Tebrikler",
  "Скучаю": "Seni özledim",
  "Новости дня": "Günün haberleri",
  "Нос корабля": "Gemi pruvası",
  "Двое на носу корабля, руки раскинуты навстречу ветру": "Gemi pruvasında iki kişi, kollar rüzgâra açık",
  "Героиня": "Kadın kahraman",
  "роль: Герой": "Kahraman",
  "Уклонение от пуль": "Kurşunlardan kaçış",
  "Время замирает, вы прогибаетесь назад, и пули проходят мимо": "Zaman durur, geriye eğilirsiniz ve kurşunlar yanınızdan geçer",
  "Танец в закусочной": "Lokantada dans",
  "Пара танцует твист у стойки придорожной закусочной": "Bir çift yol kenarı lokantasında tezgâh başında twist yapıyor",
  "Танцор": "Dansçı",
  "Танцовщица": "Kadın dansçı",
  "Свидание под дождём": "Yağmurda buluşma",
  "Ливень, старый дом и встреча, которую оба ждали годами": "Sağanak, eski bir ev ve ikisinin de yıllardır beklediği buluşma",
  "Он": "Erkek",
  "Она": "Kadın",
  "Речь перед битвой": "Savaş öncesi konuşma",
  "Вождь проезжает вдоль строя, и войско отвечает рёвом": "Lider safların önünden geçer, ordu kükremeyle karşılık verir",
  "Вождь": "Lider",
  "Знаменосец": "Sancaktar",
  "Погоня по крышам": "Çatılarda kovalamaca",
  "Прыжки между крышами ночного города, погоня не отстаёт": "Gece şehrinin çatıları arasında atlayışlar, takip geride kalmıyor",
  "Беглец": "Kaçak",
  "Преследователь": "Takipçi",
  "Ограбление казино": "Kumarhane soygunu",
  "Команда в смокингах проходит через зал, сейф уже открыт": "Smokinli ekip salondan geçiyor, kasa çoktan açık",
  "Главарь": "Elebaşı",
  "Напарник": "Ortak",
  "Напарница": "Kadın ortak",
  "Прощание на вокзале": "İstasyonda veda",
  "Поезд трогается, двое держатся за руки до последнего": "Tren kalkıyor, iki kişi son ana kadar el ele",
  "Пассажир": "Yolcu",
  "Провожающий": "Uğurlayan",
  "Дуэль на закате": "Gün batımında düello",
  "Пустая улица, два стрелка и последние секунды тишины": "Boş sokak, iki silahşor ve sessizliğin son saniyeleri",
  "Шериф": "Şerif",
  "Злодей": "Kötü adam",
  "Танец на лестнице": "Merdivende dans",
  "Злодей в ярком костюме танцует на длинной уличной лестнице": "Parlak takım elbiseli kötü adam uzun bir sokak merdiveninde dans ediyor",
  "Выход в открытый космос": "Uzay yürüyüşü",
  "Астронавт парит над Землёй, трос уходит к станции": "Astronot Dünya’nın üzerinde süzülüyor, halat istasyona uzanıyor",
  "Астронавт": "Astronot",
  "Рассвет над саванной": "Savanda şafak",
  "Питомца поднимают над скалой, и вся саванна смотрит на него": "Evcil hayvan kayanın üzerinde kaldırılıyor, tüm savan ona bakıyor",
  "Главная роль": "Başrol",
  "Хранитель": "Koruyucu",
  "Полёт под луной": "Ay altında uçuş",
  "Велосипед отрывается от земли и летит на фоне луны": "Bisiklet yerden kalkıp ayın önünden uçuyor",
  "Финальная поддержка": "Final kaldırışı",
  "Разбег, прыжок и поддержка над головой под аплодисменты зала": "Koşu, sıçrayış ve alkışlar eşliğinde baş üstü kaldırış",
  "Партнёрша": "Kadın partner",
  "Партнёр": "Ortak",
  "Песня на холме": "Tepedeki şarkı",
  "Альпийский луг и ветер: вы кружитесь с песней, а дети бегут к вам навстречу": "Alp çayırı ve rüzgâr: şarkıyla dönüyorsunuz, çocuklar size koşuyor",
  "Бледная кожа": "Solgun ten",
  "Хвойный лес": "İğne yapraklı orman",
  "Первый взгляд": "İlk bakış",
  "Туман над рекой": "Nehir üstünde sis",
  "Полночь в школе": "Okulda gece yarısı",
  "Двое на поляне": "Açıklıkta iki kişi",
  "Луч пробивается сквозь хвою, и двое замирают посреди лесной поляны": "Bir ışık huzmesi çamların arasından süzülüyor, iki kişi açıklığın ortasında donup kalıyor",
  "Глаза цвета янтаря": "Kehribar gözler",
  "Бал выпускников": "Mezuniyet balosu",
  "Клятва": "Yemin",
  "Игра в грозу": "Fırtınada maç",
  "Гром над лесной поляной, и каждый удар битой звучит как раскат": "Orman açıklığında gök gürlüyor, her sopa vuruşu gök gürültüsü gibi",
  "Отбивающий": "Vurucu",
  "Подающая": "Atıcı",
  "Ловец": "Tutucu",
  "К вершине сосны": "Çamın tepesine",
  "Он уносит её на спине к вершине сосны, внизу туман и весь лес": "Onu sırtında çamın tepesine taşıyor, aşağıda sis ve bütün orman",
  "Примерка брони": "Zırh giyme",
  "Броня защёлкивается на вас деталь за деталью, и шлем закрывает лицо": "Zırh parça parça üzerinize oturuyor, kask yüzünüzü kapatıyor",
  "Полёт над городом": "Şehrin üzerinde uçuş",
  "Разгон над ночным городом, вираж между башнями и посадка на крышу": "Gece şehrinin üstünde hızlanma, kuleler arasında dönüş ve çatıya iniş",
  "Пилот брони": "Zırh pilotu",
  "Ночь в мастерской": "Atölyede gece",
  "Искры сварки, чертежи прямо в воздухе и первый удачный запуск": "Kaynak kıvılcımları, havada çizimler ve ilk başarılı çalıştırma",
  "Изобретатель": "Mucit",
  "Последний заряд": "Son şarj",
  "Заряд брони на исходе, команда встаёт спина к спине, и всё решает последний залп": "Zırhın şarjı bitmek üzere, ekip sırt sırta veriyor ve her şeyi son atış belirliyor",
  "Герой в броне": "Zırhlı kahraman",
  "Качели на паутине": "Ağla salınış",
  "Прыжок с карниза, паутина натягивается, и улица проносится под ногами": "Kornişten atlayış, ağ geriliyor ve sokak ayaklarınızın altından akıp gidiyor",
  "Герой в маске": "Maskeli kahraman",
  "Поцелуй под дождём": "Yağmurda öpücük",
  "Ночной переулок и ливень: он висит вниз головой, она приподнимает край маски": "Gece ara sokak ve sağanak: o baş aşağı asılı, kız maskenin ucunu kaldırıyor",
  "Крыша на закате": "Gün batımında çatı",
  "Двое сидят на краю крыши, внизу шумит город, солнце уходит за башни": "İki kişi çatının kenarında oturuyor, aşağıda şehir uğulduyor, güneş kulelerin ardına iniyor",
  "Бой в поезде": "Trende kavga",
  "Схватка на крыше несущегося поезда, а потом герой останавливает вагон руками": "Hızla giden trenin çatısında kavga, ardından kahraman vagonu elleriyle durduruyor",
  "Пассажирка": "Kadın yolcu",
  "Для маркетплейса": "Pazaryerleri için",
  "Праздники": "Bayramlar",
  "Поздравления, кружки и посты к праздникам: 1 апреля, Пасха, 8 марта": "Bayramlar için tebrikler, yuvarlak videolar ve gönderiler: 1 Nisan, Paskalya, 8 Mart",
  "1 апреля": "1 Nisan",
  "Пасха": "Paskalya",
  "8 марта": "8 Mart",
  "Мода": "Moda",
  "Аватарки": "Avatarlar",
  "Фильмы": "Filmler",
  "Игры": "Oyunlar",
  "Путешествия": "Seyahat",
  "Сумерки": "Alacakaranlık",
  "Железный человек": "Demir Adam",
  "Человек-паук": "Örümcek Adam",
  "Романтика": "Romantik",
  "Погони": "Kovalamacalar",
  "Всей семьёй": "Tüm aile",
  "Особая подборка": "Özel koleksiyon",
  "Особая подборка {0}, {1}": "Özel koleksiyon {0}, {1}",
  "Подборка {0}, {1}": "Koleksiyon {0}, {1}",
  "{0} в подборке": "Koleksiyonda {0}",
  "шаблон|шаблона|шаблонов": "şablon",
  "шаблона|шаблонов|шаблонов": "şablon",
  "сцена|сцены|сцен": "sahne",
  "инструмент|инструмента|инструментов": "araç",
  "инструмента|инструментов|инструментов": "araç",
  "стиль|стиля|стилей": "stil",
  "кадра|кадров|кадров": "kare",
  "ребёнок|ребёнка|детей": "çocuk",
  "питомец|питомца|питомцев": "evcil hayvan",
  "кружки": "yuvarlak videolar",
  "голос": "ses",
  "текст": "metin",
  "для бизнеса": "işletmeler",
  "Кружок из видео": "Videodan görüntülü mesaj",
  "Фото в новом стиле": "Yeni tarzda fotoğraf",
  "Фото по описанию": "Açıklamadan fotoğraf",
  "Семейный портрет": "Aile portresi",
  "Видео в новом стиле": "Yeni tarzda video",
  "Видео по описанию": "Açıklamadan video",
  "Видео другим голосом": "Başka sesle video",
  "Объёмное фото": "3D fotoğraf",
  "Анимация из серии": "Seriden animasyon",
  "Видео из поездки": "Gezi videosu",
  "Фильм из фотографий": "Fotoğraflardan film",
  "Изменить видео": "Videoyu düzenle",
  "текст или запись": "metin veya kayıt",
  "видео до 1 минуты": "1 dakikaya kadar video",
  "1 фото и текст": "1 fotoğraf ve metin",
  "запись или аудиофайл": "kayıt veya ses dosyası",
  "5 фото лица": "5 yüz fotoğrafı",
  "1 селфи": "1 selfie",
  "описание словами": "kelimelerle açıklama",
  "фото или описание": "fotoğraf veya açıklama",
  "старое фото": "eski fotoğraf",
  "чёрно-белое фото": "siyah beyaz fotoğraf",
  "фото близких": "sevdiklerinizin fotoğrafları",
  "от 2 до 9 фото": "2–9 fotoğraf",
  "тема поста": "gönderi konusu",
  "1 фото или видео": "1 fotoğraf veya video",
  "ваше фото": "fotoğrafınız",
  "фото тех, кто сыграет": "oynayacakların fotoğrafları",
  "1 видео": "1 video",
  "видео и новый текст": "video ve yeni metin",
  "видео с речью": "konuşmalı video",
  "текст поздравления": "tebrik metni",
  "от 3 фото": "en az 3 fotoğraf",
  "фото из поездки": "gezi fotoğrafları",
  "семейные фото": "aile fotoğrafları",
  "сценарий": "senaryo",
  "запись голоса": "ses kaydı",
  "песня": "şarkı",
  "файл или ссылка": "dosya veya bağlantı",
  "название товара": "ürün adı",
  "от 1 до 5 фото товара": "1–5 ürün fotoğrafı",
  "фото товара": "ürün fotoğrafları",
  "1 видео с вами": "sizinle 1 video",
  "ваше видео": "videonuz",
  "картинка": "görsel",
  "идея словами": "kelimelerle fikir",
  "ваш промпт": "isteminiz",
  "нужно: 1 фото": "1 fotoğraf",
  "нужно: Текст": "Metin",
  "нужно: Тема": "Konu",
  "нужно: Запись": "Kayıt",
  "формат: Reels": "Reels",
  "формат: фото": "fotoğraf",
  "формат: видео": "video",
  "формат: кружков": "yuvarlak video",
  "формат: шаблонов": "şablon",
  "любое, где хорошо видно лицо": "yüzün net göründüğü herhangi biri",
  "лицо крупно и при хорошем свете": "yakın plan yüz, iyi ışıkta",
  "селфи, лицо крупно": "selfie, yakın plan yüz",
  "снимок оживёт в ролике": "fotoğraf videoda canlanır",
  "что скажет герой": "karakterin söyleyeceği",
  "или фото, из которых сделаем слайды": "ya da slayt yapacağımız fotoğraflar",
  "Сколько стоит одна генерация": "Bir üretim ne kadar",
  "Фото стоит {0} C, фотосессия {1} C за 3 кадра, видео {2} C за 5 секунд. Помощники для текста, например описание товара, стоят {3} C. Цена всегда видна на кнопке «Создать» до списания.": "Fotoğraf {0} C, 3 karelik fotoğraf çekimi {1} C, 5 saniyelik video {2} C. Ürün açıklaması gibi metin yardımcıları {3} C. Fiyat, ödeme öncesinde her zaman “Oluştur” düğmesinde görünür.",
  "Что такое C и как пополнить баланс": "C nedir ve bakiye nasıl yüklenir",
  "C это монеты Circle, ими платят за создание. Пакеты и подписка покупаются на вкладке «Баланс», там же виден остаток.": "C, oluşturma için ödediğiniz Circle jetonlarıdır. Paketler ve abonelik “Bakiye” sekmesinden alınır, kalan miktar da orada görünür.",
  "Какие файлы можно загружать": "Hangi dosyalar yüklenebilir",
  "Видео до 1 минуты и 15 МБ, фото в JPG или PNG, аудио в MP3, WAV или M4A. Ограничения показываются в самом инструменте.": "1 dakikaya ve 15 MB’a kadar video, JPG veya PNG fotoğraf, MP3, WAV veya M4A ses. Sınırlar aracın içinde gösterilir.",
  "Как сделать дешевле": "Nasıl daha ucuz yapılır",
  "Если Circle на работу не хватает, кнопка внизу экрана откроет лист «Не хватает Circle»: в нём есть «Сделать дешевле». Скидка {0}%, на результате появится водяной знак.": "Circle yetmezse ekranın altındaki düğme “Yetersiz Circle” sayfasını açar; orada “Daha ucuza yap” seçeneği var. İndirim %{0}, sonuçta filigran olur.",
  "Где найти готовые результаты": "Hazır sonuçlar nerede",
  "В разделе «История» в меню «Ещё». Там же можно скачать файл повторно или отправить в чат.": "“Diğer” menüsündeki “Geçmiş” bölümünde. Orada dosyayı yeniden indirebilir ya da sohbete gönderebilirsiniz.",
  "Можно ли использовать свой голос": "Kendi sesimi kullanabilir miyim",
  "Да. Клонируйте голос на вкладке «Клон», и он появится в списке голосов во всех инструментах с озвучкой.": "Evet. “Klon” sekmesinde sesinizi klonlayın, tüm seslendirme araçlarının ses listesinde görünsün.",
  "Фотосессия из {0} в стиле шаблона": "Şablon tarzında {0} fotoğraf çekimi",
  "По желанию: {0}": "İsteğe bağlı: {0}",
  "Тут откроется шаблон «{0}»": "“{0}” şablonu burada açılacak",
  "Только до": "Yalnızca önce",
  "Только после": "Yalnızca sonra",
  "До: {0} %": "Önce: %{0}",
  "подборка": "koleksiyon",
  "Все форматы": "Tüm biçimler",
  "Состав": "Oyuncular",
  "Вкладки каталога": "Katalog sekmeleri",
  "Найти подборку": "Koleksiyon bul",
  "Найти шаблон": "Şablon bul",
  "Поиск среди {0}": "{0} içinde ara",
  "По запросу «{0}» подборок нет. Поищите среди всех шаблонов": "“{0}” için koleksiyon yok. Tüm şablonlarda arayın",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех шаблонах": "“{1}” içinde “{0}” için sonuç yok. Tüm şablonlarda arayın",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех шаблонах": "“Sana özel” içinde “{0}” için sonuç yok. Tüm şablonlarda arayın",
  "В подборке «{0}» нет сцен «{1}»": "“{0}” içinde “{1}” sahnesi yok",
  "Посмотрите все сцены подборки": "Koleksiyonun tüm sahnelerine bakın",
  "В подборке «{0}» нет {1}": "“{0}” içinde {1} yok",
  "Посмотрите во всех форматах": "Tüm biçimlere bakın",
  "В «Рекомендуем» нет {0}": "“Sana özel” içinde {0} yok",
  "Пока ничего нет": "Henüz bir şey yok",
  "Шаблоны этого формата появятся совсем скоро": "Bu biçimde şablonlar çok yakında",
  "По запросу «{0}» среди {1} ничего нет. Поищите во всех форматах": "{1} içinde “{0}” için sonuç yok. Tüm biçimlerde arayın",
  "Искать во всех форматах": "Tüm biçimlerde ara",
  "По запросу «{0}» среди шаблонов ничего нет. Попробуйте другое слово": "“{0}” için şablon yok. Başka bir kelime deneyin",
  "Загружаем ещё": "Daha fazlası yükleniyor",
  "Это все шаблоны": "Tüm şablonlar bu kadar",
  "Тренды": "Trendler",
  "Вкладки страницы": "Sayfa sekmeleri",
  "Найти сцену": "Sahne bul",
  "Найти в подборке": "Koleksiyonda ara",
  "Искать во всех сценах": "Tüm sahnelerde ara",
  "По запросу «{0}» подборок нет. Поищите среди всех сцен": "“{0}” için koleksiyon yok. Tüm sahnelerde arayın",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех сценах": "“{1}” içinde “{0}” için sonuç yok. Tüm sahnelerde arayın",
  "По запросу «{0}» в «Трендах» ничего нет. Поищите во всех сценах": "“Trendler” içinde “{0}” için sonuç yok. Tüm sahnelerde arayın",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех сценах": "“Sana özel” içinde “{0}” için sonuç yok. Tüm sahnelerde arayın",
  "В «Трендах» нет сцен «{0}»": "“Trendler” içinde “{0}” sahnesi yok",
  "В «Рекомендуем» нет сцен «{0}»": "“Sana özel” içinde “{0}” sahnesi yok",
  "Посмотрите все сцены этой вкладки": "Bu sekmenin tüm sahnelerine bakın",
  "В подборке «{0}» ничего по запросу «{1}». Поищите во всех шаблонах": "“{0}” içinde “{1}” için sonuç yok. Tüm şablonlarda arayın",
  "В этой подборке пока нет таких шаблонов. Посмотрите её целиком или выберите другую вкладку": "Bu koleksiyonda henüz böyle şablon yok. Tamamına bakın ya da başka bir sekme seçin",
  "Поиск в подборке «{0}»: {1}": "“{0}” içinde ara: {1}",
  "Вкладки подборки": "Koleksiyon sekmeleri",
  "Нужно: {0}": "Gerekli: {0}",
  "Нужно": "Gerekli",
  "По запросу «{0}» нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "“{0}” için araç ya da şablon yok. Başka bir kelime deneyin veya tüm araçlara bakın",
  "По запросу «{0}» в разделе «{1}» ничего нет. Поищите во всех инструментах": "“{1}” bölümünde “{0}” için sonuç yok. Tüm araçlarda arayın",
  "Искать во всех": "Tümünde ara",
  "По запросу «{0}» инструментов нет. Попробуйте другое слово": "“{0}” için araç yok. Başka bir kelime deneyin",
  "Найти инструмент": "Araç bul",
  "Не удалось открыть инструмент. Обновите каталог и попробуйте снова.": "Araç açılamadı. Kataloğu yenileyip tekrar deneyin.",
  "Не удалось открыть инструмент за 30 секунд. Обновите запрос или вернитесь назад.": "Araç 30 saniyede açılmadı. Tekrar deneyin ya da geri dönün.",
  "Карточка товара": "Ürün kartı",
  "Рилс готов": "Reels hazır",
  "Кавер не создан": "Cover oluşturulmadı",
  "Фотосессия не создана": "Fotoğraf çekimi oluşturulmadı",
  "Рилс не создан": "Reels oluşturulmadı",
  "Карточка не создана": "Kart oluşturulmadı",
  "Слайды не созданы": "Slaytlar oluşturulmadı",
  "Запись не обработана": "Kayıt işlenmedi",
  "Коллаж не создан": "Kolaj oluşturulmadı",
  "· остаток {0} C": "· kalan {0} C",
  "Вернули {0} C": "{0} C iade edildi",
  "Списано {0} C со скидкой, {1} водяной знак": "İndirimle {0} C düşüldü, {1} filigran",
  "Списано {0} C": "{0} C düşüldü",
  "Рисованному стилю камера не нужна": "Çizim tarzı kamera gerektirmez",
  "У этой камеры объектив встроенный": "Bu kameranın objektifi dahili",
  "У этой камеры резкость не настраивается": "Bu kamerada netlik ayarlanamaz",
  "У этого объектива диафрагма постоянная": "Bu objektifin diyaframı sabit",
  "Встроенный": "Dahili",
  "Как у камеры": "Kamerayla aynı",
  "до {0} МБ": "{0} MB’a kadar",
  "По запросу {0} нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "{0} için araç ya da şablon yok. Başka bir kelime deneyin veya tüm araçlara bakın",
  "По запросу {0} в разделе {1} ничего нет. Поищите во всех инструментах": "{1} bölümünde {0} için sonuç yok. Tüm araçlarda arayın",
  "По запросу {0} инструментов нет. Попробуйте другое слово": "{0} için araç yok. Başka bir kelime deneyin",
  "в «Трендах»": "“Trendler” içinde",
  "в «Рекомендуем»": "“Sana özel” içinde",
  "в подборке {0}": "{0} içinde",
  "По запросу {0} {1} ничего нет. Поищите во всех сценах": "{1} {0} için sonuç yok. Tüm sahnelerde arayın",
  "В подборке {0} ничего по запросу {1}. Поищите во всех шаблонах": "{0} içinde {1} için sonuç yok. Tüm şablonlarda arayın",
  "сцен {0}": "{0} sahnesi",
  "В подборке {0} нет {1}": "{0} içinde {1} yok",
  "В подборке {0} нет таких шаблонов": "{0} içinde böyle şablon yok",
  "Посмотрите её целиком или выберите другую вкладку": "Tamamına bakın ya da başka bir sekme seçin",
  "По запросу {0} в этом формате ничего нет. Поищите во всех форматах": "Bu biçimde {0} için sonuç yok. Tüm biçimlerde arayın",
  "По запросу {0} среди шаблонов ничего нет. Попробуйте другое слово": "{0} için şablon yok. Başka bir kelime deneyin",
  "Здесь нет шаблонов": "Burada şablon yok",
  "Заказ принят": "Sipariş alındı",
  "Бот пришлёт результат в чат, в отдельную тему.": "Bot sonucu sohbete, ayrı bir konuya gönderecek.",
  "Измените запрос и попробуйте снова. Circle за проверенный заказ не возвращаются.": "İsteği değiştirip tekrar deneyin. İncelenmiş sipariş için Circle iade edilmez.",
  "Сбой на нашей стороне. Circle вернулись на баланс.": "Bizim tarafta bir hata oluştu. Circle bakiyenize iade edildi.",
  "Инструмент ещё подключается: заказ стоит в очереди и начнётся сам, бот пришлёт результат в чат.": "Araç hâlâ bağlanıyor: sipariş sırada ve kendiliğinden başlayacak, bot sonucu sohbete gönderecek.",
  "Сначала отметьте согласие ниже": "Önce aşağıdaki onayı işaretleyin",
  "Главное фото: {0}": "Ana fotoğraf: {0}",
  "Загружаем превью…": "Önizleme yükleniyor…",
  "Фото не подошло": "Fotoğraf uygun değil",
  "Проверить загрузку": "Yüklemeyi kontrol et",
  "Опишите, что хотите увидеть": "Görmek istediğinizi anlatın",
  "Не помещается: до {0} знаков": "Sığmıyor: en fazla {0} karakter",
  "{0} во весь экран": "{0} tam ekran",
  "Загрузить картинку": "Görsel yükle",
  "Ваша": "Sizin",
  "Убрать картинку": "Görseli kaldır",
  "Этот инструмент пока недоступен": "Bu araç henüz kullanılamıyor",
  "Выберите другой инструмент или вернитесь к шаблонам.": "Başka bir araç seçin ya da şablonlara dönün.",
  "Вернуться": "Geri dön",
  "Образ": "Tarz",
  "Ваши селфи": "Selfie’leriniz",
  "Три разных кадра: лицо крупно, при хорошем свете": "Üç farklı kare: yakın plan yüz, iyi ışıkta",
  "Подтверждаю согласие людей на фото": "Fotoğraftaki kişilerin onayını doğruluyorum",
  "От одного до пяти ракурсов, первый — главный": "Birden beşe kadar açı, ilki ana açı",
  "Категория": "Kategori",
  "Набор сцен": "Sahne seti",
  "Загрузите фото: нужно {0}": "Fotoğraf yükleyin: {0} gerekli",
  "Выберите: {0}": "Seçin: {0}",
  "Не удалось загрузить экран.": "Ekran yüklenemedi.",
  "Сцен: {0}": "Sahne: {0}",
  "Заказ создан, следите за ним в «Истории».": "Sipariş oluşturuldu, “Geçmiş”ten takip edin.",
  "Старые": "En eski",
  "Длинные": "En uzun",
  "Стиль уже задаёт свет и цвет. Выберите другой, если хотите поменять": "Stil ışığı ve rengi zaten belirliyor. Değiştirmek için başka bir stil seçin",
  "{0} открывается только до f/{1}": "{0} yalnızca f/{1} değerine kadar açılır",
  "Объектив не задаёт светосилу": "Objektif ışık gücünü belirlemiyor",
  "Этот объектив открывается только до f/{0}": "Bu objektif yalnızca f/{0} değerine kadar açılır",
  "Назад к настройкам": "Ayarlara dön",
  "Группа": "Grup",
  "Нашли {0}": "{0} bulundu",
  "Ничего не нашлось. Попробуйте другое слово или сбросьте группу.": "Hiçbir şey bulunamadı. Başka bir kelime deneyin ya da grubu sıfırlayın.",
  "Выбор сразу вернёт к настройкам. Цена не меняется": "Seçim sizi hemen ayarlara döndürür. Fiyat değişmez",
  "Сравнить: было и стало": "Karşılaştır: önce ve sonra",
  "Берём стиль: цвет, свет, обработку. Саму картинку и лица с неё не переносим": "Stili alıyoruz: renk, ışık, işleme. Görselin kendisini ve yüzleri aktarmıyoruz",
  "Берём сцену: фон, свет и подачу. Саму картинку и лица с неё не переносим": "Sahneyi alıyoruz: arka plan, ışık ve sunum. Görselin kendisini ve yüzleri aktarmıyoruz",
  "Берём образ: одежду, позу, фон и свет. В кадре будете вы, лица с картинки не переносим": "Tarzı alıyoruz: kıyafet, poz, arka plan ve ışık. Karede siz olacaksınız, görseldeki yüzleri aktarmıyoruz",
  "Картинка не подошла: не открывается, попробуйте JPG или PNG": "Görsel uygun değil: açılmıyor, JPG veya PNG deneyin",
  "Картинка не подошла: больше {0} МБ": "Görsel uygun değil: {0} MB’tan büyük",
  "Картинка не подошла: слишком маленькая, нужна от {0} px": "Görsel uygun değil: çok küçük, en az {0} px olmalı",
  "Картинка не подошла: на ней защищённое или запрещённое содержимое": "Görsel uygun değil: korumalı veya yasak içerik var",
  "Загрузить картинку-референс": "Referans görseli yükle",
  "Озвучка текста": "Metni seslendirme",
  "Запишите от 2 секунд речи, и бот заговорит вашим голосом": "2 saniyelik konuşma kaydedin, bot sizin sesinizle konuşsun",
  "Готовые голоса стоят на вкладке «Мои» в разделе «Озвучка»": "Hazır sesler «Sesler» bölümündeki «Benim» sekmesinde",
  "Под этим именем голос стоит в вашем списке. Описание видите только вы": "Ses listenizde bu adla görünür. Açıklamayı yalnızca siz görürsünüz",
  "Голос появится на вкладке «Мои»": "Ses «Benim» sekmesinde görünecek",
  "Имя в списке голосов": "Ses listesindeki ad",
  "Уже в «Озвучке»": "Artık «Sesler» bölümünde",
  "Голос стоит на вкладке «Мои» с меткой «Мой голос»": "Ses «Benim» sekmesinde, «Benim» etiketiyle",
  "Карточка голоса": "Ses kartı",
  "Нажмите на голос в списке, чтобы переименовать или удалить": "Yeniden adlandırmak veya silmek için listedeki sese dokunun",
  "Так голос выглядит в списке": "Ses listede böyle görünür",
  "Голос уже стоит на вкладке «Мои». Послушайте, как он звучит": "Ses artık «Benim» sekmesinde. Nasıl duyulduğunu dinleyin",
  "Идёт проверка и обучение, обычно 1–3 минуты. Голос появится на вкладке «Мои» сам": "Kontrol ve eğitim sürüyor, genelde 1–3 dakika. Ses «Benim» sekmesinde kendiliğinden görünecek",
  "Голос пропадёт с вкладки «Мои». Вернуть его не получится.": "Ses «Benim» sekmesinden kalkacak. Geri alınamaz.",
  "Обычно 1–3 минуты. Можно закрыть приложение, голос появится в списке": "Genelde 1–3 dakika. Uygulamayı kapatabilirsiniz, ses listede görünecek",
  "Можно закрыть приложение": "Uygulamayı kapatabilirsiniz",
  "Запишите речь или загрузите файлы: от 0:02 до 1:30. Подойдут MP3, WAV, M4A, OGG и WEBM, до 10 файлов по 20 МБ": "Konuşma kaydedin veya dosya yükleyin: toplam 0:02–1:30. MP3, WAV, M4A, OGG ve WEBM, en fazla 10 dosya, her biri 20 MB",
  "Создано {n} клонов из {n}. Удалите один, чтобы добавить новый": "{n}/{n} klon oluşturuldu. Yenisini eklemek için birini silin",
  "Без подписки можно создать {n} клона. С подпиской их будет {0}": "Abonelik olmadan {n} klon oluşturabilirsiniz. Abonelikle {0}",
  "До {0} клонов": "{0} klona kadar",
  "Три клона бесплатно": "Üç klon ücretsiz",
  "Запишите ещё один, другим тоном или настроением": "Farklı bir ton veya ruh hâliyle bir tane daha kaydedin",
  "С подпиской можно создать до {0}": "Abonelikle {0} klona kadar oluşturabilirsiniz",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Чем естественнее получится сейчас, тем точнее будет звучать клон.": "Merhaba! Bu, sesim için bir kayıt. Bir arkadaşımla konuşur gibi sakin ve normal hızda konuşuyorum. Şimdi ne kadar doğal olursa klon da o kadar gerçekçi olur.",
  "Знаете, что самое странное в готовке по видео? Смотришь, как человек за минуту режет лук, и думаешь: это же просто. А потом лук почему-то везде, кроме сковородки.": "Videodan yemek yapmanın en tuhaf yanı ne, biliyor musunuz? Birinin bir dakikada soğan doğradığını izleyip «Bu çok kolay» diyorsunuz. Sonra soğan nedense tava hariç her yerde oluyor.",
  "Вчера наконец разобрал коробки после переезда. Нашёл старый плеер, три зарядки от телефонов, которых уже нет, и тетрадь с планами на лето. Плеер до сих пор работает.": "Dün nihayet taşınmadan kalan kutuları açtım. Eski bir müzik çalar, artık olmayan telefonların üç şarj aleti ve yaz planlarımın olduğu bir defter buldum. Müzik çalar hâlâ çalışıyor.",
  "Погода сегодня странная: утром светило солнце, к обеду пошёл дождь, а к вечеру обещают снег. Самое время заварить что-нибудь горячее и никуда не торопиться.": "Bugün hava tuhaf: sabah güneş vardı, öğleye doğru yağmur başladı, akşam için kar bekleniyor. Sıcak bir şey demleyip hiç acele etmemenin tam zamanı.",
  "Раз, два, три, проверка. Меня хорошо слышно? Сейчас я прочитаю несколько фраз разным тоном: сначала спокойно, потом чуть громче, а в конце совсем тихо, почти шёпотом.": "Bir, iki, üç, deneme. Sesim iyi geliyor mu? Şimdi birkaç cümleyi farklı tonlarda okuyacağım: önce sakin, sonra biraz daha yüksek, en sonda da çok alçak, neredeyse fısıltıyla.",
  "Мой кот считает, что клавиатура создана для сна, а монитор нужен, чтобы закрывать его хвостом. Поэтому если в записи что-то зашуршит, знайте: это была командная работа.": "Kedim klavyenin uyumak için, monitörün de kuyruğuyla kapatılmak için yapıldığını düşünüyor. Kayıtta bir hışırtı duyarsanız bilin ki bu bir takım çalışmasıydı.",
  "Есть простое правило: если что-то не получается с третьей попытки, надо встать, налить чаю и вернуться через пять минут. Обычно после этого всё получается само.": "Basit bir kural var: Bir şey üçüncü denemede de olmuyorsa kalkın, bir çay koyun ve beş dakika sonra dönün. Genelde ondan sonra her şey kendiliğinden yoluna girer.",
  "Тихо, слышите? Где-то рядом шаги. Сейчас аккуратно выглянем за угол, и если там никого нет, перебежим к двери. Только не шумите, пожалуйста, я серьёзно.": "Sessiz, duydunuz mu? Yakında bir yerde ayak sesleri var. Şimdi dikkatlice köşeden bakacağız, kimse yoksa kapıya koşacağız. Yalnız lütfen ses yapmayın, ciddiyim.",
  "Проверено": "Doğrulandı",
  "Создание новых голосов пока недоступно": "Yeni ses oluşturma henüz kullanılamıyor",
  "От 2 секунд речи: запись в браузере или готовые файлы": "2 saniyelik konuşma: burada kaydedin veya dosya yükleyin",
  "Внутренняя ошибка, попробуйте позже": "Dahili hata, daha sonra tekrar deneyin",
  "образцов: {n}": "örnek: {n}",
  "Образец короче 2 секунд": "Örnek 2 saniyeden kısa",
  "Образец длиннее 1,5 минуты": "Örnek 1,5 dakikadan uzun",
  "Слишком шумная запись — попробуйте в тихом месте": "Kayıt çok gürültülü, sessiz bir yerde deneyin",
  "В записи слышно несколько голосов": "Kayıtta birden fazla ses duyuluyor",
  "Проверка не пройдена: голос не совпадает с образцами": "Kontrol başarısız: ses örneklerle eşleşmiyor",
  "Голос не прошёл правила площадки": "Ses platform kurallarına uymuyor",
  "Проверка не пройдена: запишите образец без музыки и других людей": "Kontrol başarısız: müzik ve başka kişiler olmadan bir örnek kaydedin",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме": "Toplam 2 saniye ile 1,5 dakika arası konuşma gerekli",
  "Результат обработки уточняется, загляните чуть позже": "İşlem sonucu netleşiyor, biraz sonra tekrar bakın",
  "Удалить голос «{n}»?": "«{n}» sesi silinsin mi?",
  "Навсегда, вместе с образцами": "Kalıcı olarak, örnekleriyle birlikte",
  "Например, спокойный, низкий": "Örneğin sakin, kalın",
  "Образец": "Örnek",
  "Запись или файлы, от 2 секунд": "Kayıt veya dosya, en az 2 sn",
  "Имя, описание и согласие": "Ad, açıklama ve onay",
  "Проверка и обучение": "Kontrol ve eğitim",
  "Модель STEOS · 1–3 минуты": "STEOS modeli · 1–3 dk",
  "Тихое место без эха": "Yankısız sessiz bir yer",
  "Фоновый шум и музыка попадут в голос": "Arka plan gürültüsü ve müzik sese karışır",
  "Хороший микрофон": "İyi bir mikrofon",
  "Гарнитура или настольный микрофон лучше встроенного": "Kulaklık mikrofonu veya masa mikrofonu dahili olandan iyidir",
  "То же оборудование": "Aynı ekipman",
  "Не меняйте микрофон между записями": "Kayıtlar arasında mikrofon değiştirmeyin",
  "Под ним голос стоит в списке выбора": "Ses listede bu adla görünür",
  "Шумоподавление": "Gürültü azaltma",
  "Включайте, только если в записи слышен шум": "Yalnızca kayıtta gürültü duyuluyorsa açın",
  "Согласие обязательно": "Onay zorunlu",
  "Клонировать можно свой голос или с согласия владельца": "Kendi sesinizi veya sahibinin onayıyla bir sesi klonlayabilirsiniz",
  "Проверка образца": "Örnek kontrolü",
  "Один говорящий, без музыки и шума": "Tek konuşmacı, müzik ve gürültü yok",
  "Обучение": "Eğitim",
  "Модель STEOS, обычно 1–3 минуты": "STEOS modeli, genelde 1–3 dakika",
  "Голос появится в списке сам": "Ses listede kendiliğinden görünecek",
  "Проверьте запись": "Kaydı kontrol edin",
  "Один голос, без музыки и шума на фоне": "Tek ses, arka planda müzik ve gürültü yok",
  "Длина образца": "Örnek uzunluğu",
  "Нужно не меньше 2 секунд чистой речи": "En az 2 saniye temiz konuşma gerekli",
  "Образцы сохранены": "Örnekler kaydedildi",
  "Можно попробовать снова с теми же файлами": "Aynı dosyalarla tekrar deneyebilirsiniz",
  "Не получилось — попробуйте снова": "Olmadı, tekrar deneyin",
  "Шаг {a} из {b}": "Adım {a}/{b}",
  "Персональный": "Kişisel",
  "Дальше": "İleri",
  "Продолжить": "Devam et",
  "К списку голосов": "Ses listesine",
  "Результат уточняется": "Netleşiyor",
  "Попробовать снова": "Tekrar dene",
  "Голос готов": "Ses hazır",
  "Опишите голос": "Sesi tanımlayın",
  "Например, Мой голос": "Örneğin Benim sesim",
  "Это мой голос или у меня есть согласие его владельца. Я не буду использовать клон для обмана, оскорблений и запрещённого контента": "Bu benim sesim ya da sahibinin onayı bende. Klonu aldatma, hakaret ve yasaklı içerik için kullanmayacağım",
  "Загружаем {a} из {b}": "{a}/{b} yükleniyor",
  "Обрабатываем голос": "Ses işleniyor",
  "Не получилось создать голос": "Ses oluşturulamadı",
  "Результат обработки ещё уточняется. Повтор пока недоступен.": "İşlem sonucu henüz netleşmedi. Tekrar deneme şimdilik kullanılamıyor.",
  "Образцы сохранены — можно попробовать снова с теми же файлами": "Örnekler kaydedildi, aynı dosyalarla tekrar deneyebilirsiniz",
  "Загруженные файлы": "Yüklenen dosyalar",
  "Читаем аудио…": "Ses okunuyor…",
  "Записать ещё": "Daha kaydet",
  "Ждём разрешение…": "İzin bekleniyor…",
  "Разрешите доступ в настройках браузера или загрузите файл": "Tarayıcı ayarlarından erişime izin verin veya bir dosya yükleyin",
  "Другой текст": "Başka metin",
  "Прочитайте вслух": "Sesli okuyun",
  "Микрофон по умолчанию": "Varsayılan mikrofon",
  "Минимум": "Asgari",
  "Хорошо": "İyi",
  "Отлично": "Mükemmel",
  "Набрано {a} из {b}": "{a}/{b} toplandı",
  "из {t}": "/ {t}",
  "всё готово": "hazır",
  "Файлов с ошибкой: {n}": "Hatalı dosya: {n}",
  "до «{n}» ещё {t}": "«{n}» için {t} daha",
  "Ещё {t} до минимума": "Asgariye {t} kaldı",
  "Нужно не меньше 2 секунд": "En az 2 saniye gerekli",
  "Загрузка образцов": "Örnekler yükleniyor",
  "Образцы приняты сервером": "Örnekler sunucuya ulaştı",
  "Проверка голоса": "Ses kontrolü",
  "Пройдена": "Geçti",
  "Не запрашивалась": "İstenmedi",
  "Результат проверки пока недоступен": "Kontrol sonucu henüz yok",
  "Обработка голоса": "Ses işleme",
  "Не удалось обработать": "İşlenemedi",
  "Выполняется на сервере": "Sunucuda sürüyor",
  "Очистка шума": "Gürültü temizleme",
  "Пропущено": "Atlandı",
  "Модель STEOS · один говорящий, без музыки": "STEOS modeli · tek konuşmacı, müzik yok",
  "Обучение голоса": "Ses eğitimi",
  "Файл больше 20 МБ": "Dosya 20 MB’tan büyük",
  "Запись {n}": "Kayıt {n}",
  "Не удалось прочитать аудио": "Ses okunamadı",
  "Неподдерживаемый формат": "Desteklenmeyen biçim",
  "Результат прошлого создания ещё уточняется. Вернитесь к прежнему запросу, чтобы не создать второй клон.": "Önceki oluşturmanın sonucu henüz netleşmedi. İkinci bir klon oluşturmamak için önceki isteğe dönün.",
  "Проверить прошлое создание": "Öncekini kontrol et",
  "Остановить": "Durdur",
  "Ждём доступ": "Erişim bekleniyor",
  "Ещё раз": "Tekrar",
  "Начать запись": "Kaydı başlat",
  "Нажмите на голос в списке, чтобы открыть его карточку: прослушать, переименовать или удалить.": "Kartını açmak için listedeki bir sese dokunun: dinleyin, yeniden adlandırın veya silin.",
  "Озвучек": "Seslendirme",
  "Знаков": "Karakter",
  "Образцов": "Örnek",
  "Доступна": "Kullanılabilir",
  "Недоступна": "Kullanılamaz",
  "После обучения": "Eğitimden sonra",
  "Голос обучен на ваших записях: образцов {n}, всего {d}": "Kayıtlarınızla eğitildi: {n} örnek, toplam {d}",
  "Происхождение: ваши записи. Подробнее": "Kaynak: kayıtlarınız. Ayrıntılar",
  "Происхождение": "Kaynak",
  "Ваши записи": "Kayıtlarınız",
  "Проверка": "Kontrol",
  "Не пройдена": "Geçmedi",
  "Идёт": "Sürüyor",
  "Переозвучка аудио": "Ses yeniden seslendirme",
  "Создан": "Oluşturuldu",
  "Доступ": "Erişim",
  "Только вы": "Yalnızca siz",
  "Голос пока недоступен для выбора. Обновите список.": "Ses henüz seçilemiyor. Listeyi yenileyin.",
  "Голос ещё учится, обычно 1–3 минуты": "Ses hâlâ eğitiliyor, genelde 1–3 dakika",
  "Коротко о голосе": "Kısaca ses",
  "О голосе": "Ses hakkında",
  "Голос не создан": "Ses oluşturulmadı",
  "Обработка дольше обычного": "Her zamankinden uzun sürüyor",
  "Сервер ещё обрабатывает голос. Можно закрыть приложение и вернуться позже.": "Sunucu sesi hâlâ işliyor. Uygulamayı kapatıp daha sonra dönebilirsiniz.",
  "Аватар {n} останется без голоса, в кружках зазвучит голос по умолчанию.": "{n} avatarı sessiz kalacak, yuvarlak videolarda varsayılan ses kullanılacak.",
  "Аватары {n} останутся без голоса, в кружках зазвучит голос по умолчанию.": "{n} avatarları sessiz kalacak, yuvarlak videolarda varsayılan ses kullanılacak.",
  "Записать первый голос": "İlk sesi kaydet",
  "клон|клона|клонов": "klon",
  "в месяц": "aylık",
  "{n} C в месяц": "Ayda {n} C",
  "{n} своих голосов": "{n} kendi sesiniz",
  "Оформить": "Abone ol",
  "Подписка активна": "Abonelik etkin",
  "Подписка «{n}»": "«{n}» aboneliği",
  "{n} голосов ваши": "{n} ses sizin",
  "Доступно — своих голосов": "Kendi sesleriniz kullanılabilir",
  "{n} голосов мало?": "{n} ses yetmiyor mu?",
  "Возьмите {n}": "{n} tane alın",
  "Нужно больше голосов?": "Daha fazla ses mi lazım?",
  "До {n} с подпиской": "Abonelikle {n} taneye kadar",
  "Посмотрите доступные подписки": "Mevcut aboneliklere göz atın",
  "Занято {a} из {b}. Записывайте голоса под разные задачи и настроения": "{a}/{b} kullanılıyor. Farklı işler ve ruh hâlleri için ses kaydedin",
  "Без подписки можно создать {a} {w}. С любой подпиской их будет {b}": "Abonelik olmadan {a} {w} oluşturabilirsiniz. Herhangi bir abonelikle {b}",
  "Без подписки: {n}. Лимит зависит от выбранной подписки.": "Abonelik olmadan: {n}. Sınır seçilen aboneliğe bağlı.",
  "Занято {a} из {b}": "{a}/{b} kullanılıyor",
  "Без подписки · {n}": "Abonesiz · {n}",
  "С подпиской · {n}": "Abonelikle · {n}",
  "Смотреть все подписки": "Tüm abonelikler",
  "Повторить сохранение": "Tekrar kaydet",
  "Сохраняем изменения…": "Değişiklikler kaydediliyor…",
  "Управление голосами временно недоступно": "Ses yönetimi geçici olarak kullanılamıyor",
  "клон: Мой голос": "Benim sesim",
  "Свои голоса временно недоступны. Попробуйте обновить список позже.": "Kendi sesleriniz geçici olarak kullanılamıyor. Listeyi daha sonra yenileyin.",
  "Сервис голосов временно недоступен. Попробуйте ещё раз позже.": "Ses hizmeti geçici olarak kullanılamıyor. Daha sonra tekrar deneyin.",
  "Не удалось подтвердить лимит голосов. Обновите список позже.": "Ses sınırı doğrulanamadı. Listeyi daha sonra yenileyin.",
  "Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.": "Hesap doğrulanamadı. Daha sonra tekrar deneyin.",
  "Имя голоса должно содержать от 2 до 32 символов.": "Ses adı 2–32 karakter olmalı.",
  "Описание должно содержать не больше 120 символов.": "Açıklama en fazla 120 karakter olmalı.",
  "Добавьте от 1 до 10 подходящих образцов.": "1 ile 10 arası uygun örnek ekleyin.",
  "Превью этого голоса пока недоступно.": "Bu sesin önizlemesi henüz yok.",
  "Не удалось загрузить превью. Попробуйте позже.": "Önizleme yüklenemedi. Daha sonra deneyin.",
  "Слишком шумная запись. Попробуйте записать голос в тихом месте.": "Kayıt çok gürültülü. Sesi sessiz bir yerde kaydetmeyi deneyin.",
  "В записи слышно несколько голосов. Добавьте речь одного человека.": "Kayıtta birden fazla ses var. Tek bir kişinin konuşmasını ekleyin.",
  "Голос не прошёл правила площадки.": "Ses platform kurallarına uymuyor.",
  "Сервис не смог обработать голос. Проверьте статус перед повтором.": "Hizmet sesi işleyemedi. Tekrar denemeden önce durumu kontrol edin.",
  "Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.": "Onay metni değişti veya kullanılamıyor. Tekrar denemeden önce listeyi yenileyip güncel sürümü onaylayın.",
  "Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.": "Yükleme reddedildi. Örneği yeniden yüklemek için düğmeye tekrar basın.",
  "Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.": "Yükleme henüz onaylanmadı. Düğmeye tekrar basın: önce önceki yüklemeyi kontrol edeceğiz.",
  "Выберите аудиофайл MP3, WAV, M4A, OGG или WebM.": "MP3, WAV, M4A, OGG veya WebM ses dosyası seçin.",
  "Не удалось прочитать аудио. Попробуйте ещё раз или загрузите файл.": "Ses okunamadı. Tekrar deneyin veya bir dosya yükleyin.",
  "Пример звучания": "Ses örneği",
  "Пример звучания пока недоступен": "Ses örneği henüz yok",
  "Превью голоса": "Ses önizlemesi",
  "Прослушать пример": "Örneği dinle",
  "Скидка {0}% на первый пакет Circle действует {1} {2} после оформления подписки": "İlk Circle paketinde %{0} indirim, abonelikten sonra {1} {2} geçerli",
  "Вы уже пришли по ссылке партнёра": "Zaten bir iş ortağının bağlantısıyla geldiniz",
  "Промокод партнёра уже применён": "Bir iş ortağı kodu zaten uygulandı",
  "Тут откроется тема чата, куда бот прислал {0}": "Burada botun sonucu gönderdiği sohbet konusu açılır: {0}",
  "можно вывести": "çekilebilir",
  "только в STEOS": "yalnızca STEOS'ta",
  "Не короче {0} знаков": "En az {0} karakter",
  "Введите почту и пароль": "E-posta ve şifreyi girin",
  "от {0} знаков": "en az {0} karakter",
  "После входа Circle станут общими для бота и аккаунта STEOS. Баланс и вывод есть и на {0}.": "Giriş yaptıktan sonra Circle'lar bot ve STEOS hesabınız için ortak olur. Bakiye ve para çekme {0} üzerinde de var.",
  "Вход или новый аккаунт": "Giriş veya yeni hesap",
  "Придумайте пароль": "Bir şifre belirleyin",
  "Ваш пароль": "Şifreniz",
  "Принимаю {0} и {1} STEOS": "STEOS {0} ve {1} kabul ediyorum",
  "согласие: условия": "koşullarını",
  "согласие: политику конфиденциальности": "gizlilik politikasını",
  "Пришлём ссылку на почту": "E-postanıza bir bağlantı göndereceğiz",
  "Откройте ссылку из письма и задайте новый пароль на {0}. Потом войдите здесь с новым паролем.": "E-postadaki bağlantıyı açın ve {0} üzerinde yeni şifre belirleyin. Sonra yeni şifreyle buradan giriş yapın.",
  "Ссылка для нового пароля ушла на {0}": "Yeni şifre bağlantısı {0} adresine gönderildi",
  "Письма нет? Проверьте папку «Спам».": "E-posta gelmedi mi? Spam klasörünü kontrol edin.",
  "Аккаунт создан и подключён": "Hesap oluşturuldu ve bağlandı",
  "Баланс бота теперь общий с аккаунтом STEOS.": "Bot bakiyesi artık STEOS hesabınızla ortak.",
  "Подтвердите почту по ссылке из письма.": "E-postanızı gelen bağlantıyla onaylayın.",
  "Вывод работает здесь и на {0}.": "Para çekme burada ve {0} üzerinde çalışır.",
  "Открыть {0}": "{0} sitesini aç",
  "Ссылка ушла на {0}. Откройте её, затем проверьте подключение здесь.": "{0} adresine bir bağlantı gönderildi. Açın, sonra bağlantıyı burada kontrol edin.",
  "Проверить подключение": "Bağlantıyı kontrol et",
  "Почти готово": "Neredeyse hazır",
  "Почта ещё не подтверждена": "E-posta henüz onaylanmadı",
  "Не удалось проверить. Попробуйте позже": "Kontrol edilemedi. Daha sonra deneyin",
  "Озвучиваю тексты голосом героя": "Metinler kahraman sesiyle",
  "Любой голос из библиотеки или свой": "Kütüphaneden herhangi bir ses ya da kendi sesiniz",
  "Озвучиваю тексты голосами героев в STEOS. Попробуйте по моей ссылке, промокод {0}": "STEOS'ta metinleri kahraman sesleriyle seslendiriyorum. Bağlantımla deneyin, promosyon kodu {0}",
  "Пишу текст, персонаж говорит": "Ben yazarım, karakter konuşur",
  "Делаю кружки с персонажами в STEOS: пишу текст, а персонаж его говорит. Промокод {0}": "STEOS'ta karakterli yuvarlak videolar yapıyorum: metni yazıyorum, karakter söylüyor. Promosyon kodu {0}",
  "Свои фото в любом образе": "Kendi fotoğraflarınız her tarzda",
  "Фотосессия в любом образе по паре моих фото, без студии. STEOS, промокод {0}": "Birkaç fotoğrafımdan her tarzda fotoğraf çekimi, stüdyosuz. STEOS, promosyon kodu {0}",
  "Вы в кадре, монтаж и музыка сами": "Siz kadrajda, kurgu ve müzik otomatik",
  "Снимаюсь в рилсах одной кнопкой в STEOS: сюжет, монтаж и музыка уже в шаблоне. Промокод {0}": "STEOS'ta tek dokunuşla Reels'te oynuyorum: senaryo, kurgu ve müzik şablonda hazır. Promosyon kodu {0}",
  "Персонаж оживает": "Karakter canlanıyor",
  "Говорит вашим текстом": "Sizin metninizi söyler",
  "Персонаж говорит моим текстом и своим голосом. Попробуйте STEOS, промокод {0}": "Karakter benim metnimi kendi sesiyle söylüyor. STEOS'u deneyin, promosyon kodu {0}",
  "Клон голоса за минуту": "Bir dakikada ses klonu",
  "Запишите от 2 секунд, дальше говорит клон": "2 saniye kaydedin, gerisini klon konuşur",
  "Клон моего голоса за минуту в STEOS: теперь он озвучивает всё сам. Промокод {0}": "STEOS'ta bir dakikada sesimin klonu: artık her şeyi o seslendiriyor. Promosyon kodu {0}",
  "Старому фото цвет и резкость": "Eski fotoğraflara renk ve netlik",
  "Восстановление за минуту": "Bir dakikada onarım",
  "Возвращаю старым фото цвет и резкость в STEOS. Промокод {0}": "STEOS'ta eski fotoğraflara rengini ve netliğini geri veriyorum. Promosyon kodu {0}",
  "По ссылке или промокоду": "Bağlantı veya promosyon koduyla",
  "Дарю +{0} C и скидку {1}% на первый пакет в STEOS по моему промокоду {2}": "{2} promosyon kodumla STEOS'ta +{0} C ve ilk pakette %{1} indirim hediye ediyorum",
  "Кавер на любую песню": "Her şarkıya cover",
  "Рок, джаз, lo-fi любым голосом": "Rock, caz, lo-fi, her sesle",
  "Кавер на любую песню любым голосом в STEOS. Промокод {0}": "STEOS'ta her şarkıya her sesle cover. Promosyon kodu {0}",
  "Мой аватар в любом образе": "Avatarım her tarzda",
  "Свой аватар из 10 фото": "10 fotoğraftan kendi avatarınız",
  "Мой аватар в любом образе: собран из 10 фото в STEOS. Промокод {0}": "Her tarzda avatarım: STEOS'ta 10 fotoğraftan yapıldı. Promosyon kodu {0}",
  "Это я, только говорю вашим текстом": "Bu benim, sadece sizin metninizi söylüyorum",
  "сторис: Мой голос": "Benim sesim",
  "на баланс сразу": "hemen bakiyeye",
  "на первый пакет Circle": "ilk Circle paketinde",
  "Сторис открыта в Telegram": "Hikâye Telegram'da açıldı",
  "Сторис готова": "Hikâye hazır",
  "Осталось нажать «Опубликовать» в редакторе Telegram": "Geriye Telegram düzenleyicisinde paylaşmak kaldı",
  "Тут откроется редактор сторис Telegram с этой картинкой и подписью": "Burada bu görsel ve açıklamayla Telegram hikâye düzenleyicisi açılır",
  "Подпись к сторис": "Hikâye açıklaması",
  "Кнопка-ссылка на сторис в Telegram есть только с Premium. Промокод на картинке видят все.": "Telegram hikâyelerinde bağlantı düğmesi yalnızca Premium ile var. Görseldeki promosyon kodunu herkes görür.",
  "Опубликовать в сторис": "Hikâyede paylaş",
  "Попробовать STEOS": "STEOS'u dene",
  "Не удалось подготовить сторис. Попробуйте ещё раз": "Hikâye hazırlanamadı. Tekrar deneyin",
  "Сторис отправляет Telegram: откройте мини-приложение в Telegram": "Hikâyeleri Telegram paylaşır: Mini App'i Telegram'da açın",
  "Ссылка и промокод уже на картинке": "Bağlantı ve promosyon kodu görselde hazır",
  "Попробуйте STEOS по моей ссылке. Промокод {0}": "STEOS'u bağlantımla dene. Promosyon kodu {0}",
  "Попробуйте STEOS по моей ссылке: +{0} C и скидка {1}% на первый пакет. Промокод {2}": "STEOS'u bağlantımla dene: +{0} C ve ilk pakette %{1} indirim. Promosyon kodu {2}",
  "Ссылка": "Bağlantı",
  "Скопировать ссылку": "Bağlantıyı kopyala",
  "Друзьям {0} и {1} на первый пакет": "Arkadaşlara {0} ve ilk pakette {1}",
  "Промокод выделен: скопируйте вручную": "Promosyon kodu seçildi: elle kopyalayın",
  "Ссылка выделена: скопируйте вручную": "Bağlantı seçildi: elle kopyalayın",
  "Ссылка скопирована": "Bağlantı kopyalandı",
  "Ссылка выделена: скопируйте её вручную": "Bağlantı seçildi: elle kopyalayın",
  "Ссылка выделена": "Bağlantı seçildi",
  "Вы пришли по приглашению": "Davetle geldiniz",
  "{0} C на баланс": "Bakiyeye {0} C",
  "Сгорят через {0} {1}": "{0} {1} içinde sona erer",
  "{0} на первый пакет Circle": "İlk Circle paketinde {0}",
  "{0} {1} после оформления подписки": "Abonelikten sonra {0} {1}",
  "Пакеты Circle можно купить с любой подпиской. Скидка начнёт действовать, как только вы её оформите.": "Circle paketleri her abonelikle alınabilir. İndirim abone olduğunuz anda başlar.",
  "Выбрать тариф": "Tarife seç",
  "QR-код ссылки приглашения, промокод {0}": "Davet bağlantısının QR kodu, promosyon kodu {0}",
  "Друг наведёт камеру и откроет бота": "Arkadaşınız kamerayı tutar ve botu açar",
  "Цвет карточки": "Kart rengi",
  "Скачать картинку": "Görseli indir",
  "Аврора": "Aurora",
  "Закат": "Gün batımı",
  "Океан": "Okyanus",
  "Графит": "Grafit",
  "Партнёры": "Ortaklar",
  "Нашёл бота, где любой персонаж скажет в кружке твой текст. Там же фото, видео и озвучка любым голосом, всё прямо в Telegram.": "Herhangi bir karakterin metnini görüntülü mesajda söylediği bir bot buldum. Fotoğraf, video ve istediğin sesle seslendirme de var, hepsi doğrudan Telegram'da.",
  "Делюсь находкой: STEOS, бот в Telegram, где я делаю кружки с персонажами, озвучку и фото. Пишете текст, выбираете голос, и через минуту готово.": "Bir keşfimi paylaşıyorum: STEOS, karakterli görüntülü mesajlar, seslendirmeler ve fotoğraflar yaptığım bir Telegram botu. Metni yazıyorsunuz, sesi seçiyorsunuz ve bir dakikada hazır.",
  "Восстанавливаю наши старые семейные фото в STEOS: за минуту возвращает цвет и резкость. Пришлите мне снимки, которые хотите обновить, или попробуйте сами.": "Eski aile fotoğraflarımızı STEOS'ta yeniliyorum: bir dakikada renk ve netlik geri geliyor. Yenilemek istediğiniz fotoğrafları bana gönderin ya da kendiniz deneyin.",
  "Кто хотел кружок голосом любимого героя? В STEOS пишешь текст, и персонаж из игры или сериала его произносит. Это бот в Telegram.": "Sevdiğin kahramanın sesiyle görüntülü mesaj isteyen var mı? STEOS'ta metni yazıyorsun, oyun ya da dizi karakteri onu söylüyor. Bu bir Telegram botu.",
  "Фото товара, карточки с преимуществами и описания для маркетплейсов делаю в STEOS за пару минут, без студии и дизайнера. Может, и вам пригодится.": "Ürün fotoğraflarını, avantaj kartlarını ve pazaryeri açıklamalarını STEOS'ta birkaç dakikada, stüdyo ve tasarımcı olmadan yapıyorum. Belki sizin de işinize yarar.",
  "Озвучиваю ролики своим клоном голоса, снимаюсь в рилсах по готовым шаблонам и записываю каверы. Всё в одном боте STEOS в Telegram.": "Videolarımı kendi ses klonumla seslendiriyorum, hazır şablonlarla reels'lerde rol alıyorum ve cover kaydediyorum. Hepsi Telegram'daki tek bir STEOS botunda.",
  "По моей ссылке +{0} C на старт.": "Bağlantımla başlangıç için +{0} C.",
  "По моей ссылке +{0} C и −{1}% на первый пакет.": "Bağlantımla: +{0} C ve ilk pakette −%{1}.",
  "Попробуй сам.": "Bir dene.",
  "Попробуйте сами.": "Kendiniz deneyin.",
  "Актёры": "Oyuncular",
  "Персонажи и актёры": "Karakterler ve oyuncular",
  "По запросу «{q}» голосов нет. Попробуйте другое слово или загляните в подборки": "“{q}” için ses yok. Başka bir kelime deneyin ya da koleksiyonlara göz atın",
  "Здесь пока нет голосов. Загляните в другие вкладки или подборки": "Burada henüz ses yok. Diğer sekmelere veya koleksiyonlara göz atın",
  "Голос вернётся на экран создания": "Ses oluşturma ekranına döner",
  "После выбора пишите текст для озвучки в чат бота": "Sonra seslendirilecek metni bot sohbetine yazın",
  "От Я до А": "Z'den A'ya",
  "Сортировка и фильтры": "Sıralama ve filtreler",
  "Сбросить": "Sıfırla",
  "Чаще всего выбирают": "En çok seçilenler",
  "Сначала свежие": "Önce en yeniler",
  "Сначала давние": "Önce en eskiler",
  "Сначала недорогие": "Önce en ucuzlar",
  "Сначала короткие ролики": "Önce kısa videolar",
  "По названию": "Ada göre",
  "По названию, с конца алфавита": "Ada göre, alfabenin sonundan",
  "Вертикальные ролики": "Dikey videolar",
  "Картинки и посты": "Görseller ve gönderiler",
  "Горизонтальные ролики": "Yatay videolar",
  "Видеосообщения Telegram": "Telegram görüntülü mesajları",
  "Один человек в кадре": "Karede bir kişi",
  "Трое и больше": "Üç veya daha fazla",
  "С ребёнком": "Çocukla",
  "С питомцем": "Evcil hayvanla",
  "Двое человек в кадре": "Karede iki kişi",
  "О разделе": "Hakkında",
  "Превращает текст в речь: голос из каталога или ваш клон, настройки интонации и скорости.": "Metni sese dönüştürür: katalogdan bir ses veya klonunuz, tonlama ve hız ayarlarıyla.",
  "Копия вашего голоса по записи: ею можно озвучивать любые тексты.": "Bir kayıttan yapılmış sesinizin kopyası: onunla her metni seslendirebilirsiniz.",
  "AI-студия: ролики, фото, кружки и другие шаблоны с вами, близкими и персонажами.": "Yapay zekâ stüdyosu: sizinle, sevdiklerinizle ve karakterlerle videolar, fotoğraflar, daireler ve diğer şablonlar.",
  "Кредиты (C) на счёте и пополнение. Кредиты списываются за озвучку и заказы студии.": "Hesaptaki krediler (C) ve yükleme. Krediler seslendirme ve stüdyo siparişleri için harcanır.",
  "Задания и награды: выполняйте задания и получайте кредиты.": "Görevler ve ödüller: görevleri tamamlayın ve kredi kazanın.",
  "Все ваши озвучки и заказы студии: послушать, скачать или повторить.": "Tüm seslendirmeleriniz ve stüdyo siparişleriniz: dinleyin, indirin veya tekrarlayın.",
  "Ваш профиль и данные аккаунта.": "Profiliniz ve hesap bilgileriniz.",
  "Настройки приложения: язык, валюта и уведомления.": "Uygulama ayarları: dil, para birimi ve bildirimler.",
  "Ответы на частые вопросы и связь с поддержкой.": "Sık sorulan soruların yanıtları ve destekle iletişim.",
  "Партнёрская программа: приглашайте друзей и получайте процент с их пополнений.": "Ortaklık programı: arkadaşlarınızı davet edin ve yüklemelerinden yüzde alın.",
  "Озвучка больших текстов и сценариев по ролям.": "Uzun metinlerin ve senaryoların rollere göre seslendirilmesi.",
  "Вы или один близкий": "Siz veya bir yakınınız",
  "Вы и близкий": "Siz ve bir yakınınız",
  "Товары и места": "Ürünler ve mekânlar",
  "Фото товара, блюда или места": "Ürün, yemek veya mekân fotoğrafı",
  "В избранном": "Favorilerde",
  "Голоса и персонажи, которые вы отметили сердцем": "Kalple işaretlediğiniz sesler ve karakterler",
  "Нажмите — выбрать голос": "Ses seçmek için dokunun",
  "Удерживайте — карточка голоса": "Ses kartı için basılı tutun",
  "Карточка голоса или персонажа": "Ses veya karakter kartı",
  "Нажмите на голос, чтобы выбрать его": "Seçmek için bir sese dokunun",
  "Удерживайте, чтобы открыть карточку голоса": "Ses kartını açmak için basılı tutun",
  "Удаление голоса": "Sesi silme",
  "Подсказка": "İpucu",
  "Пример звучания пока недоступен. Попробуйте позже.": "Örnek henüz kullanılamıyor. Daha sonra tekrar deneyin.",
  "Языков: {0}": "Diller: {0}",
  "Ещё языков: {0}": "Diğer diller: {0}",
  "Ход примера": "Örnek ilerlemesi",
  "Голос говорит на {0} языках": "Ses {0} dil konuşuyor",
  "Все голоса мультиязычные и озвучат текст на любом языке системы.": "Tüm sesler çok dillidir ve metni sistemin desteklediği her dilde seslendirir.",
  "Голоса подборки": "Koleksiyondaki sesler",
  "Удерживайте голос, чтобы открыть его": "Açmak için bir sese basılı tutun",
  "Назад к голосу": "Sese dön",
  "Оригинал голоса говорил на {0} языке": "Sesin aslı {0} konuşuyordu",
  "Происхождение: {0}. Подробнее": "Köken: {0}. Ayrıntılar",
  "Новый": "Yeni",
  "Официальный": "Resmi",
  "Актёр": "Oyuncu",
  "Удерживайте, чтобы послушать": "Dinlemek için basılı tutun",
  "Удерживайте строку голоса или нажмите её правой кнопкой мыши, чтобы открыть карточку голоса. Персонаж открывается обычным нажатием.": "Ses kartını açmak için ses satırına basılı tutun veya sağ tıklayın. Karakter normal dokunuşla açılır.",
  "Подборка · Голосов: {0}": "Koleksiyon · Ses: {0}",
  "Доступные голоса появятся в каталоге. Здесь можно будет прослушать пример и выбрать голос для бота.": "Kullanılabilir sesler katalogda görünecek. Burada bir örnek dinleyip bot için ses seçebilirsiniz.",
  "Зажмите голос": "Bir sese basılı tutun",
  "Удерживайте строку голоса, чтобы открыть его карточку: прослушать и посмотреть подборки. Короткое нажатие выбирает голос.": "Kartını açmak için ses satırına basılı tutun: dinleyin ve koleksiyonlarını görün. Kısa dokunuş sesi seçer.",
  "Нажмите на аватарку": "Avatara dokunun",
  "Круглая аватарка в строке проигрывает пример голоса. Нажмите ещё раз, чтобы остановить. Нажатие на саму строку выбирает голос.": "Satırdaki yuvarlak avatar ses örneğini çalar. Durdurmak için tekrar dokunun. Satırın kendisine dokunmak sesi seçer.",
  "Сохраняйте в избранное": "Favorilere kaydedin",
  "Нажмите сердце в карточке голоса или персонажа — они соберутся в подборке «Избранное», первой в «Подборках» и на «Рекомендуем». Нажмите ещё раз, чтобы убрать.": "Ses veya karakter kartındaki kalbe dokunun — “Favoriler” koleksiyonunda toplanırlar; bu koleksiyon “Koleksiyonlar” ve “Önerilen” içinde ilk sıradadır. Kaldırmak için tekrar dokunun.",
  "Запишите свой голос": "Sesinizi kaydedin",
  "30 секунд речи или пара файлов, и через две минуты ваш голос появится во всех инструментах с озвучкой. Нажмите «Записать» и читайте текст с экрана.": "30 saniyelik konuşma veya birkaç dosya; iki dakika içinde sesiniz seslendirme yapan tüm araçlarda görünür. “Kaydet”e dokunun ve ekrandaki metni okuyun.",
  "Читать полностью": "Devamını oku",
  "Голос STEOS": "STEOS sesi",
  "Назад к персонажу": "Karaktere dön",
  "Назад к списку": "Listeye dön",
  "Актёр STEOS": "STEOS oyuncusu",
  "Персонаж STEOS": "STEOS karakteri",
  "Об актёре": "Oyuncu hakkında",
  "О персонаже": "Karakter hakkında",
  "Голоса актёра": "Oyuncunun sesleri",
  "Голоса персонажа": "Karakterin sesleri",
  "шапка: Мой голос": "Sesim",
  "Пример голоса «{0}»": "“{0}” ses örneği",
  "Ещё языки": "Diğer diller",
  "Юзеры": "Kullanıcılar",
  "Лайки": "Beğeniler",
  "Пол": "Cinsiyet",
  "В каталоге с": "Katalogda şu tarihten beri",
  "Автор": "Yazar",
  "Откуда": "Nereden",
  "Характер": "Kişilik",
  "Голосов": "Ses sayısı",
  "Мужской": "Erkek",
  "Женский": "Kadın",
  "Детский": "Çocuk",
  "Не указан": "Belirtilmemiş",
  "Голос персонажа": "Karakter sesi",
  "Выберите поддерживаемый аудиофайл до {0} МБ.": "{0} MB’a kadar desteklenen bir ses dosyası seçin.",
  "пол: Детский": "Çocuk",
  "Состав подборки": "Koleksiyon içeriği",
  "Закрыть выбор голоса": "Ses seçimini kapat",
  "Не удалось открыть запись для прослушивания.": "Kayıt dinlemek için açılamadı.",
  "Использовать готовую запись": "Hazır kaydı kullan",
  "Подтвердите права на материалы, чтобы взять запись.": "Kaydı kullanmak için materyallerin haklarını onaylayın.",
  "Работа из доната": "Bağıştan gelen iş",
  "Модель синтеза": "Sentez modeli",
  "Новая модель": "Yeni model",
  "Прежняя модель": "Önceki model",
  "Удерживайте — карточка голоса и модель синтеза": "Basılı tutun: ses kartı ve sentez modeli",
  "Модель для озвучки в чате": "Sohbette seslendirme modeli",
  "Новая модель: эмоции и живая интонация, вопросы, много языков, клоны голоса": "Yeni model: duygular ve doğal tonlama, sorular, birçok dil, ses klonları",
  "Прежняя модель: только пять языков, без эмоций и вопросительной интонации, без клонов": "Önceki model: yalnızca beş dil, duygu ve soru tonlaması yok, klon yok",
  "Активная модель: STEOS Voice": "Etkin model: STEOS Voice",
  "Активная модель:": "Etkin model:",
  "Новая модель: 19 языков, естественное звучание с живыми интонациями — без металла и роботизированности, качественное клонирование голоса": "Yeni model: 19 dil, canlı tonlamalarla doğal ses — metalik ve robotik tını yok, kaliteli ses klonlama",
  "Прежняя модель: только 5 языков, без эмоций и вопросительной интонации, без клонов голоса": "Önceki model: yalnızca 5 dil, duygu ve soru tonlaması yok, ses klonu yok",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из этих языков.": "STEOS Voice {0} modelinde tüm sesler çok dillidir ve metni bu dillerin herhangi birinde seslendirir.",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из {1}.": "STEOS Voice {0} modelinde tüm sesler çok dillidir ve metni {1} herhangi birinde seslendirir.",
  "этих языков": "bu dillerin",
  "Языки озвучки": "Seslendirme dilleri",
  "Любой голос на модели STEOS Voice {0} озвучит текст на каждом из этих языков": "STEOS Voice {0} modelindeki her ses metni bu dillerin her birinde seslendirir",
  "Все голоса": "Tüm sesler",
  "Озвучка текста и переозвучка": "Metin seslendirme ve ses değiştirme",
  "Переозвучка записи": "Kayıtta ses değiştirme",
  "Меняют голос в вашей записи": "Kaydınızdaki sesi değiştirir",
  "Выберите голос для переозвучки записи": "Kaydınızdaki sesi değiştirmek için bir ses seçin",
  "Голос выбран — вернитесь в чат и нажмите «Продолжить переозвучку»": "Ses seçildi — sohbete dönün ve «Ses değiştirmeye devam et» düğmesine dokunun"
}
